/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source:    web_frontend/src/lang/en.js
 * Generator: packages/lang-gen (pnpm gen:lang)
 */

export default {
  common: {
    skipToMain: 'Skip to main content',
    yes: 'Yes',
    no: 'No',
    click: 'Click here',
    retry: 'Retry',
    failedToLoad: 'Failed to load.',
    error: 'Error',
    noPermission: 'You don\'t have permission for this operation.',
    staleData: 'Showing earlier results — the latest refresh failed.',
    copy: 'Copy',
    copied: 'Copied',
    learnMore: 'Learn more',
    lastStep: 'Back',
    next: 'Next',
    cancel: 'Cancel',
    confirm: 'Confirm',
    unlock: 'Unlock',
    ok: 'OK',
    refreshSuccess: 'Refresh succeeded.',
    refreshFailed: 'Refresh failed.',
    pleaseSelect: 'Please select',
    manage: 'Manage',
    goHome: 'Return to Homepage',
    create: 'Create',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    email: 'Email address',
    name: 'Name',
    lastLogin: 'Last Login',
    resetPassword: 'Reset password',
    removeUser: 'Remove member',
    reset: 'Reset',
    insType: 'Instance type',
    cpu: 'CPU',
    memory: 'Memory',
    storageType: 'Storage type',
    subscribe: 'Subscribe',
    freeTrial: 'Free Trial',
    free: 'Free',
    freeTier: 'Free Developer Tier',
    unit: 'Unit',
    lastminutes: '{val} minutes',
    lasthour: '1 hour',
    lasthours: '{val} hours',
    lastdays: '{val} days',
    lastweek: '1 week',
    lastweeks: '{val} weeks',
    lastmonth: '1 month',
    lastmonths: '{val} months',
    minutes: 'minutes',
    hours: 'hours',
    seconds: 'seconds',
    refresh: 'Refresh',
    millisecond: 'ms',
    cluster: 'Cluster',
    range: 'Date range',
    form: 'Form',
    clusters: 'Clusters',
    notActive: 'Not Active',
    member: 'Member',
    account: 'Account',
    detail: 'Details',
    remove: 'Remove',
    invite: 'Invite',
    or: 'or',
    cores: 'Cores',
    gb: 'GB',
    storage: 'Storage',
    step: 'Step',
    Step: 'STEP',
    noData: 'No Data',
    status: 'Status',
    edit: 'Edit',
    delete: 'Delete',
    current: 'Current',
    node: 'Node',
    before: 'before',
    after: 'after',
    storageSize: 'Storage size',
    empty: 'empty',
    priceUnit: 'CCU',
    priceUnitS: 'CCU(s)',
    moneyUnit: '$',
    del: 'Delete',
    confirmDel: 'Confirm to delete? ',
    testConnect: 'Test connect',
    failed: 'Failed',
    serverError: 'Server Error',
    random: 'Random',
    filter: 'filter',
    applyFilter: 'Apply filter',
    finish: 'Finish',
    download: 'Download',
    start: 'Start',
    startCreate: 'Start create',
    stopCluster: 'Stop Cluster',
    startCluster: 'Start Cluster',
    management: 'Access Control',
    role: 'Role',
    creator: 'Created by',
    createdAt: 'Created At',
    desc: 'Description',
    add: 'Add',
    save: 'Save',
    saveChanges: 'Save changes',
    submit: 'Submit',
    advanceSettings: 'Advanced Settings',
    contactCelerData: 'Contact PhoenixAI',
    suspend: 'Suspend',
    resume: 'Resume',
    suspendCluster: 'Suspend cluster',
    resumeCluster: 'Resume cluster',
    cancelResume: 'Cancel Resume',
    operationSucceeded: 'Operation succeeded',
    operationFailed: 'Operation failed',
    operationStateSucceeded: 'Operation succeeded, please wait for the state to change.',
    back: 'Back',
    action: 'Action',
    enable: 'Enable',
    disable: 'Disable',
    enabled: 'Enabled',
    disabled: 'Disabled',
    beta: 'Beta',
    key: 'Key',
    value: 'Value',
    close: 'Close',
    unassign: 'Unassign',
    assign: 'Assign',
    supportMail: 'cloud-support{\'@\'}celerdata.com',
    reload: 'Reload',
    apply: 'Apply',
    clusterShouldBeRunning: 'Sorry, only running clusters can perform this operation.',
    on: 'ON',
    off: 'OFF',
    pleaseEnter: 'Please enter',
    pleaseChoose: 'Please choose',
    datePicker: {
      today: 'Today',
      yesterday: 'Yesterday',
      last3Days: 'Last 3 days',
      last7Days: 'Last 7 days',
      lastMonth: 'Last month',
    },
    copySucceeded: 'Copy succeeded.',
    copyFailed: 'Copy failed.',
    selectPlaceholder: 'Please select',
    selectDayOfMonth: 'Select day of month',
    selectDaysOfMonth: 'Select days of month',
    operation: 'Operation',
    source: 'Source',
    time: 'Time',
    timestamp: 'Timestamp',
    actions: 'Actions',
    enterPlaceHolder: 'Please enter',
    unknownErr: 'Unknown Error',
    seeMore: 'See more',
    nameValidate: 'The name must start with a letter, and can only contain letters, numbers and \'_\' . The maximum length is {len}.',
    awsNameValidate: 'The name must start with a letter, and can only contain letters, numbers, underscores, and hyphens. The maximum length is {len}.',
    gcpStartEndValid: '{0} must start and end with a lowercase letter or number.',
    gcpNameValidate: 'The {0} must start and end with a lowercase letter or number, and can only include lowercase letters (a-z), numbers, and hyphens. The maximum length is {len}.',
    gcpWhNameValidate: 'The {0} must start with a lowercase letter, and can only include lowercase letters (a-z), numbers and \'_\'. The maximum length is {len}.',
    update: 'Update',
    showMore: 'Show more',
    show: 'Show',
    hide: 'Hide',
    expand: 'Expand',
    collapse: 'Collapse',
    awsPrivateLink: 'PrivateLink',
    azurePrivateLink: 'PrivateLink',
    gcpPrivateLink: 'Private Service Connect',
    outdated: 'Outdated',
    warehouse: 'Warehouse',
    changeItem: 'Change Item',
    initialValue: 'Initial Value',
    afterValue: 'After Value',
    mb: 'MB/s',
    condition: 'Condition',
    equalTo: 'equal to',
    lessThan: 'less than',
    greaterThan: 'greater than',
    below: 'below',
    above: 'above',
    policy: 'Policy',
    accountName: 'Account name',
    accountID: 'Account ID',
    startedAt: 'Started At',
    endedAt: 'Ended At',
    nodeSingular: 'node',
    nodePlural: 'nodes',
    groupSingular: 'group',
    groupPlural: 'groups',
    azs: 'Availability zones',
    timeZone: 'Time zone',
    storagePath: 'Storage Path',
    restore: 'Restore',
    backup: 'Backup',
    comment: 'Comment',
    isEnabled: 'Is Enabled',
    type: 'Type',
    operationStateLimitTips: 'This operation is supported only when the cluster is running',
    supportedOnlyWhenClusterRunning: 'This operation is supported only when the cluster is running',
    operationWarehouseStateLimitTips: 'This operation is supported only when the warehouse is running',
    supportedOnlyWhenClusterAndWarehousesRunning: 'This operation is supported only when the cluster and warehouses are running',
    updateSuccess: 'Updated successfully',
    deleteFailed: 'Delete Failed',
    recommended: 'Recommended',
    noMatch: 'No match found',
    noMatchDesc: 'Try different keywords or check spelling.',
    unknown: 'Unknown',
  },
  profile: {
    title: 'My profile',
    name: 'Your name',
    email: 'Your email',
    loginTime: 'Last login time',
  },
  docs: {
    connect: 'Connect from a client application to PhoenixAI Cloud',
    release: 'Release a PhoenixAI cluster',
    sign: 'Sign up or sign in to PhoenixAI Cloud',
    quickstart: 'Quickstart',
    loadDataFromS3: 'Batch load data from Amazon S3',
    loadDataFromAzure: 'Batch load data from Azure cloud storage',
    loadDataFromGCP: 'Batch load data from GCP Cloud Storage',
    authToGCP: 'Authenticate to Google Cloud Storage',
    idle_suspend: 'Suspend and resume a PhoenixAI cluster',
    enableAutomatedSnapshot: 'Enable Automated Cluster Snapshot',
    restoreFromSnapshot: 'Restore From Cluster Snapshot',
  },
  form: {
    itemError: 'Please enter the correct value',
    itemErrorWithLabel: 'Please enter the {label}',
    mailError: 'You have entered an incorrect email format.',
    unsupportMail: 'Email contains unsupported characters',
    invalidPasswordSet: 'The password is required and should be between 8 and 16 characters in length. It is a mix of letters, numbers, and symbols. The symbols we now support are !{\'@\'}#$%^&*_',
    passwordRule: '8-16 characters, including letters, digits, and one of {chars}',
    accountExist: 'Account exists',
    nameExist: 'Name exists',
    accountNotExist: 'Account does not exist',
    error: 'Error',
    invalidPassword: 'Login failed: Invalid account or password.',
    confirmPassword: 'Please check your password',
    nameRequired: '{0} is required.',
  },
  layout: {
    docs: 'Help document',
    name: 'PhoenixAI Cloud',
    account: 'Account: ',
    menu: {
      cluster: 'Clusters',
      setting: 'Account settings',
      member: 'Members',
      billing: 'Usage and billing',
      cloud: 'Cloud settings',
      aws: 'AWS',
      azure: 'Azure',
      gcp: 'GCP',
      account: 'Account',
      auditLog: 'Audit log',
      management: 'Access control',
      role: 'Roles',
      alarm: 'Alert',
      appKey: 'Application keys',
      integration: 'Integration Hub',
      organization: 'Account management',
      support: 'Support',
    },
    logout: 'Sign out',
    modal: {
      title: 'Sign out of PhoenixAI Cloud? ',
    },
  },
  member: {
    admin: 'account creator',
    you: 'you',
    searchPlaceholder: 'Search the members',
    memberMatched: 'member(s) matched',
    selectRolePlaceholder: 'Please select role',
    detailTitle: 'Member\'s Details',
    confirmRemove: 'This action will remove the member from your PhoenixAI Cloud account.',
    confirmTitle: 'Are you sure that you want to remove the member?',
    resetTitle: 'Reset password',
    resetDesc: 'After you reset the password, the old password becomes invalid and a link is sent to your email address. You can click the link to specify a new password.',
    resetDescEmail: 'After you reset the password, the old password becomes invalid and a link is sent to {0}. You can click the link to specify a new password.',
    resetSent: 'A password reset link has been sent to {0}.',
    removeTips: 'This action will remove the member from your PhoenixAI Cloud account.',
    removeServiceAccountTips: 'This action will remove the service account from your PhoenixAI Cloud account.',
    accountExist: 'Email exists in this account.',
    roleNameLimit: 'Role name must be 1-32 characters',
    detail: 'Member details',
    assignNewRole: 'Assign new role',
    roleSelectPlaceholder: 'Please select one role',
    viewPrivileges: 'View current privileges',
    roleName: 'Role Name',
    privilegeName: 'Privilege name',
    allPrivileges: 'All privileges of',
    unassignRoleTitle: 'Unassign role {0}',
    unassignRoleContent: 'All the privileges of this role will be revoked from the member. Confirm to unassign the {0} from the member {1}.',
    accountMembers: 'Account members',
    serviceAccounts: 'Service accounts',
    mfa: 'MFA',
    mfaOn: 'Enabled',
    mfaOff: 'Not enabled',
    resetMfa: 'Reset MFA',
    resetMfaTitle: 'Reset MFA for {0}',
    resetMfaTips: 'Clears this user’s MFA setup. They will be required to configure MFA again at their next sign-in. Use this when a user has lost access to their authenticator device.',
    resetMfaConfirm: 'Reset MFA',
  },
  signUp: {
    exist: 'This email has already been occupied in another PhoenixAI account!',
    clickTwice: 'Do not click on the verification email repeatedly.',
    privacy: 'By continuing, you agree to the {0} or other agreement for PhoenixAI services, and the {1}. This site uses essential cookies. See our {2} for more information.',
    terms: 'Terms of Service',
    statement: 'Privacy Statement',
    cookie: 'Cookie Policy',
    invitePassword: 'Set up a new password ',
    invitePasswordTips: 'Set up a new password for {0} in PhoenixAI account',
    awsTips: 'Subscription linking in progress',
    notBizEmail: 'Please use your business email',
    toSignUp1: 'Want to have your own account? ',
    toSignUp2: 'Sign up',
    signInNew: 'Sign in with a new account.',
    chooseAccount: 'Choose already signed-in account',
    freezeTitle: 'Your account has been deactivated. ',
    freezeDesc: 'Your account has been deactivated due to a policy violation or inactivity. To regain access, please contact our support team for assistance at {0}',
    mpUnsubscribeFreezeDesc: 'The account you are now logging into was created through {0} Marketplace subscription. Since you have canceled your subscription, the account is unavailable. You can sign up again through {1} or re-subscribe through {2} Marketplace.',
    title: 'Sign up for PhoenixAI Cloud',
    welcom: 'Welcome to PhoenixAI Cloud',
    welcomTip: 'Choose an account to sign in',
    welcomInput: 'Enter your account ID to continue.',
    passwordTitle: 'Create password',
    passwordTitleTip: 'Enter the password to use for the new account.',
    create: 'Create an account',
    noPassword: 'User has no password ',
    noPasswordTip: 'User has no password. Please check your email and finish the process, or {0} to resend the email.',
    sendOK: 'Check your email',
    sendOKTip: 'If an account exists for that address, an email has been sent. Please check your inbox and finish the process.',
    sendForgetAccountOKTip: 'If your account exists in PhoenixAI, you will get an email. Please check the account information in it.',
    sendForgetPasswordOK: 'Check your email',
    sendForgetPasswordOKTip: 'If an account exists for {0}, a link has been sent. Click it to set the password for your PhoenixAI Cloud account.',
    resetPassword: 'Reset Password',
    resetPasswordTip: 'Reset account password for ',
    createTip: 'Enter an account name and remember the account ID, which will be used to verify your identity during each login.',
    choose: 'Choose an account to sign in.',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Business Email',
    company: 'Company',
    country: 'Country/Region',
    state: 'State',
    alreadyHaveOne: 'Already have an account? ',
    signIn: 'Sign in.',
    otherAccount: 'Sign in with a new account.',
    success: 'Check your email and start the trial!',
    checkSignupMail: 'You will receive a confirmation email shortly. Please click the confirmation link to activate this PhoenixAI cloud account and finish the sign-up process.',
    checkMail: 'An email has been sent to you. Please check and finish the account activation process.',
    setAccountName: 'An activation link has been sent to your email. Please click it to activate your PhoenixAI cloud account and finish the sign-up process.',
    blockTitle: 'Please contact the PhoenixAI Cloud Support Team',
    blockTips: 'Your account has been locked by the PhoenixAI Cloud Support team. Please contact us to unlock',
  },
  invite: {
    title: 'Invite member',
    defaultRole: 'Default role',
    sendEmailTips: 'Your invitation has been sent successfully.',
    confirmRemove: 'Confirm to remove the user {0}?',
    confirmRemoveServiceAccoutn: 'Confirm to remove the service account {0}?',
  },
  reSignin: {
    title: 'Please sign in again',
    desc: 'Login has timed out, please log in again.',
  },
  mcpAuthorize: {
    pageTitle: 'Authorize MCP access',
    invalidServerTitle: 'Invalid MCP server',
    invalidServerDesc: 'The redirect URL is not a recognized PhoenixAI MCP server. This request will not be completed.',
    consentIntro: 'An MCP client is requesting access to your PhoenixAI Cloud account through:',
    consentSignedInAs: 'Signed in as:',
    consentPermsIntro: 'This will allow the MCP client to:',
    consentPermList_listClusters: 'List your clusters',
    consentPermList_executeSql: 'Query data from your clusters',
    consentAuthorizeBtn: 'Authorize',
    mcpDisabledTitle: 'MCP Server is not enabled',
    mcpDisabledAdminBody: 'MCP Server is not enabled in your account. Please enable it under Account Settings → Advanced Settings.',
    mcpDisabledAdminBtn: 'Go to Account Settings',
    mcpDisabledNoPermBody: 'MCP Server is not enabled in your account. Please reach out to your account admin to enable it under Account Settings → Advanced Settings.',
    mcpDisabledDocsLink: 'Learn more',
  },
  request: {
    tooManyRequests: 'Too many requests. Please try again later.',
    recentRequest: 'You have recently submitted a request to {mode}. Please try again later.',
    code429Mode: {
      signUpAccount: 'register your account',
      resetPassword: 'reset your password',
      findAccount: 'retrieve your account',
    },
  },
  signIn: {
    account: 'Account Name',
    accountIdNotEmail: 'Account ID (Not Email)',
    accountIdNotEmailTip: 'Please enter your account ID, not your email.',
    accountId: 'Account ID',
    accountIdNotFound: 'Account ID not found',
    invalidCredentials: 'Invalid email or password. If you haven\'t set a password yet, use the link in your activation email or click "Forgot / set password".',
    title: 'Sign in with your PhoenixAI account',
    name: 'Username',
    password: 'Password',
    titleTip: ' ',
    alreadyExist: 'The account you choose is already signed in.',
    signinTitle: 'Sign up for PhoenixAI Cloud',
    subTitle: 'Enter your PhoenixAI Cloud User information',
    email: 'Business email',
    pwd: 'Password',
    forgotPwd: 'Forgot the password?',
    signin: 'Sign in',
    tips: 'Don\'t have an account? ',
    click: 'click here',
    tipsEnd: ' to sign up.',
    continue: 'Continue',
    ssoLogin: 'Continue with SSO ({0})',
    ssoLoginErr: 'Login failed: SSO login failed, please contact your account admin for help',
    ssoAdminLoginErr: 'Login failed: SSO is not allowed for account admin',
    ssoRedirectFailed: 'SSO sign-in failed.',
    ssoBackToContinue: 'Back to sign in',
    ssoNotAllowed: 'Login failed: this PhoenixAI Cloud account has SSO enabled and password login is disabled. Please contact your cloud account administrator for help.',
    registrationPage: 'the PhoenixAI registration page',
    newPasswordSuccess: 'New password set successfully.',
    enterUserInfo: 'Enter user information for your Account:',
    loginWithSSO: 'Login with SSO',
    loginWithEmailPassword: 'Login with email and password',
    forgotPassword: 'Forgot / set password?',
    forgotAccountId: 'Forgot your account ID?',
    forgetAccountDesc: 'Enter your email here. If your email exists in PhoenixAI Cloud, we will send all related PhoenixAI Cloud Accounts to your email.',
    forgetPasswordDesc: 'Enter your email here. We will send the password reset verification link to you if your email exists in this PhoenixAI.',
    forgetAccount: 'Forgot account ID',
    forgetPassword: 'Forgot password',
    accountLabel: 'Account:',
    businessEmailLabel: 'Business Email:',
    goLogin: 'Go Login',
    userInfoError: 'There was an issue with the user information, please try again',
    activationLinkResent: 'If an account exists, an activation email has been sent.',
    freeTrial: {
      title: 'PhoenixAI Cloud',
      titleSignup: 'Start your free trial of PhoenixAI Cloud today. No credit card required.',
      desc: 'Enjoy PhoenixAI Cloud on the world’s most popular cloud lakehouse analytics platforms. Grow your business with 3X greater analytics performance and up to 80% lower operating costs.',
      descSignup: 'During your 30-day free trial period, you can deploy as many resources or clusters as you need. At the end of your trial period, you have the option to:',
      option1: 'Accelerated time-to-insight',
      option1Signup: 'Add a credit card to your account to continue using PhoenixAI Cloud services.',
      option2: 'Enhanced cost-effectiveness',
      option2Signup: 'Suspend your clusters and resume your clusters when you are ready to purchase.',
      option3: 'Lowered IT overhead',
      option3Signup: 'Scale your usage to the Free Developer Tier level. Learn more about {0} here.',
      option4: 'Security you can count on',
      option4Signup: 'Release your clusters. This will also release all the deployed cloud resources.',
      freeTierLink: 'the Free Developer Tier',
    },
  },
  reset: {
    title: 'Reset your PhoenixAI Cloud Account Password',
    subtitle: 'Enter your email address and we will send you a link to reset the password',
    email: 'Your business email',
    newPwd: 'New Password',
    confirmPwd: 'Confirm the Password',
    reset: 'Reset',
    back: 'Back to sign in',
  },
  infoModal: {
    reset: 'Your Password has been reset successfully!',
    resetClickEnd: 'to sign in now.',
    active: 'Your Account has been activated successfully!',
    activeClick: 'Start data analytics on your PhoenixAI Cloud?',
    activeClickEnd: ' to sign in now.',
    notActive: 'This user hasn’t been activated.',
    notActiveDesc: 'To activate the account, check your email and finish the signup process. If you didn’t receive the email, you can {0} to resend the activation email.',
    checkMail: 'Sign up successfully!',
    checkMailDesc: 'An activation email has been sent to your email. Please check and finish the account activation process. Or {0} to sign in.',
    checkResend: 'Send Mail successfully!',
    checkResendDesc: 'The email has been sent. Please check and finish the password reset process. Or {0} to sign in.',
    checkFailed: 'Something is wrong.',
    checkFailedDesc: 'Please check your email and open the right {type} link.',
  },
  mfa: {
    verifyTitle: 'Multi-factor authentication',
    verifyDesc: 'Enter the 6-digit code from your authenticator app to continue.',
    codeLabel: 'Authentication code',
    codePlaceholder: '6-digit code',
    recoveryDesc: 'Enter one of your saved recovery codes.',
    recoveryLabel: 'Recovery code',
    recoveryPlaceholder: 'Recovery code',
    useRecovery: 'Use a recovery code',
    useAuthenticator: 'Use your authenticator app',
    verify: 'Verify',
    rememberDevice: 'Remember this device for 30 days',
    lostDevice: 'Lost your device? Contact your account admin.',
    invalidCode: 'Invalid code. Please try again.',
    sessionExpired: 'Your verification session has expired. Please sign in again.',
    genericError: 'Verification failed. Please try again.',
    setupTitle: 'Set up multi-factor authentication',
    setupSubtitle: 'Your account requires multi-factor authentication (MFA). This keeps your access secure even if your password is compromised.',
    stepAuthenticator: 'Authenticator',
    stepRecoveryCodes: 'Recovery codes',
    enrollScanTitle: 'Scan this QR code',
    enrollScanHint: 'Open Google Authenticator, Microsoft Authenticator, Okta Verify, or Authy and scan:',
    enrollCodeTitle: 'Enter the 6-digit code',
    enrollKeyHint: 'Compatible with any TOTP authenticator app.',
    cantScan: 'Can’t scan? Enter this key manually',
    copySecret: 'Copy',
    secretCopied: 'Setup key copied',
    enable: 'Verify & continue',
    setupError: 'Could not start setup. Please try again.',
    passwordTitle: 'Confirm your password',
    passwordDesc: 'Enter your account password to continue setting up multi-factor authentication.',
    passwordPlaceholder: 'Enter your password',
    passwordIncorrect: 'Incorrect password. Please try again.',
    backupTitle: 'Save your recovery codes',
    backupDesc: 'Store these somewhere safe. Each code can be used once to sign in if you lose access to your authenticator.',
    copyCodes: 'Copy codes',
    codesCopied: 'Recovery codes copied',
    downloadCodes: 'Download codes',
    regenerate: 'Regenerate',
    regenerateDesc: 'Enter a current authentication code to generate a new set of recovery codes. Your existing codes will stop working.',
    codesRegenerated: 'New recovery codes generated',
    savedConfirm: 'I have saved my recovery codes in a safe place',
    finishEnrollment: 'Finish enrollment',
    done: 'Done',
    settingsTitle: 'Multi-factor authentication methods',
    settingsDesc: 'Add an extra layer of security by requiring a code from an authenticator app when you sign in.',
    authenticatorApp: 'Authenticator app',
    authenticatorDesc: 'Use an authentication app or browser extension to get multi-factor authentication (MFA) codes when prompted.',
    recoveryCodesTitle: 'Recovery codes',
    recoveryCodesDesc: 'Recovery codes can be used to access your account in the event you lose access to your device and cannot receive MFA codes.',
    configured: 'Configured',
    enforcedNote: 'Your account requires multi-factor authentication (MFA), so it cannot be turned off.',
    enableCta: 'Enable',
    disableCta: 'Disable',
    cancel: 'Cancel',
    disableTitle: 'Turn off multi-factor authentication',
    disableDesc: 'Enter a current authentication code from your app to confirm.',
    disableConfirm: 'Turn off',
    enableSuccess: 'Multi-factor authentication enabled',
    disableSuccess: 'Multi-factor authentication turned off',
    statusError: 'Could not load your MFA status.',
    nav: 'Security',
  },
  account: {
    title: 'Enter your PhoenixAI Cloud Account',
    choose: 'Choose your PhoenixAI Cloud\'s Account ',
    placeholder: 'Enter your account name here',
    tips: 'Don\'t have a PhoenixAI Cloud account?',
    tipsEnd: ' to sign up',
    chooseAccount: 'please choose the account',
    setting: {
      title: 'Account settings',
      member: 'Members',
      auditLog: 'Audit Log',
      config: {
        title: 'General configuration',
        name: 'Account name',
        id: 'Account ID',
        time: 'Created at',
        creator: 'Created by',
        email: 'Email address',
      },
    },
    advance: {
      title: 'Advanced settings',
      strict_mode: 'Strict Mode',
      strict_mode_desc: 'When strict mode is enabled, accessing the cluster through the Open cluster in the PhoenixAI Cloud console is not possible. Additionally, all query context will remain within your managed VPC and will not be routed through our VPC.',
      disable_editor: 'Disable SQL Editor',
      disable_editor_desc: 'When you disable the SQL Editor, the PhoenixAI SQL Editor for the entire account will become unavailable. As a result, you will only be able to connect to the PhoenixAI cluster using your own SQL client and cannot utilize the built-in SQL Editor provided by PhoenixAI.',
      ai_assistant: 'AI Assistant',
      ai_assistant_desc: 'Enable or disable the AI Assistant for all users in this account. Provides AI-powered product guidance, SQL generation & optimization, and troubleshooting.',
      ai_assistant_enable_title: 'Enable AI Assistant',
      ai_assistant_enable_desc_long1: 'PhoenixAI Cloud\'s AI Assistant enables users to receive query, code, or configuration suggestions (Outputs) from third-party large language model (LLM) providers based on natural language prompts, database schema, and/or local code context (Inputs).',
      ai_assistant_enable_desc_long2: 'No data in your PhoenixAI Cloud database is shared with LLM providers unless the AI Assistant is enabled by your organization administrator, as described below.',
      ai_assistant_enable_desc_long3: 'When the AI Assistant is enabled for your organization, LLM providers may execute queries against your database and use the returned data as additional Inputs. In this case, Outputs may include responses that analyze or summarize the data returned by those queries.',
      ai_assistant_enable_desc_long4: 'By enabling this feature, you agree, on behalf of your organization, that PhoenixAI may transmit relevant Inputs to third-party LLM providers, and that all such Inputs will comply with the providers\' acceptable use policies. PhoenixAI has configured its integration with third-party LLM providers such that Inputs and Outputs are not used to train their models. PhoenixAI does not retain Inputs or Outputs beyond what is necessary to deliver the AI Assistant feature. Outputs may be inaccurate or incomplete and should be reviewed before use. The AI Assistant can be enabled or disabled at any time by an organization administrator.',
      ai_assistant_enable_desc_long5: 'PhoenixAI does not control third-party LLM providers or their underlying systems. Any Inputs transmitted to, and Outputs generated by, third-party LLM providers are subject to those providers\' own terms of service, privacy policies, and data handling practices. Your organization is responsible for reviewing and ensuring compliance with the applicable third-party terms.',
      ai_assistant_enable_desc1: 'This feature uses AI-generated responses to assist with product guidance and troubleshooting.',
      ai_assistant_enable_desc2: 'Do not include personal, regulated, or sensitive customer data in your prompts.',
      ai_assistant_enable_desc3_prefix: 'By proceeding, you confirm that you understand these limitations and accept the ',
      ai_assistant_enable_desc3_terms: 'AI Use Terms',
      ai_assistant_enable_desc3_mid: ' and ',
      ai_assistant_enable_desc3_privacy: 'Privacy Policy',
      ai_assistant_enable_desc3_suffix: '.',
      ai_assistant_enable_confirm: 'Accept & Enable',
      ai_assistant_disable_title: 'Disable AI Assistant',
      ai_assistant_disable_warn: 'Disabling the AI Assistant will permanently delete all existing AI chat session data across your account, including conversation history and any generated SQL fixes.',
      ai_assistant_disable_desc1: 'This action cannot be undone. Users will no longer see AI-related features until the assistant is re-enabled.',
      ai_assistant_disable_desc2: 'Are you sure you want to proceed?',
      ai_assistant_disable_confirm: 'Disable & Delete Data',
      ai_assistant_cancel: 'Cancel',
      mcp_server: 'MCP Server',
      mcp_server_desc: 'Enable MCP (Model Context Protocol) access to allow AI agents to connect to your PhoenixAI cluster, list resources, and run SQL queries.',
      mcp_server_docs_link: 'View MCP server endpoints',
      mcp_server_url_label: 'MCP Server URL',
      mcp_server_connected: 'Connected',
      mcp_server_last_used: 'Last used {0}',
      mcp_server_never_used: 'Never used',
      mcp_server_enable_title: 'Enable MCP Server',
      mcp_server_enable_intro: 'Enabling the MCP server allows AI assistants like Claude, ChatGPT, and other Model Context Protocol-compatible clients to connect to your PhoenixAI clusters on behalf of authorized users in this account.',
      mcp_server_enable_what_title: 'What this means:',
      mcp_server_enable_what_1: 'Users in this account can authenticate AI clients to query data in your clusters',
      mcp_server_enable_what_2: 'AI clients will execute queries using each user\'s own permissions — they cannot exceed what the user could do directly',
      mcp_server_enable_not_title: 'What this does NOT do:',
      mcp_server_enable_not_1: 'Does not grant AI vendors direct access to your data',
      mcp_server_enable_not_2: 'Does not change existing user permissions or RBAC policies',
      mcp_server_enable_not_3: 'Does not enable AI clients to act without an authenticated user session',
      mcp_server_enable_governance: 'By enabling this, you confirm you have authority to allow third-party AI clients to access this account\'s data, and that doing so complies with your organization\'s data governance policies.',
      mcp_server_enable_checkbox: 'I understand and want to enable MCP server access for this account.',
      mcp_server_enable_confirm: 'Enable MCP Server',
      mcp_server_disable_title: 'Disable MCP Server',
      mcp_server_disable_desc: 'Disabling the MCP server will disconnect all active MCP connections in this account. In-progress operations using MCP tools will fail.',
      mcp_server_disable_confirm: 'Disable MCP Server',
      mcp_server_disable_cancel: 'Cancel',
      group_security: 'Security & Access Control',
      group_ai: 'AI & Integrations',
      group_data_export: 'Data Export',
      mfa: 'Multi-Factor Authentication',
      mfa_desc: 'Enabling MFA requires all users in this account to set up multi-factor authentication (MFA) at their next sign-in.',
      mfa_enable_title: 'Enforce Multi-Factor Authentication',
      mfa_enable_desc: 'All users in this account will be required to set up multi-factor authentication (MFA) the next time they sign in. Users who already use MFA are unaffected.',
      mfa_enable_confirm: 'Enable',
      mfa_disable_title: 'Turn off enforced MFA',
      mfa_disable_desc: 'Users will no longer be required to use multi-factor authentication (MFA). Anyone who already set up MFA keeps it until they remove it themselves.',
      mfa_disable_confirm: 'Turn off',
      audit_log_export: 'Audit log export',
      audit_log_export_active: 'Active',
      audit_log_export_desc: 'Export your account audit log as CSV to your own S3 bucket. Runs are incremental.',
      audit_log_export_create: 'Create export credential',
      audit_log_export_create_tips: 'Create a cross-account IAM role that lets PhoenixAI write to your S3 bucket. Configure the role\'s trust policy with the trusted account ID and External ID below, then attach the permission policy shown.',
      audit_log_export_create_success: 'Audit log export credential created',
      audit_log_export_name: 'Credential name',
      audit_log_export_name_placeholder: 'Enter a name for this credential',
      audit_log_export_trusted_account: 'Trusted account ID',
      audit_log_export_external_id: 'External ID',
      audit_log_export_role_arn: 'Role ARN',
      audit_log_export_role_arn_placeholder: 'arn:aws:iam::<account-id>:role/<role-name>',
      audit_log_export_role_arn_required: 'Please enter the role ARN',
      audit_log_export_role_arn_invalid: 'Please enter a valid IAM role ARN',
      audit_log_export_bucket: 'Bucket name',
      audit_log_export_bucket_placeholder: 'Enter the target S3 bucket',
      audit_log_export_bucket_required: 'Please enter the bucket name',
      audit_log_export_bucket_invalid: 'Please enter a valid S3 bucket name',
      audit_log_export_folder: 'Folder path',
      audit_log_export_folder_placeholder: 'e.g. audit/logs',
      audit_log_export_folder_required: 'Please enter the folder path',
      audit_log_export_kms: 'KMS key ARN',
      audit_log_export_kms_placeholder: 'arn:aws:kms:<region>:<account-id>:key/<key-id>',
      audit_log_export_kms_invalid: 'Please enter a valid KMS key ARN',
      audit_log_export_policy: 'Permission policy',
      audit_log_export_delete_title: 'Delete export credential',
      audit_log_export_delete_desc: 'Delete the audit log export credential "{0}"? Audit logs will no longer be exported to S3.',
      audit_log_export_delete_success: 'Audit log export credential deleted',
    },
    sso: {
      title: 'IAM settings',
      config: 'Configure',
      saml: 'SAML',
      oidc: 'OIDC',
      testSso: 'Test SSO',
      info: {
        samlStatus: 'SAML Status',
        oidcStatus: 'OIDC Status',
        testStatus: 'Test Status',
        update: 'Updated at',
        updater: 'Updated by',
      },
      testStatus: {
        none: 'Not tested',
        passed: 'Passed',
        failed: 'Failed',
        passedWithEmail: 'Passed (email: {email})',
        failedWithMsg: 'Failed: {msg}',
        tipNeedTest: 'Please click "Test SSO" and complete the authorization flow before enabling OIDC.',
        tipSamlEnabled: 'SAML SSO is currently enabled. Please disable SAML first before enabling OIDC.',
        tipOidcEnabled: 'OIDC SSO is currently enabled. Please disable OIDC first before enabling SAML.',
        returnPassed: 'Test SSO passed. You can now enable OIDC.',
        returnFailed: 'Test SSO failed. Please review your OIDC configuration and try again.',
      },
      dialog: {
        title: 'Configure SAML',
        desc: 'Before configuring SAML, you need to create an identity provider (IdP) account. More information: ',
        docsLink: 'How to configure SAML?',
        form: {
          protocol: 'Select SSO protocol',
          redirect: 'PhoenixAI redirect URL',
          sso: 'Single Sign-On URL',
          celerDataEntity: 'PhoenixAI entity ID',
          ssoHover: 'Enter the SSO URL generated by your identity provider.',
          entity: 'Entity ID',
          entityHover: 'Enter the identity provider’s entity ID.',
          enforce: 'Enforce SSO',
          enforceHover: 'When enabled, all users, except account and org admins, can only sign in with SSO',
          cert: 'x.509 Certificate',
          certHover: 'Specify your identity provider\'s full public x.509 certificate.',
          defaultRole: 'Default Role',
          defaultRolePlaceholder: 'Please select a default role',
          defaultRoleRequired: 'Default Role is required',
        },
        disableTitle: 'Disable Single Sign-On (SSO)',
        disableTips: 'Are you sure you want to disable Single Sign-On (SSO)? Disabling this may remove access for members without passwords. Your configuration will be saved to be reactivated in the future.',
      },
      oidcDialog: {
        title: 'Configure OIDC',
        desc: 'OpenID Connect (OIDC) allows users to authenticate using your organization\'s identity provider. Configure your OIDC application in the IdP first, then fill in the fields below. ',
        docsLink: 'How to configure OIDC?',
        form: {
          protocol: 'Identity protocol',
          redirect: 'PhoenixAI redirect URL',
          redirectHover: 'Copy this URL and set it as the Redirect URI of your OIDC application in your identity provider.',
          clientId: 'Client ID',
          clientIdPlaceholder: 'Enter the Client ID of your OIDC application',
          clientIdHover: 'Client ID is the unique identifier for the PhoenixAI Cloud application you created in your identity provider. This is sometimes referred to as the Application ID.',
          clientIdRequired: 'Client ID is required',
          clientSecret: 'Client Secret',
          clientSecretPlaceholder: 'Enter the Client Secret of your OIDC application',
          clientSecretPlaceholderEdit: 'Leave empty to keep the existing Client Secret',
          clientSecretHover: 'Client secret is a secret or password generated for the PhoenixAI Cloud application that you created. It is used to authorize PhoenixAI Cloud with your identity provider.',
          clientSecretRequired: 'Client Secret is required',
          discoveryUrl: 'Discovery URL',
          discoveryUrlPlaceholder: 'https://<idp-domain>/.well-known/openid-configuration',
          discoveryUrlHover: 'Discovery URL is the prefix of the URL at which your identity provider\'s OpenID Configuration Document can be found. That OpenID Configuration Document must be found at {issuer-url}/.well-known/openid-configuration.',
          discoveryUrlRequired: 'Discovery URL is required',
          discoveryUrlInvalid: 'Discovery URL must end with /.well-known/openid-configuration',
          emailClaim: 'Username Claim (optional)',
          emailClaimPlaceholder: 'email',
          emailClaimHover: 'The claim in the ID token that represents the user email. Leave blank to use the default "email" claim.',
        },
        disableTitle: 'Disable OIDC Single Sign-On',
        disableTips: 'Are you sure you want to disable OIDC Single Sign-On? Users will no longer be able to sign in with OIDC. Your configuration will be preserved.',
        disableBlockedTitle: 'Unable to Disable OIDC',
        disableBlockedDesc: 'The following clusters have JWT authentication enabled and depend on OIDC. Please disable JWT authentication on these clusters before disabling OIDC:',
        goToCluster: 'Go to cluster',
        updateSuccessNeedTest: 'Configuration saved. Please click "Test SSO" and complete authorization before enabling OIDC.',
        addSuccessNeedTest: 'Configuration created. Please click "Test SSO" and complete authorization before enabling OIDC.',
        enableSuccess: 'OIDC SSO enabled successfully.',
        disableSuccess: 'OIDC SSO disabled successfully.',
        testStarting: 'Redirecting to your identity provider for authorization...',
      },
      roleMapping: {
        title: 'Role Mapping for SAML Config',
        createBtn: 'Create New Role Mapping',
        groupName: 'Group Name (from IDP)',
        celerDataRoles: 'PhoenixAI Roles',
        dialogTitle: 'Create Role mapping between your identity provider\'s group names and roles in PhoenixAI',
        idpGroupName: 'IDP Group Name',
        idpGroupNameRequired: 'IDP Group Name is required',
        idpGroupNamePlaceholder: 'Enter the group name from your identity provider.',
        selectRoles: 'Select PhoenixAI Roles',
        selectRolesPlaceholder: 'Select one or more PhoenixAI roles to map to this IDP group.',
        selectRolesRequired: 'Please select at least one role',
        duplicateGroupName: 'IDP Group Name must be unique',
        unsavedWarning: 'Please save or cancel the role mapping being edited first.',
        deleteConfirm: 'Are you sure you want to delete this role mapping?',
        deleteSuccess: 'Role mapping deleted successfully.',
        createSuccess: 'Role mapping created successfully.',
      },
    },
    serviceAccount: {
      desc: 'The service account is an independent entity that exists in your PhoenixAI Cloud account. It is used to integrate with your custom programs and access PhoenixAI Cloud through OpenAPI/Terraform and execute cluster and cloud resource management operations.',
      matchedTip: 'service account(s) matched',
      searchPlaceholder: 'Search the service accounts',
      clientID: 'Client ID',
      createTitle: 'Generate secret for service account',
      name: 'Service account name',
      namePlaceholder: 'Enter the user-facing display name for this service account (unique in this account)',
      nameRequired: 'Service account name is required',
      nameUniqueTips: 'Service account name must be unique in this account.',
      clientSecret: 'Client Secret',
      generatedTips: 'You have successfully generated a service account. Please make sure to save the secret & Client ID pair locally as this will be your only opportunity to view the secret key. If you misplace this key pair, you will need to generate a new service account. The service account currently does not possess any permissions. Therefore, the next step is to assign the required roles to this service account.',
      detailTitle: 'Service account details',
      unassignRoleContent: 'All the privileges of this role will be revoked from the service account. Confirm to unassign the {0} from the service account {1}.',
    },
  },
  auditLog: {
    filter: {
      object: 'Object',
      objectName: 'Object name',
      changelogEntry: 'Changelog entry',
    },
    exportTruncatedTip: 'Only the most recent 20,000 records were exported. Narrow the filter to export fewer records.',
    exportS3Success: 'Audit log exported to {path}',
    exportMenu: 'Export',
    downloadLocal: 'Download to csv',
    runExport: 'Export to s3',
    goExportSettings: 'Go export settings',
  },
  config: {
    title: 'Configure your PhoenixAI Cloud Account',
    subTitle: 'Enter the PhoenixAI Cloud\'s Account Name here',
    placeholder: 'your account name',
    tips: 'Attention: The PhoenixAI Cloud Account Name will be the identifier for your PhoenixAI Cloud Account Console service. A PhoenixAI Account can manage more than 20 clusters within the same Cloud Platform. You need to make sure the account is unique across PhoenixAI Cloud. More information can be referenced in',
    tipsEnd: 'PhoenixAI Cloud Account Console.',
  },
  platform: {
    title: 'Choose your cloud platform:',
    tips: 'Google Cloud Platform and Azure will be supported soon!',
  },
  cluster: {
    title: 'Clusters',
    add: 'Create cluster',
    name: 'Cluster name',
    region: 'Region',
    createTime: 'Created at',
    state: 'Status',
    runningFor: 'Running for {0} day(s) {1} hour(s) {2} minute(s)',
    noCluster: 'No clusters',
    loadFailed: 'Failed to load clusters',
    account: 'Account',
    type: 'Type',
    selectAccount: 'Select account',
    allAccounts: 'All accounts',
    countLabel: '{0} clusters',
    cardView: 'Card view',
    tableView: 'Table view',
    editClusterName: 'Edit cluster name',
    backtoRestore: 'Back to restore',
    AccountNoClusterTip: 'There is no cluster under the currently selected account.',
    noClusterTip: 'The PhoenixAI cluster can serve as a data lake query engine to perform data analytics workloads directly on external data sources with zero migration. Additionally, you can ingest and transform data from external data sources into the PhoenixAI cluster to achieve extreme query performance.',
    del: 'Delete cluster',
    edit: 'Edit cluster',
    suspend: 'Suspend cluster',
    resume: 'Resume cluster',
    editCoordinator: 'Edit coordinator',
    scaleCoordinator: 'Scale coordinator node',
    addWarehouse: 'Add warehouse',
    open: 'Open cluster',
    release: 'Release cluster',
    preview: 'Preview Cluster',
    classicTip: 'Classic clusters are deployed with reference to {0} from shared-nothing StarRocks.',
    classicTipLink: 'storage-compute coupled architecture',
    elasticTip: 'Elastic clusters are deployed with reference to {0} from shared-data StarRocks.',
    elasticTipLink: 'storage-compute separation architecture',
    syncResp: 'You have successfully updated your cluster!',
    asyncResp: 'Starting cluster update! This process may take a few minutes, please be patient.',
    warehouse: {
      warehousePrice: 'Warehouse costs per hour:',
      costDetailTitle: 'Warehouse costs details',
      costDesc: 'The warehouse is charged {0} (per hour) for the software costs by PhoenixAI. The total warehouse cost will be calculated based on the hourly warehouse cost and the total running time of the warehouse. You also need to pay the cloud provider for the additional infrastructure (such as virtual machines) costs associated with this warehouse.',
      costItem: 'Compute Nodes Cost:',
      createWarehouse: 'Create warehouse',
      editWarehouse: 'Edit the Warehouse: {0}',
      warehouseName: 'Warehouse name',
      enterWarehouseName: 'Enter your warehouse name',
      resumeWarehouseWithCluster: 'Resume this warehouse when the cluster is resumed',
      ccuTotal: 'CCU(s) total',
      description: 'Description (Optional)',
      enterDescription: 'Enter your warehouse description for the easy management',
      nodeConfiguration: 'Node configuration',
      computeNodeSize: 'Compute node size',
      computeNodeCount: 'Compute node count',
      nodeDistributionPolicy: 'Node distribution policy',
      sameAZDeployment: 'Nodes will be deployed in the same availability zone as you selected.',
      subnetID: 'Subnet ID',
      subnetIDRequired: 'Subnet ID is required',
      evenDistribution: 'Nodes will be evenly distributed across multiple availability zones',
      nameValidation: 'The name must start with a letter, can only contain letters, numbers and underscores. The maximum length is 32.',
      descriptionLengthLimit: 'The description cannot exceed 100 characters.',
      creatingWarehouse: 'The warehouse is being created. Please be patient, the process will take about 3-5 minutes.',
      instancesChanging: 'It looks like there are instances in your cluster that are undergoing changes, please wait a moment.',
      nodeInstanceType: 'Node instance type:',
      nodeCount: 'Node count:',
      warehouseNodeScaling: 'Warehouse node scaling.',
      warehouseDescription: 'A warehouse in a PhoenixAI cluster provides the resources to run SQL against internal & external data. You can access the data exposed by the internal & external catalogs with the SQL Editor or other client applications. Learn more:',
      manageWarehousesLink: 'Manage warehouses in PhoenixAI Cloud',
      editClusterSize: 'Edit your cluster size',
      totalWarehouses: 'Total {0} warehouses',
      builtinWarehouse: 'Builtin warehouse',
      normalWarehouse: 'Normal warehouse',
      warehouseSize: 'Warehouse size:',
      groupSize: 'Group size:',
      diskUsage: 'Disk usage:',
      used: 'used',
      free: 'Free',
      last7DaysComputeUsage: 'Last 7 days compute usage:',
      quickSuspend: 'Quick suspend',
      quickResume: 'Quick resume',
      viewMoreDetails: 'View more details',
      warehouseSuspending: 'The warehouse {0} is being suspended. Please be patient, the process will take about 3 minutes.',
      warehouseResuming: 'The warehouse \'{0}\' is resuming and is expected to take a few minutes. Please wait a moment.',
      manageWarehouse: 'Manage warehouse',
      editWarehouseSize: 'Edit warehouse',
      editScalingPolicy: 'Edit scaling policy',
      editSuspendPolicy: 'Edit suspend policy',
      computeNodes: 'Compute nodes',
      deleteWarehouseConfirmTitle: 'Confirm to delete the warehouse {0}?',
      deleteWarehouseConfirmContent: 'Once the warehouse is deleted, the related cloud resources in it will be released, and the SQL running on it will also be exited.',
      resumeWarehouseConfirmTitle: 'Confirm to resume the warehouse {0}?',
      resumeWarehouseConfirmContent: 'This process will last about 2 minutes, please be patient.',
      suspendWarehouseConfirmTitle: 'Confirm to suspend the warehouse {0}?',
      suspendWarehouseConfirmContent: 'Once suspended, the warehouse will stop running and release computing resources. No workload can be submitted to this warehouse. You can manually resume it again the next time you use it.',
    },
    az: {
      singleAZ: 'Single AZ',
      crossingAZ: 'Crossing AZ',
      MutilAZ: 'Multi AZ',
      singleAZDesc: 'Single AZ (Choose primary availability zone in the network configuration specifications)',
      crossingAZDesc: 'Crossing AZ (Nodes are automatically and evenly distributed in multiple availability zones)',
      MutilAZDesc: 'Multi AZ (Nodes are totally distributed in multiple availability zones)',
    },
  },
  clusterDetail: {
    timeZoneTips: 'The cluster time zone is set during deployment, and is read only. It’s the same as `system_time_zone` variable.',
    clusterEvent: 'View cluster event',
    event: {
      title: 'Cluster event of {0}',
      result: 'Result',
    },
    resumeWarehouseConfig: {
      title: 'Warehouse Configuration',
      resumeTip: 'Resume this warehouse when cluster is resumed',
    },
    upgrade: {
      buttonText: 'Upgrade',
      dialogTitle: 'Are you sure you want to upgrade the cluster to version {version}?',
      dialogMessage: 'This will upgrade your cluster from {oldVersion} to version {version}. During this upgrade, your cluster will remain operational. Nodes are updated one at a time. The upgrade time depends on cluster size (~2 mins per node).',
      confirmButton: 'Upgrade',
      successMessage: 'Cluster upgrade initiated successfully.',
      tooltipAvailable: 'We have new patched version {version}, click to upgrade.',
    },
    resource: 'Resource scheduling',
    deploymentBtn: 'Deployments',
    settingsBtn: 'Cloud settings',
    overview: 'Overview',
    backupRestore: 'Backup & Restore',
    dataProtection: 'Data Protection',
    dp: {
      scheduledSnapshot: 'Scheduled snapshot',
      level1Label: 'LEVEL 1',
      level2Label: 'LEVEL 2',
      statusEnabled: 'Enabled',
      statusNotConfigured: 'Not Configured',
      localRecoveryTitle: 'Local Recovery',
      localRecoveryDesc: 'Time-based recovery within a region using cluster snapshots.',
      localRecoveryNeutralDesc: 'Time-based recovery within a region. Fast, metadata-only snapshots with no data copy. Roll back this cluster or restore into another cluster in the same region.',
      localRecoveryTooltip: 'Point-in-time recovery points produced by the automated snapshot policy.',
      localRecoveryNotEnabledTitle: 'Local Recovery is not enabled',
      localRecoveryNotEnabledDesc: 'Enable automated cluster snapshots to protect your data with time-based recovery points within this region.',
      crossRegionTitle: 'Cross-Region Resilience',
      crossRegionDesc: 'Self-contained snapshots restorable to a cluster in any region.',
      crossRegionNeutralDesc: 'Region-outage recovery. Self-contained snapshots with a full data copy, restorable to a cluster in any region — includes in-region recovery.',
      crossRegionTooltip: 'Region-outage recovery. Self-contained snapshots restorable to a cluster in any region.',
      crossRegionNotConfiguredTitle: 'Cross-Region Resilience is not configured',
      crossRegionDescL1Off: 'Enable cross-region data synchronization to protect against regional outages.',
      crossRegionRequiresL1: 'Requires Local Recovery (Level 1) to be enabled first.',
      crossRegionDescL1On: 'Enable cross-region data synchronization to protect your cluster against regional outages. A secondary region will maintain a consistent recovery point for manual failover.',
      statusRunning: 'Running',
      statusNotEnabled: 'Not Enabled',
      enableDataProtection: 'Enable Data Protection',
      heroTitleOff: 'Data Protection is not enabled',
      heroSubOff: 'Snapshots create point-in-time recovery points for this cluster. Choose a protection scope during setup — recover within this region, or recover to a cluster in any region after a regional outage.',
      heroTitleLocal: 'Local Recovery is enabled',
      heroSubLocal: 'This cluster takes a snapshot {schedule}. You can restore to any recovery point within this region.',
      heroTitleExternal: 'Cross-Region Resilience is enabled',
      heroSubExternal: 'This cluster takes a self-contained snapshot {schedule}. After a regional outage, restore into a cluster in any region — in-region recovery is included.',
      onePolicyInfo: 'In this release a cluster runs {0} snapshot policy — Local or Cross-Region. Running both at the same time is planned for a future release.',
      snapshotsTitle: 'Snapshots',
      typeAuto: 'Auto',
      manualSnapshotsHint: 'Manual snapshots — planned for a future release.',
      protectionScope: 'Protection Scope',
      scopeTagLocal: 'Fast snapshots',
      scopeTagExternal: 'Region-outage protection',
      scopeLocalDesc: 'Metadata-only snapshots — no data copy, minimal overhead. Restore within this region: roll back this cluster or restore into another cluster.',
      scopeExternalDesc: 'Self-contained snapshots with a full data copy. Restore to a cluster in {0} — includes everything Local Recovery does. Snapshots take longer and copy data on each cycle.',
      scopeExternalDescBold: 'any region',
      scopeNotAvailable: 'Not available',
      enableScopeInfo: 'A cluster runs {0} automated snapshot policy — Local or Cross-Region, not both (simultaneous support is on the roadmap). Switching scope later requires disabling the current policy, {1}.',
      enableScopeInfoBold1: 'one',
      enableScopeInfoBold2: 'which deletes its existing snapshots',
      crossRegionUnsupportedTip: 'This cluster version does not support Cross-Region Resilience.',
      enableCrossRegion: 'Enable Cross-Region Resilience',
      statusActive: 'Active',
      statusNotActive: 'Not Active',
      statusCovered: 'Covered',
      localRecoveryCoveredDesc: 'Covered by Cross-Region snapshots — they support in-region restore as well.',
      localRecoveryInactiveDesc: 'Not running as its own policy. In-region restore is still available — Cross-Region snapshots can be restored into a cluster in this region too.',
      crossRegionInactiveDesc: 'Restore into a cluster in any region after a regional outage. Not running on this cluster.',
      switchToLocal: 'Switch to Local Recovery…',
      switchToCrossRegion: 'Switch to Cross-Region…',
      activeScopeNote: 'A cluster runs {0} snapshot policy. {1} is the active scope — {2} is off.',
      switchScopeLink: 'Switch protection scope…',
      kvScope: 'Scope:',
      kvPrimaryRegion: 'Primary region:',
      kvRegion: 'Region:',
      kvStoredLocation: 'Stored location:',
      regionAnyRegionSuffix: '· restorable to any region',
      scopeMonoLocal: '(snapshot_scope = local)',
      scopeMonoExternal: '(snapshot_scope = external)',
      kvStatus: 'Status:',
      kvLatestSnapshotStatus: 'Snapshot Status:',
      latestSnapshotStatus: 'Job status',
      scopeValueLocal: 'Local Recovery',
      scopeValueExternal: 'Cross-Region Resilience',
      syncStatusTitle: 'Snapshot Job Status',
      syncStatusTooltip: 'Read from the automated snapshot job history: the latest job with STATE=FINISHED means Running; anything else shows Error with that job\'s error message.',
      syncStatusLabel: 'Status',
      syncStatusRunning: 'Running',
      syncStatusError: 'Error',
      syncStatusSuspended: 'Suspended',
      syncStatusRunningSub: 'The most recent snapshot job finished without errors',
      syncStatusErrorSub: 'Latest snapshot job did not finish',
      lastSuccessfulSnapshot: 'Last successful snapshot',
      recoveryPoint: 'Recovery point',
      recoveryPointSub: 'Changes made in the last {span} are not yet in a snapshot',
      recoveryPointSubEmpty: 'Changes since the last snapshot are not yet in a snapshot',
      recoveryPointLtMin: '< 1 min',
      recoveryPointMin: '~{n} min',
      recoveryPointHour: '~{n} h',
      recoveryPointDay: '~{n} day(s)',
      agoJustNow: 'just now',
      agoMin: '{n} min ago',
      agoHour: '{n} h ago',
      agoDay: '{n} day(s) ago',
      crossRegionOutageLead: 'During a region outage this page stays available.',
      crossRegionOutageInfo: '{0} Snapshots are listed directly from S3, not from the cluster. Use {1} to recover into a cluster in another region.',
      existingClusterInfoBannerExternal: 'Only running clusters, with all warehouses running, that use the same credential and run the same major.minor version as the source cluster are eligible as restore targets. Cross-Region snapshots may target a cluster in any region.',
      switchScopeTitle: 'Switch Protection Scope',
      switchScopeSubtitle: 'Switch this cluster from {0} to {1}.',
      switchScopeDangerTitle: 'Switching deletes existing snapshots',
      switchScopeWarning: 'A cluster runs one snapshot policy. Switching scope disables the current policy first, and disabling automated snapshots {0}.',
      switchScopeWarningBold: 'deletes all snapshots it has produced',
      switchScopeUnprotected: 'This cluster will have no recovery points until the first snapshot on the new policy completes.',
      switchScopeAckDelete: 'I understand that all existing snapshots will be {0}.',
      switchScopeAckDeleteBold: 'deleted',
      switchScopeAckUnprotected: 'I understand the cluster is unprotected until the first snapshot on the new policy finishes.',
      switchScopeConfirm: 'Disable & Continue to Setup',
      kvSnapshotSchedule: 'Schedule:',
      kvRetentionPeriod: 'Retention period:',
      kvLastSnapshot: 'Last snapshot:',
      configure: 'Configure',
      restoreFromSnapshot: 'Restore from Snapshot',
      backToDataProtection: 'Back to Data Protection',
      configureTitle: 'Enable Data Protection',
      editTitle: 'Edit Data Protection',
      scheduleHint: 'Interval between automated snapshots. Cross-Region snapshots copy data each cycle and take longer than Local snapshots — prefer a longer interval.',
      snapshotSchedule: 'Snapshot schedule',
      retentionPeriod: 'Retention period',
      storedLocation: 'Stored location',
      storedLocationReadonlyDesc: 'Read-only. Snapshots are written to this cluster\'s own bucket.',
      storedLocationVolumeDesc: 'Snapshots are written to the storage volume {0}.',
      storageVolume: 'Storage volume',
      storageVolumeHint: 'Where Cross-Region snapshots are written. Pick a volume in a different region from this cluster. It cannot be changed after the policy is enabled.',
      storageVolumeLockedHint: 'Set when the policy was enabled and cannot be changed. To use another volume, disable Cross-Region Resilience and enable it again.',
      infoBanner: 'Snapshots will begin after enabling. The first snapshot may take longer depending on data size. Snapshot storage costs are included in your cluster plan.',
      enableLocalRecovery: 'Enable Local Recovery',
      saveChanges: 'Save Changes',
      enableSuccessTips: 'Local Recovery enabled successfully',
      saveSuccessTips: 'Settings saved successfully',
      overwriteConfirmTitle: 'Auto snapshot already enabled',
      overwriteConfirmContent: 'Auto snapshot is already enabled on this cluster. Overwrite it with the new configuration?',
      scheduleEvery10m: 'Every 10 minutes',
      scheduleEvery4h: 'Every 4 hours',
      scheduleEvery6h: 'Every 6 hours',
      scheduleEvery12h: 'Every 12 hours',
      scheduleEvery24h: 'Every 24 hours',
      retentionDays3: '3 days',
      retentionDays7: '7 days',
      retentionDays14: '14 days',
      retentionDays30: '30 days',
      restoreTitle: 'Restore from Snapshot',
      restoreSubtitle: 'Select a snapshot to restore and choose your restore target.',
      step1Title: 'Step 1: Select Snapshot',
      step2Title: 'Step 2: Choose Restore Target',
      colSnapshotId: 'Snapshot ID',
      colType: 'Type',
      colCreated: 'Created',
      colSize: 'Size',
      colDatabases: 'Databases',
      colStatus: 'Status',
      typeAutomated: 'Automated',
      statusAvailable: 'Available',
      restoreTargetCurrentTitle: 'Restore to Current Cluster',
      restoreTargetCurrentDesc: 'Roll back this cluster to the selected snapshot. All data written after the snapshot will be lost.',
      restoreTargetExistingTitle: 'Restore to Existing Cluster',
      restoreTargetExistingDesc: 'Restore snapshot data into another existing cluster, or create a new cluster first.',
      restoreTargetExistingDescExternal: 'Restore snapshot data into another existing cluster — in this region or in any other region, or create a new cluster first.',
      restoreS3InfoBanner: 'Snapshots are read directly from S3 — this flow remains available even if the source cluster is unreachable.',
      tagDestructive: 'DESTRUCTIVE',
      tagNonDestructive: 'NON-DESTRUCTIVE',
      selectTargetCluster: 'Select a target cluster:',
      existingClusterInfoBanner: 'Eligible targets are {0} clusters with {1}, using the {2} and the {3} as the source cluster.',
      existingClusterInfoBannerBold0: 'running',
      existingClusterInfoBannerBold1: 'all warehouses running',
      existingClusterInfoBannerBold2: 'same credential',
      existingClusterInfoBannerBold3: 'same major.minor version',
      existingClusterRegionExternalBold: 'any region',
      existingClusterDataAllowedBold: 'is allowed',
      existingClusterRegionLocal: 'Local snapshots can only be restored within the same region ({region}).',
      existingClusterRegionExternal: 'Cross-Region snapshots may target a cluster in {0}; all other settings must match — a mismatch blocks the restore.',
      existingClusterDataAllowed: 'A target that already holds data {0} — the {1} column shows what is there before you confirm.',
      colClusterName: 'Cluster Name',
      colRegion: 'Region',
      colCredential: 'Credential',
      colVersion: 'Version',
      colContents: 'Contents',
      warehousesRunning: '{running} / {total} warehouses running',
      warehouseRunningSingular: '{running} / {total} warehouse running',
      warehousesNotReachable: 'warehouses not reachable',
      contentsEmpty: 'Empty',
      contentsUnknown: 'Unknown',
      contentsOneDatabase: '1 database',
      contentsManyDatabases: '{n} databases',
      existingClusterVersionRequirement: 'This cluster is on {0}, so any {1} target is accepted.',
      versionMismatchTip: 'Different major.minor version — the target cluster must run {version}.x to accept this snapshot.',
      versionUnknownTargetTip: 'Version could not be determined — this cluster cannot be selected as a restore target.',
      versionUnknownSourceTip: 'This cluster version could not be determined, so version compatibility cannot be verified.',
      createNewCluster: 'Create a new cluster…',
      createNewClusterDesc: 'A new cluster will be provisioned with the same instance profile and version, in the region you choose. You\'ll return here to select it once it\'s ready.',
      createNewClusterDescLocal: 'A new cluster will be provisioned with the same instance profile and version, in this region. You\'ll return here to select it once it\'s ready.',
      credentialMismatchTip: 'Instance profile differs from the source cluster — restore blocked.',
      clusterNotRunningTip: 'The cluster must be running to accept a restore.',
      warehouseNotRunningTip: 'Every warehouse must be running to accept a restore.',
      sourceNotSuspendedTip: 'Suspend the source cluster before restoring its snapshot to another cluster.',
      confirmTitle: 'Confirm Restore to Current Cluster',
      confirmSubtitle: 'Review the restore details carefully. This action is destructive and cannot be undone.',
      confirmLabelSnapshot: 'Snapshot:',
      confirmLabelCreated: 'Created:',
      confirmLabelSize: 'Size:',
      confirmLabelTarget: 'Target:',
      confirmTargetValue: 'Current Cluster ({0})',
      confirmLabelSourceCluster: 'Source cluster:',
      confirmLabelTargetCluster: 'Target cluster:',
      confirmLabelTargetRegion: 'Target region:',
      warningTitle: 'Warning: Destructive Action',
      warningAllCurrentData: 'all current data',
      warningText: 'This will overwrite {0} in cluster {1} with the snapshot data. Any data written after {2} will be permanently lost. The cluster will be unavailable during the restore process.',
      confirmClusterNameLabel: 'To confirm, type the cluster name: {0}',
      ackDataLoss: 'I understand that all data written after the snapshot will be permanently lost.',
      ackDowntime: 'I understand the cluster will be unavailable during the restore.',
      restoreCluster: 'Restore Cluster',
      confirmExistingTitle: 'Confirm Restore to Existing Cluster',
      confirmExistingSubtitle: 'Review the restore details. The snapshot data will be restored into the selected target cluster.',
      safeOperation: 'Safe operation',
      safeOperationDesc: 'Your source cluster ({0}) is not affected.',
      existingOverwriteWarning: 'The target cluster will be overwritten with snapshot data.',
      existingOverwriteWarningBody: 'Restoring into a cluster that already holds data is allowed, but everything currently on {name} is replaced. Type its name below to confirm.',
      confirmTargetClusterNameLabel: 'To confirm, type the target cluster name: {0}',
      restoreSummaryTitle: 'Restore Summary',
      safeOpTitle: 'This operation does not modify the source cluster.',
      safeOpExternalTail: ' It proceeds even if the source cluster ({0}) is currently unreachable.',
      confirmLabelType: 'Type:',
      confirmTypeLocal: 'Local',
      confirmTypeExternal: 'Cross-Region (external)',
      confirmLabelPrechecks: 'Pre-checks:',
      prechecksInstanceProfile: 'Instance profile matched',
      prechecksVersion: 'Version compatible (source {source} → target {target}, same {line}.x)',
      prechecksDataOne: 'Target holds 1 database — allowed, it will be replaced',
      prechecksDataMany: 'Target holds {n} databases — allowed, they will be replaced.',
      prechecksDataEmpty: 'Target is empty',
      prechecksDataUnknown: 'Target contents unknown',
      confirmAckHeader: 'Before you proceed, acknowledge the following:',
      ackExistingOverwrite: 'Existing data on {0} will be replaced with the snapshot data.',
      ackSnapshotsOff: 'After the restore, snapshots on {0} are {1}. I must re-enable Data Protection on it to re-establish coverage.',
      ackSnapshotsOffBold: 'turned off automatically',
      ackSourceReadOnly: 'The source cluster {0} should not continue taking writes. If both clusters accept writes, their data will diverge and cannot be reconciled. Read-only use of the source is safe.',
      restoreToCluster: 'Restore to Cluster',
      snapshotExpiredReselect: 'The selected snapshot is no longer available. Please choose another recovery point.',
    },
    snapshot: {
      automatedSnapshotTitle: 'Automated Cluster Snapshot',
      enableSnapshotTitle: 'Enable Automated Cluster Snapshot',
      enableSnapshotDesc: 'You can enable automated cluster snapshot to automatically backup the cluster data to the object storage. The snapshot will be created at the specified interval.',
      volume: 'Storage volume',
      snapshotName: 'Snapshot name',
      storageLocation: 'Storage location',
      storedLocation: 'Stored location',
      storedLocationReadonlyDesc: 'Read-only. Snapshots are written to this cluster\'s own bucket.',
      volumePlaceholder: 'Select the storage volume',
      disableDialogTitle: 'Disable automated cluster snapshot',
      disableDialogContent: 'If you disable Cluster Snapshots, the system will {0}. After it\'s deleted, you {1} the cluster using snapshot.',
      disableDialogContentBold1: 'automatically delete the snapshot',
      disableDialogContentBold2: 'won\'t be able to restore or roll back',
      enableSnapshotForm: {
        interval: 'Snapshot Interval',
        intervalPlaceholder: 'Enter the snapshot interval',
        successTips: 'Automated snapshot enabled successfully',
        failedTip: 'Failed to enable automated snapshot',
        storagevolumeError: 'Unable to access the storage volume. Confirm that the storage volume is in the enabled state and that the associated permissions are correctly set.',
        bucketAccessError: 'Unable to access the storage volume\'s bucket from the cluster. Confirm that the cluster\'s instance profile has permission to access the bucket. If the permissions are correct, the cluster agent may be outdated. Please contact support to upgrade it.',
      },
      restoreSnapshotTitle: 'Restore From Cluster Snapshot',
      restoreSnapshotDesc: 'Cluster recovery from a specific snapshot will overwrite existing data. Configuration options allow reuse of deployment and network configuration. The system handles automatic remounting of the original storage volume.',
      restoreNoAllowTips: 'Before running the restore, ensure the cluster is in the running state.',
      restoreSnapshotForm: {
        restoreOnOriginCluster: 'Restore on origin cluster',
        successTips: 'Snapshot restored successfully',
        failedTip: 'Failed to restore snapshot',
      },
    },
    clusterTypes: {
      classic: 'Classic cluster',
      elastic: 'Elastic cluster',
      jwtAuth: 'JWT Auth',
    },
    privateLink: {
      openFromPrivateLink: 'Open cluster from private link',
      comingSoon: '(Coming soon)',
    },
    warehouse: 'Warehouses',
    scheduling: 'Resource scheduling',
    parameters: 'Cluster parameters',
    warehouseParameters: 'Warehouse parameters',
    computeReplica: 'Compute Replica',
    computeReplicaDetail: {
      title: 'Compute Replica',
      titleTip: 'Compute Replica maintains redundant cache copies of tablet data across multiple compute nodes to ensure predictable query latency.',
      statusNotConfigured: 'Not Configured',
      statusHealthy: 'Healthy',
      statusDegraded: 'Degraded',
      emptyTitle: 'Compute Replica is not enabled',
      emptyDesc: 'Enable compute replica to maintain redundant cache copies across compute nodes. This ensures predictable query latency during node restarts, rolling upgrades, and scaling events.',
      configureBtn: 'Configure Compute Replica',
      configureTitle: 'Configure Compute Replica',
      configureDesc: 'Compute Replica maintains redundant cache copies of tablet data across multiple compute nodes in this warehouse. When a node restarts or fails, queries are automatically routed to a surviving node with warm cache, avoiding costly remote reads from object storage.',
      editTitle: 'Edit Compute Replica Settings',
      replicaCount: 'Replica count',
      replicaCount2Recommended: '2 (Recommended)',
      replicaCountHint: 'Number of compute nodes that cache each tablet. Higher count = more redundancy but more disk usage.',
      cacheReplicationType: 'Cache replication type',
      replicationType: 'Replication Type',
      synchronous: 'Synchronous',
      synchronousDesc: 'New data is replicated to all replica nodes before transaction commits. Ensures all cache copies are always up-to-date.',
      asynchronous: 'Asynchronous',
      asynchronousDesc: 'New data commits to one replica first; others updated in background. Faster ingest but replicas may briefly lag.',
      cacheWarmupLevel: 'Cache warmup level',
      warmupLevel: 'Warmup Level',
      warmupNone: 'None',
      warmupNoneDesc: 'No preloading. New nodes start cold.',
      warmupMetadata: 'Metadata',
      warmupMetadataDesc: 'Preload tablet metadata only.',
      warmupIndex: 'Index',
      warmupIndexDesc: 'Metadata + data file footers. Best balance.',
      warmupAll: 'All',
      warmupAllDesc: 'Full data preload. High IO pressure.',
      servingTimeout: 'Serving Timeout',
      servingTimeoutHint: 'How long to wait for a restarted node to finish cache warmup before routing queries to it cold. Applies to all warehouses in this cluster.',
      diskUsageWarning: '{0} With {1} replicas, each tablet\'s local cache will be stored on {2} nodes instead of 1. Ensure compute nodes have sufficient local disk capacity.',
      diskUsageWarningTitle: 'Disk usage impact: ',
      diskUsageImpact: 'Disk Usage Impact',
      cacheDiskUsed: 'Cache Disk Used (per node avg)',
      primaryPlusReplica: 'Primary + replica cache',
      replicaOverhead: 'Replica Overhead',
      additionalDiskUsed: 'Additional disk used by replicas',
      enableBtn: 'Enable Compute Replica',
      enableSuccess: 'Compute Replica has been enabled successfully.',
      updateSuccess: 'Compute Replica has been updated successfully.',
      disableBtn: 'Disable Compute Replica',
      disableConfirmTitle: 'Confirm to disable Compute Replica?',
      disableConfirmContent: 'Once disabled, replica cache copies will be removed and query latency may increase during node restarts or failures.',
      disableSuccess: 'Compute Replica has been disabled.',
      saveChanges: 'Save Changes',
      nodeServingReadiness: 'Node Serving Readiness',
      node: 'Node',
      status: 'Status',
      tabletsServing: 'Tablets Serving',
      servingState: 'Serving State',
      degradedWarning: '{0} Queries to tablets previously served by {1} are being routed to replica nodes with warm cache. Query latency may increase slightly (~1.2x) until {2} completes warmup and returns to serving state.',
      degradedWarningTitle: '{node} is restarting.',
      degradedNodeInfo: '{node}\'s tablets are being served by replica cache on other nodes. Once {node} reaches the serving timeout ({timeout} min) or completes warmup, it will re-enter "Ready" state.',
    },
    editClusterName: {
      title: 'Edit cluster name',
      newName: 'New cluster name',
      editClusterNamePlaceholder: 'Enter your new cluster name',
    },
    storageAutoScaling: {
      title: 'Storage autoscaling policy',
      editTitle: 'Edit storage autoscaling policy',
      coordinatorEditTitle: 'Edit coordinator storage autoscaling policy',
      enabled: 'Enabled',
      disabled: 'Disabled',
      triggerUsage: 'Trigger usage',
      stepSize: 'Step size',
      maxSize: 'Max size',
      label: 'Storage autoscaling:',
      description: 'We strongly recommend keeping storage autoscaling enabled. Storage can fill up quickly due to unpredictable workloads, which may cause critical cluster failures. Storage autoscaling is required for SLA coverage. You can disable it later or adjust thresholds in the cluster resource scheduling settings.',
      classicNote: 'Note that enabling autoscaling for BE nodes may lead to a significant surge in storage expenses; thus, please exercise caution when specifying the step size of the scaling operations.',
      enableLink: 'Storage AutoScaling',
      intervalWarning: 'A minimum of {0} hours is mandatory as the interval between two scaling operations (including manual scaling and autoscaling). To prevent storage from reaching maximum capacity, make sure to allocate enough storage space in advance.',
      whenUsageGte: 'When storage usage >=:',
      rangeHint: 'range between 80 - 90',
      storage: '{0} Storage:',
    },
    deploymentCredential: 'deployment credential ',
    dataCredential: 'data credential ',
    credentialUpdateTipsTail: ' for cluster {0} is outdated, some console operations may not work well, you need to update the credential.',
    security: 'Security',
    securityTab: {
      privateLink: {
        title: 'Private connectivity using {privatelinkName}',
        enableButton: 'Enable public access',
        enableButtonDesc: 'You can disable public access to the Cluster console to ensure that all users access it via {privatelinkName}, securing the traffic instead of using the public internet. This approach protects all traffic between clients and the Cluster console, and is the recommended approach. Alternatively, you can enable public access if you prefer easier access to the Cluster console without additional network configuration.',
        seeMoreDesc: 'More information: {0}.',
        privateLinkDoc: 'Deploy cluster with end-to-end {privatelinkName}',
      },
      ipAccessList: {
        title: 'IP Access List',
        addRule: 'Add Rule',
        maxRulesTooltip: 'The maximum number of rules per cluster is 20. The number of rules can be reduced by merging the existing rules, or new IPs can be added to the existing rules.',
        description: 'Use the IP Access List to restrict access to the Open Cluster page to specific IP addresses or subnets. When there are zero allow lists, all IP addresses that were not blocked are allowed.',
        ruleName: 'Rule name',
        type: 'Type',
        allowed: 'allowed',
        blocked: 'blocked',
        statusLabel: 'Status',
        ipAddresses: 'IP Addresses',
        addRuleTitle: 'Add Rule',
        editRuleTitle: 'Edit Rule',
        ruleDescription: 'You can enter a valid IPv4 address with an optional CIDR, or multiple addresses in a comma-separated list.',
        allowRadio: 'Allow: specify the set of IP addresses on the public Internet that are allowed access',
        blockRadio: 'Block: specify IP addresses or subnets to block, even if they are included in the allow list',
        ruleNameLabel: 'Rule name',
        ruleNamePlaceholder: 'Enter your rule name',
        ipAddressesLabel: 'IP Addresses',
        ipAddressesPlaceholder: 'Example: 123.22.198.78/28, 2.2.2.2',
        deleteConfirmTitle: 'Confirm to delete the rule {name}?',
        deleteConfirmContent: 'All the IPs in this rule will be removed from the access control lists.',
        nameValidationError: 'The name must start with a letter, can only contain letters, numbers and underscores. The maximum length is 32.',
        ipValidationError: 'Wrong IP address format.',
        ipRequiredError: 'Please enter the IP addresses.',
      },
      securityPatch: {
        patches: {
          title: 'Security Patching',
          description: 'Patch versions and machine images available for this cluster. Schedules are computed from the cluster\'s maintenance windows.',
          colVersion: 'Version / AMI',
          colCriticalCves: 'Critical CVEs',
          colHighCves: 'High CVEs',
          colCves: 'CVEs addressed',
          colWindow: 'Scheduled window',
          colActions: 'Actions',
          machineImage: 'Machine image',
          patchVersion: 'Patch version',
          patchVersionRange: 'Patch version ({from} → {to})',
          hasCve: 'Yes',
          noCve: 'No',
          moreCves: '+{count} more',
          noWindowSet: 'No window set',
          noWindowSetTip: 'This cluster has no active maintenance window, so the patch cannot be scheduled automatically. Click to add a window, or apply the patch now.',
          overdue: 'Overdue',
          overdueTip: 'This patch is past its remediation SLA deadline of {date}.',
          overdueTipNoSla: 'This patch was not applied inside its scheduled maintenance window.',
          slaDeadline: 'SLA deadline: {date}',
          applyNow: 'Apply now',
          pickDate: 'Pick date',
          skip: 'Skip',
          urgentAuto: 'Applied automatically',
          urgentAutoTip: 'Urgent patches are applied immediately by PhoenixAI Cloud and cannot be rescheduled or skipped.',
          urgentFootnote: 'Urgent patches are applied immediately by PhoenixAI Cloud and reported here after the fact',
          empty: 'No security patches are pending for this cluster.',
        },
        history: {
          title: 'Applied in the last {days} days',
          colVersion: 'Version / AMI',
          colCves: 'CVEs addressed',
          colResolvedAt: 'Applied at',
          colTrigger: 'Trigger',
          colOutcome: 'Outcome',
          empty: 'No patches have been applied or skipped in this period.',
        },
        severity: {
          CRITICAL: 'Critical',
          HIGH: 'High',
          MEDIUM: 'Medium',
          LOW: 'Low',
        },
        trigger: {
          SCHEDULED_WINDOW: 'Scheduled',
          SYSTEM_URGENT: 'Urgent',
          APPLY_NOW: 'On demand',
          CUSTOM_DATE: 'Custom date',
        },
        outcome: {
          ONGOING: 'Ongoing',
          SUCCEED: 'Success',
          FAILED: 'Failed',
          SKIPPED: 'Skipped',
        },
        apply: {
          title: 'Apply {version} now?',
          cluster: 'Cluster: {name}',
          impactTitle: 'Expected impact',
          impactRolling: 'Rolling upgrade — nodes restart in sequence; queries continue where topology supports it.',
          impactSerial: 'Runs one patch operation at a time; blocked if another cluster operation is in flight.',
          impactPaused: 'A paused cluster is resumed, patched, then paused again.',
          duration: 'Estimated duration: 25–40 min. You\'ll get an email with the outcome.',
          confirm: 'Apply now',
          dispatched: 'Patch dispatched. You will get an email with the outcome.',
        },
        skip: {
          title: 'Skip {version}?',
          warningTitle: 'Skipping leaves this cluster exposed',
          warningBody: 'The fixes in this patch are not applied, and the cluster stays on its current version. The skip is recorded in the Security section and audit log.',
          reasonLabel: 'Reason (optional)',
          reasonPlaceholder: 'e.g., dev cluster, retiring in Q3',
          confirm: 'Skip patch',
          skipped: 'Patch skipped. The decision is recorded in the patch history.',
        },
        pickDate: {
          title: 'Reschedule {version}',
          subtitle: 'Includes {severity} CVE fixes — remediation SLA: {date}',
          subtitleNoSla: 'Includes {severity} CVE fixes',
          subtitleSlaOnly: 'Remediation SLA: {date}',
          dateAndTimeLabel: 'Date and time',
          dateLabel: 'Date',
          datePlaceholder: 'Select a date',
          timeLabel: 'Time',
          timezoneLabel: 'Timezone',
          dateRequired: 'Please select a date.',
          slaWarningTitle: 'This date is past the remediation SLA',
          slaWarningBody: '{date} is {days} days past the {severity} SLA ({deadline}) for CVEs in this patch. Critical CVEs may be deferred by up to 1 month and High CVEs by up to 2 months, and never by more than 3 months. The move is flagged and recorded for compliance.',
          acceptRisk: 'I accept the risk of operating past the remediation SLA',
          acceptRiskHint: 'Confirm is enabled after you accept the risk.',
          confirm: 'Confirm date',
          rescheduled: 'Patch rescheduled to {date}.',
        },
        windows: {
          cardTitle: 'Security patch maintenance windows',
          desc: 'A patch is scheduled into the earliest active window. Every window on this cluster {0}, {1}. Each window is otherwise configured and saved on its own.',
          descRecurrence: 'shares one recurrence — weekly or monthly',
          descFirstWindow: 'set when the first one is created',
          emptyTitle: 'No maintenance window',
          emptyDesc: 'Patches cannot be scheduled automatically until a window exists. You will be notified when a patch is available and will have to apply it manually. The first window also sets the recurrence — weekly or monthly — that every later window follows.',
          addWindow: 'Add window',
          addFirstWindow: '+ Add your first window',
          colWindow: 'Window',
          colTimezone: 'Timezone',
          colRecurrence: 'Recurrence',
          colStatus: 'Status',
          colActions: 'Actions',
          weekly: 'Weekly',
          monthly: 'Monthly',
          active: 'Active',
          paused: 'Paused',
          edit: 'Edit',
          resume: 'Resume',
          editWindow: 'Edit window',
          pauseWindow: 'Pause window',
          deleteWindow: 'Delete window',
          weeklyLabel: '{day} · {start} – {end}',
          monthlyLabel: 'Day {day} · {start} – {end}',
          monthlyDayShort: 'Day {day}',
          crossesMidnight: '{duration} · crosses midnight',
          deleteConfirmTitle: 'Confirm to delete this maintenance window?',
          deleteConfirmContent: 'Patches will no longer be scheduled into {window}. A patch already scheduled into it is re-planned into the next active window.',
          pauseConfirmTitle: 'Confirm to pause this maintenance window?',
          pauseConfirmContent: 'While paused, no patch is scheduled into {window}. The window keeps its configuration and can be resumed at any time.',
        },
        windowForm: {
          addTitle: 'Add maintenance window',
          editTitle: 'Edit maintenance window',
          recurrenceLabel: 'Recurrence',
          recurrenceLockedHint: 'Every maintenance window on a cluster uses the same recurrence.',
          dayAndTimeLabel: 'Day and time',
          dayOfWeekLabel: 'Day of week',
          dayOfMonthLabel: 'Day of month',
          dayOfMonthPlaceholder: 'Select day of month',
          timeLabel: 'Time',
          to: 'to',
          minDurationHint: 'Minimum 2 hours.',
          minDurationError: 'A maintenance window must be at least 2 hours long.',
          sameDayError: 'A maintenance window must start and end on the same day.',
          timezoneLabel: 'Timezone',
          timezoneHint: 'Each window keeps its own timezone.',
          save: 'Save window',
          created: 'Maintenance window created.',
          updated: 'Maintenance window updated.',
          deleted: 'Maintenance window deleted.',
          pausedMessage: 'Maintenance window paused.',
          resumedMessage: 'Maintenance window resumed.',
        },
        daysOfWeek: {
          monday: 'Monday',
          tuesday: 'Tuesday',
          wednesday: 'Wednesday',
          thursday: 'Thursday',
          friday: 'Friday',
          saturday: 'Saturday',
          sunday: 'Sunday',
        },
      },
    },
    del: 'Delete cluster',
    ccuPrice: 'CCU per hour',
    host: 'Node host',
    insType: 'Instance type',
    cpu: 'vCPU (core)',
    mem: 'Memory (GB)',
    volCount: 'Volume count',
    volSize: 'Volume size (GB)',
    nodeCount: 'Node count',
    suspendDialogText: 'Suspending your cluster will preserve the name and endpoint, but the suspended cluster will not execute queries or consume CCUs. All the virtual machine resources in your VPC will be terminated. Confirm to suspend cluster {0} ?',
    suspendDialogTitle: 'Suspend cluster',
    suspendClusterDialogTitle: 'Confirm to suspend the cluster {clusterName}?',
    suspendClusterDialogText: 'Once suspended, the cluster will stop running and release computing resources, and all the warehouses in it will be suspended. No workloads can be submitted to suspended clusters. You can manually resume it again when you use it next time.',
    resumeClusterDialogTitle: 'Confirm to resume the cluster {clusterName}?',
    resumeClusterDialogText: 'This process takes about 2 minutes, please be patient.',
    cancelResumeClusterTitle: 'Confirm to cancel resume the cluster {clusterName}?',
    cancelResumeWarehouseTitle: 'Confirm to cancel resuming the warehouse {name}?',
    resumeMultiWarehouseCluster: 'Only the default warehouse will be resumed.',
    resetPwd: 'Reset password',
    resetPwdDialogTitle: 'Reset password for admin user',
    resetPwdDialogErrTitle: 'Sorry, you can’t reset the password',
    resetPwdDialogText: 'If you have forgotten the password for the cluster admin user and want to reset it, you can type or generate a new password. This new password will replace the existing password.',
    resetPwdDialogErrText: 'You can only reset the admin user password when the cluster is running. Please resume your cluster first, then try again.',
    resetPwdDialogUser: 'SQL User',
    resetPwdDialogPwd: 'New password',
    resetPwdDialogConfirm: 'Reset & Save',
    generatePwd: 'Generate password',
    resetPwdDialogErr: 'Password is required',
    pwdFormatError: 'The password is required and should be between 8 and 16 characters in length using a mix of letters, numbers, and symbols. The symbols we support are !{\'@\'}#$%^&*_',
    editSizeNeedRunningTip: 'You can edit the cluster when the cluster is running.',
    noPermisTip: 'You do not have permission to perform this operation. Please contact the administrator.',
    crossAccountNoPermisTip: 'You do not have permission to perform this operation.',
    freeTierDialog: {
      title: 'Free Tier Cluster Limitation',
      desc: 'Please note that you are currently using a free tier cluster! This free tier cluster is permanently free, but once you choose to expand the cluster, it will no longer be free. ',
      desc_freetrial: 'Please note that you are currently using a free tier cluster! This free tier cluster is permanently free, but once you choose to expand the cluster, it will no longer be free at the end of the 30-day free trial period.',
      desc_confirm: 'Enter \'Confirm\' to edit the cluster, whether the cluster expands or not, it will no longer be a free tier cluster.',
    },
    modal: {
      title: 'Confirm to release cluster',
      releaseTips: 'This action will release the cluster from your PhoenixAI Cloud account.',
      release: 'Release',
    },
    prolicy: {
      title: 'Update policy for {0}',
      tip: 'When data/deployment credentials become outdated, certain dependent features may not function properly, and creating a new cluster with outdated credentials is also impossible. To resolve this issue, update the policy associated with the data/deployment credential role in AWS or attach a newer version of the policy directly. Once the update is complete, confirm by clicking "I have updated in AWS". Since the system cannot verify the actual policy update in AWS, ensure that the policy has been updated correctly.',
      confirm: 'I have updated in AWS',
      current: 'Current version:',
      default: 'Newest version:',
    },
    release: {
      modal: {
        title: 'Confirm to release this cluster?',
        desc1: 'All workloads currently running in your cluster will be stopped once it has been released, and PhoenixAI no longer charges you for their services. ',
        desc2: 'The data in your cluster is no longer accessible. To avoid irreparable data loss, we advise backing up your cluster before releasing it. ',
        desc3: 'All associated {cspName} Cloud resources will be automatically released by PhoenixAI. ',
        desc4: 'To confirm the release, enter the cluster name in the text input field. ',
        desc5: 'Cluster name:',
        check: 'Automatically release associated AWS Cloud resources',
      },
    },
    toggle: {
      modal: {
        title: 'Confirm to {0}',
      },
    },
    info: {
      title: 'Deployment credential',
      Credential: {
        method: 'Credential method',
        acID: 'Trust account ID',
        externalID: 'External ID',
        arn: 'IAM role ARN',
      },
      property: {
        title: 'Cluster properties',
        id: 'Cluster ID',
        name: 'Cluster name',
        csp: 'Cloud provider',
        region: 'Region',
        cspAndRegion: 'Cloud provider/Region',
        type: 'Cluster type',
        version: 'Version',
        state: 'Status',
        clusterOwner: 'Cluster owner',
        owner: 'Cluster owner',
        time: 'Created at',
        endpoint: 'Service endpoint',
        queryPort: 'Query port',
        suspend: 'Cluster idle suspend',
        suspendEnableValue: 'Suspend after {minute} minutes',
        timeZone: 'Time zone',
      },
      versionTag: {
        ga: 'GA',
        preview: 'Preview',
        stable: 'Stable',
      },
      config: {
        title: 'Cluster size',
        feCount: 'FE node count',
        feType: 'FE node type',
        feStorageType: 'FE storage type',
        beCount: 'BE node count',
        beType: 'BE node type',
        beStorageType: 'BE storage type',
      },
      elasticConfig: {
        title: 'Cluster size',
        feCount: 'Coordinator node count',
        feType: 'Coordinator node type',
        feStorageType: 'Coordinator storage type',
        warehouseCount: 'Warehouse count',
        beCount: 'Compute node count',
        beType: 'Compute node type',
        beStorageType: 'Compute storage type',
        diskCapacity: 'Total disk capacity',
      },
      connection: {
        title: 'Connection',
        titleDesc: 'Use the dropdowns to find out how to build the connection between the cluster and your applications. Different network environments need different cluster domain names.',
        JDBC: 'JDBC URL',
        Client: 'Client command',
        help: 'Help me connect',
        endpoint: 'Endpoint',
        qPort: 'Query port',
        ssl: 'SSL Connection',
        sslEnable: 'More information on viewing this cluster\'s SSL certificate: ',
        sslEnableLink: 'Connect to an SSL-enabled cluster',
        dialog: {
          subtitle: 'General connection string',
          subtitleDesc: 'PhoenixAI supports the MySQL protocol, and you can choose `MySQL` as the datasource type that your BI Application will connect with. Then use the following connection string to your cluster. Before building the connection, make sure the security group allows connections. More details: ',
          subtitleLinkTxt: 'Connect from a client application to PhoenixAI Cloud',
          tip: 'Use the cluster username like `admin` and password to access the cluster.',
          hint: '`Database` is an option, you can configure it as the target database like `catalog.database`',
          title: 'Connect to {0}',
          networkMethod: 'Network method',
          connectionOption: 'Select connection option',
          mysqlClient: 'MySQL Client',
          jdbc: 'JDBC',
          ingestionNoteBeforeHttps: 'For data ingestion methods like stream load or flink connector, you need to use ',
          ingestionNoteAfterHttps: ' protocol for higher security in PhoenixAI Cloud. Please refer to the documentation ',
          ingestionNoteLinkTxt: 'here',
          ingestionNoteAfterLink: ' for more details.',
        },
        failed: 'PhoenixAI failed to allocate domain name to this cluster, you can choose to ',
        ongoing: 'PhoenixAI is allocating domain name to this cluster, this process takes about 3 minutes.',
        retry: 'retry again.',
        hover: 'PhoenixAI encountered an error while allocating a domain name to the cluster due to the maximum number of load balancers being reached in the same AWS account.',
      },
      usage: {
        price: 'Cluster price',
        priceDesc: 'Current runtime price per hour',
        usage: 'Cluster usage',
        usageDesc: 'Month-to-date usage',
        warehouse: 'Warehouse activity status',
        warehouseDesc: 'The running quantity in the total',
        disk: 'Disk usage',
        diskDesc: 'Current disk usage',
        total: 'Cluster storage',
      },
      usagStorage: {
        used: 'Disk Usage',
        total: 'Disk Total',
      },
      usagStorageTips: {
        classic: 'PhoenixAI clusters use disk to store self-managed table data file. The metrics display the usage per node. Disk space shrinkage is mainly caused by system reservation.',
        elastic: 'PhoenixAI clusters use disk to cache data files located in object storage. The metrics display the usage per node. Disk space shrinkage is mainly caused by system reservation.',
      },
      usageDailyDelta: {
        title: 'Data volume change',
        todayData: 'Today data delta',
        yesterdayData: 'Yesterday data delta',
      },
      overview: {
        recentActivity: 'Recent Activity',
        clusterUsageTrend: 'Cluster usage trend (Last 7 days)',
        warehousePrice: 'Warehouse price',
        monthlyWarehouseUsage: 'Monthly warehouse usage',
        warehouseNodes: 'Warehouse nodes',
        runningQuantity: 'The running quantity in the total',
        resourceUtilization: 'Resource utilization',
        averageCpuUtilization: 'Average CPU utilization of all compute nodes',
        instanceSize: 'Instance size',
        warehouseProperties: 'Warehouse properties',
        groupSize: 'Group size',
        warehouseSize: 'Warehouse size',
        owner: 'Owner',
        resumeOn: 'Resumed on',
        idleSuspend: 'Idle suspend',
        usageTrend: 'Usage trend',
        nodeCountTrend: 'Node count trend',
        nodeCount: 'Node Count',
        lastDays: 'Last {0} days',
        diskUsageLocalCache: 'Disk usage (for local cache)',
        occupiedSpace: 'Ocupied space',
        remainingCapacity: 'Remaining capacity',
      },
      editSize: 'Edit size',
    },
    credential: {
      title: 'Deployment credential',
      titleTip: 'Describe how PhoenixAI Cloud impersonates your cloud account during the deployment and scaling process so PhoenixAI Cloud can launch cloud resources like virtual machines and load balancers in your cloud account.',
      info: {
        title: 'Deployment credential',
        name: 'Name',
        method: 'Credential method',
        accID: 'Trust account ID',
        exID: 'External ID',
        role: 'IAM role ARN',
      },
      sk: {
        title: 'Credential information',
        method: 'Credential method',
        key: 'AWS Access Key',
        secretKey: 'AWS Secret Key',
      },
      network: {
        title: 'Network configuration',
        titleTip: 'Describe the virtual network and network access policy of your cluster.',
        name: 'Name',
        subnet: 'Subnet ID',
        sg: 'Security group ID',
        nlbSg: 'Security group ID for NLB',
        vpc: 'VPC endpoint ID',
      },
      storage: {
        title: 'Data credential',
        titleTip: 'Describe how this cluster integrates with your own cloud storage in scenarios like data loading & unloading, backup & restore, querying data in your cloud storage, or table creating (especially for elastic clusters).',
        name: 'Name',
        bucketName: 'Bucket name',
        profileArn: 'Instance profile ARN',
      },
      invalidPolicyType: 'Invalid policy type, please refresh and try again',
      invalidCredentialId: 'Invalid credential id, please refresh and try again',
    },
    azureCredential: {
      info: {
        title: 'Deployment credential',
        titleTip: 'Describe how PhoenixAI Cloud impersonates your cloud account during the deployment and scaling process so PhoenixAI Cloud can launch cloud resources like virtual machines and load balancers in your cloud account.',
        name: 'Name',
        TID: 'Directory (tenant) ID',
        AID: 'Application (client) ID',
        clientSecret: 'Client secret value',
        sshID: 'SSH Key resource ID',
        update: 'Updated at',
      },
      network: {
        title: 'Network configuration',
        titleTip: 'Describe the virtual network and network access policy of your cluster.',
        name: 'Name',
        VNID: 'Virtual network resource ID',
        subnetName: 'Subnet name',
        resourceGroup: 'Resource group resource ID',
      },
      storage: {
        title: 'Data credential',
        titleTip: 'Describe how this cluster integrates with your own cloud storage in scenarios like data load & unloading, backup & restore, querying data in your cloud storage, or table creation (especially for elastic clusters).',
        name: 'Name',
        MID: 'Managed identity resource ID',
        storageAccName: 'Storage account name',
        containerName: 'Container name',
      },
    },
    gcpCredential: {
      info: {
        title: 'Deployment credential',
        name: 'Name',
        method: 'Credential method',
        accID: 'Grant access to',
        exID: 'Project ID',
      },
      network: {
        title: 'Network configuration',
        titleTip: 'Describe the virtual network and network access policy of your cluster.',
        name: 'Name',
        subnet: 'Subnet name',
        sg: 'Network tag',
        vpc: 'PSC connection ID',
      },
      storage: {
        title: 'Data credential',
        titleTip: 'Describe how this cluster integrates with your own cloud storage in scenarios like data loading & unloading, backup & restore, querying data in your cloud storage, or table creating (especially for elastic clusters).',
        name: 'Name',
        bucketName: 'Bucket name',
        profileArn: 'Instance service account',
      },
    },
    delete: {
      del: 'Remove',
      title: 'Confirm to delete the cluster?',
      desc: 'This action will drop the service, but not free up all the computing and storage resources in your cloud. All of the data will be dropped too.',
    },
    deployment: {
      statusTitle: 'Deployment status',
      feTitle: 'Instance status (FE nodes)',
      elasticFeTitle: 'Instance status (Coordinator nodes)',
      beTitle: 'Instance status (BE nodes)',
      elasticBeTitle: 'Instance status (Compute nodes)',
      search: 'Search your instance',
      availabilityZone: 'Availability zone',
      nodeType: 'Node type',
      terminated: 'terminated',
      restartRollingConfirmTitle: 'Restart the {nodeType}',
      restartRollingConfirmContent: 'This action will restart all the {nodeType}. You may experience a temporary, minimal performance impact. Do you want to continue?',
      restartNodesDialogTitle: 'Restart nodes of {label}',
      restartScopeAll: 'All nodes',
      restartScopeSpecific: 'Specific node',
      nodeHost: 'Node host',
      restartSingleNodeConfirmTitle: 'Restart the node {host}',
      restartSingleNodeConfirmContent: 'This action will restart the node {host} of {label}. You may experience a temporary, minimal performance impact. Do you want to continue?',
      idle: {
        title: 'Auto-suspend on idle',
        desc: 'When the cluster remains idle, PhoenixAI will automatically suspend the cluster as a cost-saving measure. Learn more ',
        warehouseDesc: 'When the warehouse remains idle, PhoenixAI will automatically suspend the warehouse as a cost-saving measure. Learn more about',
        builtinWarehouseDesc: 'The builtin warehouse does not support defining a warehouse-level suspend policy on its own; you need to suspend/resume it together with the whole elastic cluster. If you want to edit the suspend policy of this cluster, you can navigate to',
        idleDoc: 'Idle suspend',
        suspend: 'Idle suspend',
        gap: 'Idle suspend after',
        minutes: 'Idle suspend after (minutes):',
        warehouseManualResume: 'After the warehouse is suspended, you must resume it manually.',
        updateSuccess: 'Updated successfully',
        dialog: {
          title: 'Edit auto-suspend on idle',
          warehouseTitle: 'Edit suspend policy',
          auto: 'Auto-suspend on idle',
          gap: 'Idle suspend after (min)',
        },
      },
      schedule: {
        title: 'Scheduling policy',
        create: 'Create scheduling policy',
        createTips: 'PhoenixAI will automatically suspend the cluster to save the majority of costs on EC2 (only EBS costs will be incurred) and resume the cluster for usage as scheduled.',
        dialog: {
          title: 'Create scheduling policy',
          edit: 'Edit scheduling policy: ',
          name: 'Policy name',
          nameTips: 'Enter your policy name',
          desc: 'Description',
          descTips: 'Enter your policy description (optional)',
          timeZone: 'Time zone',
          day: 'Active days',
          dayTips: 'Configure the days for the cluster to always be on. ',
          time: 'Active time',
          timeTips: 'Configure the hours for the cluster to auto-resume or auto-suspend.',
          resumeTime: 'Resume at',
          suspendTime: 'Suspend at',
          latest: 'Latest run',
          pleaseEnterPolicyName: 'Please enter policy name',
          nameMaxLength: 'name must be 1-32 characters',
        },
        table: {
          enable: 'Enabled',
          action: 'Action',
          emptyText: 'No scheduling policies',
          removeTips: 'The action will permanently delete the scheduling policy and can’t be undone. Are you sure about this?',
        },
      },
    },
    azureDeployment: {
      schedule: {
        createTips: 'PhoenixAI will automatically suspend the cluster to save the majority of costs on virtual machine instances (only cloud disk costs are incurred) and resume the cluster for usage as scheduled.',
      },
    },
    gcpDeployment: {
      schedule: {
        createTips: 'PhoenixAI will automatically suspend the cluster to save the majority of costs on virtual machine instances (only Persistent Storage costs are incurred) and resume the cluster for usage as scheduled.',
      },
    },
    edit: {
      title: 'Configure the deployment',
      tabs: {
        deployment: 'Deployment',
        nodeDistribution: 'Node distribution',
      },
      sNodeType: 'Node type',
      sOPType: 'Operation type',
      nodeInsType: 'Node instance type',
      editTips: 'The operation causes changes to your instances, this will take some time.',
      changeType: 'Change type',
      targetNodeType: 'Target node type',
      changeDetails: 'Change details',
      storageTips: 'Your disk (capacity/IOPS/throughput) can only be modified once every {0} hours. Please try again later.',
      coordinator: 'Coordinator',
      compute: 'Compute',
      coordinatorNode: 'Coordinator node',
      computeNode: 'Compute node',
      coordinatorNodeCount: 'Coordinator node count',
      computeNodeCount: 'Compute node count',
      scaleInOut: 'Scale in/out',
      scaleUpDown: 'Scale up/down',
      add: 'add',
      decommiss: 'decommiss',
      changeNodeTypeWarning: 'This modification will change {0} node type to your cluster and take some time.',
      changeNodeCountWarning: 'This modification will {0} {1} nodes to your cluster and take some time.',
      dialog: {
        title: 'Commit {0} changes?',
        opTitle: 'You are going to {0} your {1}.',
        storageOpTitle: 'You are going to {0}.',
        storageNumOpTitle: 'Changing the number of disks will result in a RESTART of cluster nodes.',
        diskTypeChangeTips: 'This action will invalidate the cluster cache and may affect the query performance.',
        feScaleTitle: 'You are going to scale up/down your cluster with interruptions.',
        storagesTips: 'This operation is restricted by the cloud provider and requires a waiting period after execution.',
        instanceStorageTips: 'This operation will cause changes to your instances and take some time. Storage size can only be changed once every 6 hours. Please note this and choose the suitable storage size.',
        feOpTips: 'This operation requires maybe three minutes of waiting time, please be patient.',
      },
      nodeDistribution: {
        title: 'Configure the node distribution',
        policy: 'Node distribution policy',
        subnetId: 'Subnet ID',
        specifyAzDesc: 'Please select the subnet of corresponding availability zone to be deployed. Nodes will be deployed in the availability zone you select.',
        evenlyDesc: 'Nodes will be evenly distributed across availability zones of {0}.',
        notRunning: 'Not Running',
        policyChanges: 'Commit warehouse changes?',
        policyChangesWarning: 'The redistribution of nodes will cause the computing nodes to restart. The service may be interrupted. Please operate with caution.',
      },
      noChanges: 'No changes',
      changesTooSmall: 'Changes too small',
      instancesChanging: 'It looks like there are instances in your cluster that are undergoing changes, please wait a moment.',
      convertMultiAz: {
        createModal: {
          title: 'Create multi-AZ network configuration',
          inheritedFrom: 'Inherited from the current network configuration',
          additionalSubnet: 'Additional subnet',
          checkFirst: 'Run Check to validate the new subnets before you can save.',
          whySubnets: 'A multi-AZ cluster requires at least three nodes deployed across different availability zones, so a minimum of 3 subnets is required.',
          additionalZone: 'Availability zones',
          zonesPlaceholder: 'Select 3 availability zones',
          currentZoneTag: 'current',
          zoneTypeUnavailable: '{0} not available in this zone',
          checkFirstZones: 'Select 3 availability zones and run Check to validate them before you can save.',
          whyZones: 'A multi-AZ cluster requires at least three nodes deployed across different availability zones, so a minimum of 3 availability zones is required.',
          notEnoughZones: 'This region does not have enough availability zones offering the coordinator node type to build a 3-AZ network configuration.',
          zonesFetchFailed: 'Failed to load the availability zones for this region.',
          unknownCurrentZone: 'Cannot determine the availability zone the cluster currently runs in.',
          unknownCoordinatorType: 'Cannot determine the coordinator node type, so the availability zones cannot be validated against it.',
          namePlaceholder: 'Enter a name for the new network configuration',
          nameInvalid: 'Name must start with a letter and contain only letters, digits, hyphens or underscores (max 128 characters).',
        },
        networkConfig: 'Network configuration',
        createFromCurrent: '+ Create multi-AZ config from current config',
        noEligibleNetworks: 'No eligible multi-AZ network configuration found for this cluster\'s region and credential. Create one from the current configuration.',
        confirmTitle: 'Commit multi-AZ conversion?',
        convertDesc: 'Converting redistributes coordinator nodes across the availability zones of the selected network configuration.',
        scaleOutNodesHint: 'This will add {0} coordinator (FE) node(s) to reach 3 across the availability zones.',
        coordinatorCountUnsupported: 'Multi-AZ conversion requires a supported coordinator (FE) node count: 1 (which will be scaled out to 3), 3, 5, or any count from 6 to 11. This cluster has {0}.',
        convertWarning: 'Converting to multi-AZ redistributes coordinator nodes across availability zones with a rolling replacement. The cluster may experience brief disruption during the process — please proceed with caution.',
        subnetsSummaryTitle: 'Subnets / AZs',
        subnetsAzsCount: '{0} subnets · {1} AZs',
        azsSummaryTitle: 'Availability zones',
      },
    },
    param: {
      staticConfigTitle: '{0} Node static configuration',
      viewAll: 'View all parameter list',
      applyToAll: 'Apply to all nodes',
      description: 'You can customize static parameters related to StarRocks process behavior. After configuration, you must manually restart the cluster or select {0} for the parameters to take effect. {1} will forcefully restart the running cluster nodes.',
      lastApply: 'Last apply',
      lastEdit: 'Last edit',
      dialogDescription: 'PhoenixAI Cloud only supports customized configuration of parameters related to process behavior, and infrastructure-related parameters are managed by PhoenixAI Cloud on behalf of users. For specific parameter meanings and usage methods, please refer to:',
      parameterKey: 'Parameter key',
      value: 'Value',
      newParameter: 'New parameter',
      parameterKeyRequired: 'The parameter key is required.',
      parameterKeyInvalid: 'The parameter key "{0}" is invalid.',
      parameterKeyManaged: 'The parameter key "{0}" is managed by PhoenixAI Cloud and does not support modification.',
      parameterKeyDuplicated: 'The parameter key "{0}" is duplicated.',
      parameterValueRequired: 'The parameter value is required.',
      parameterValueInvalid: 'The parameter value "{0}" is invalid.',
      managedConfigError: 'The static configurations related to ports and storage volumes are not allowed to be modified by users and are centrally managed by the PhoenixAI Cloud.',
      applyConfirmTitle: 'Confirm to apply static configuration?',
      applyConfirmContent: 'This operation will restart all {0} nodes in the current {1} one by one, which will take some time (depending on total nodes count).',
      applyConfirmText: 'Yes, I want to apply now.',
      applyErrorTitle: 'Sorry, you can\'t apply the static parameters to this {0}',
      applyErrorContent: 'You can only apply the {0} node static parameters to the running {1}. For non-running {2}, PhoenixAI Cloud will automatically apply the latest static parameters configuration the next time it is resumed.',
      applyErrorConfirmText: 'OK, I will restart the cluster later.',
      parameterKeyPlaceholder: 'Enter prefix of the key to search',
      parameterValuePlaceholder: 'The value should be {0}.',
      parameterValueFormattedExample: 'The parameter value for "{0}" should be formatted as: {1}.',
      searching: 'Searching...',
      noResults: 'No matching results found',
      unmanagedKeyTip: 'Not a managed key. The value is not validated — an invalid value may prevent the node from starting on its next restart.',
      parameterKeyChecking: 'Still verifying this parameter key. Please wait a moment and try again.',
      others: {
        title: 'Cluster Configuration',
        supportAccess: 'Cluster access for PhoenixAI personnel',
        supportAccessDesc: 'You can control whether PhoenixAI can access your cluster for support purposes. If you have disabled access, no PhoenixAI personnel will be able to gain access to your cluster.',
        supportTableCaseInsensitive: 'Case Insensitive',
        supportTableCaseInsensitiveDesc: 'When enabled, all related names will be stored in lowercase, and all SQL commands containing these names will automatically convert them to lowercase. This configuration is available only during the cluster creation process and cannot be modified later.',
        supportQueryAuditLog: 'Query Audit Logs',
        supportQueryAuditLogDesc: 'You can stream audit log files for queries directly into StarRocks tables for SQL-based analysis. This feature can be enabled or disabled as needed. Be aware that enabling audit log streaming will use additional system resources.',
        supportArrowFlight: 'Arrow Flight',
        supportArrowFlightDesc: 'You can enable the cluster to interact with Arrow Flight SQL for data ingestion and export. Once enabled, the Arrow Flight requests need to be sent to port 443 when accessing through the Endpoint.',
        enableArrowFlightConfirmTitle: 'Confirm to enable Arrow Flight?',
        disableArrowFlightConfirmTitle: 'Confirm to disable Arrow Flight?',
        operationArrowFlightConfirmContent: 'This action restarts nodes in the current cluster one at a time. The process may take several minutes, depending on the total number of nodes.',
        arrowFlightNotAvailable: 'ArrowFlight is only available for clusters with versions 3.5.14+ or 4.0.7+. Please request an upgrade to this cluster to access this feature.',
        jwtAuth: 'JWT Auth',
        jwtAuthDesc: 'Enable JWT-based single sign-on for this cluster. When turned on, anyone signed in to PhoenixAI Cloud — with any login method — will be able to sign in to this cluster using their email as the StarRocks username.',
        jwtAuthNotRunning: 'The cluster must be in the Running state to enable JWT Auth.',
        jwtAuthUnsupportedVersion: 'The current cluster StarRocks version does not support JWT Auth. Please upgrade the cluster.',
        jwtAuthDisableNotAllowed: 'JWT Auth can only be turned off when the cluster is in Running or Suspended state.',
        disableJwtAuthConfirmTitle: 'Confirm to disable JWT Auth?',
        disableJwtAuthConfirmContent: 'After disabling, JWT-based single sign-on to this cluster will stop working.',
        jwtAuthDisabledSuspendedTip: 'Disabled. The FE configuration will be removed after the cluster is resumed.',
        excludeReadFromLeader: 'Exclude Read Traffic to FE Leader',
        excludeReadFromLeaderDesc: 'When enabled, traffic for read behavior will route to follower nodes, excluding the leader node. Only applicable with more than one FE.',
      },
      opsWindow: {
        title: 'Window of time for software operations and maintenance',
        description: 'During this period of time, the PhoenixAI technical support team will perform on-demand maintenance and upgrade operations on your cluster.',
        timezone: 'Time Zone (offset from UTC)',
        time: 'Time',
        days: 'Days:',
      },
      tag: {
        desc: 'You can add {tagName} to your {cspName} {instanceName} to help you identify, organize, and search for resources. Each {tagName} consists of a key and a value.',
        policyTooltip: 'You need to update your deployment credential policy to edit tags. Click the "Outdated" button to update the policy.',
        limitTip: 'You have reached the maximum number of tags',
        autoTag: 'Automatic tags',
        autoLabel: 'Automatic labels',
        autoTagDesc: 'These tags are automatically created by PhoenixAI Cloud and cannot be modified.',
        autoLabelDesc: 'These labels are automatically created by PhoenixAI Cloud and cannot be modified.',
        failedTitle: 'Failed to update tags',
        failedDesc1: 'The update failed with the following error: {0}',
        failedDesc2: 'This may be because your deployment credential policy does not have the necessary permissions. Please refer to our {0} or update your policy in {1}.',
        failedDesc3: 'After updating the policy, try again.',
      },
      tde: {
        title: 'Transparent Data Encryption (TDE) configuration',
        desc: 'You can change the authentication method and related configurations to access your Master Key which is a KMS key. After the reconfiguration, you must restart the cluster by hand or click {0} for the new authentication configurations to take effect. Clicking {1} will result in a restart of all nodes.',
        changeButton: 'Change authentication',
        dialogTitle: 'Change TDE authentication',
        dialogDesc: 'You can change the authentication to access your TDE Master Key which is a KMS key, but you can\'t change the Master key, or shutdown the TDE feature.',
        dialogConfirmation: 'Confirmation: I understand that the TDE authentication is very important, and I\'m sure I want to change the authentication.',
        dialogConfirmationError: 'Please confirm that you understand the importance of the TDE authentication.',
        applyConfirmTitle: 'Confirm to apply to all nodes?',
        applyConfirmContent: 'This action will restart all nodes in the current cluster one by one, which will take some time (depending on total nodes count).',
        applyConfirmText: 'Yes, I want to apply now.',
        applyStartMessage: 'Start applying the TDE parameter configurations.',
        applyErrorTitle: 'Sorry, you can\'t apply the TDE configurations to the cluster.',
        applyErrorContent: 'You can apply TDE parameter configurations only when the cluster is running. If the cluster is not in Running state, its latest TDE parameter configurations will be applied the next time when it is restarted.',
        applyErrorConfirmText: 'OK, I will restart the cluster later.',
        testSuccess: 'Success.',
        testFailedError: 'Failed to check the permission of the TDE authentication to access your Master key. You probably can\'t do any queries or data ingestion if the TDE authentication is not set well.',
      },
      ranger: {
        title: 'Apache Ranger integration',
        applyConfig: 'Apply configuration',
        cleanConfig: 'Clean configuration',
        description: 'To enable the Apache Ranger integration when using an external catalog, place the ranger-related configuration files ( {0} and {1} ) in the cloud storage related to the cluster data credential. The cluster FE node (or coordinator node) will automatically pull and apply the configuration from the files every time the cluster is resumed.',
        lastUpdated: 'Last updated',
        configFileLocation: 'Configuration file location',
        dialogTitle: 'Configure your source file location',
        gcpUploadText: 'Upload {0} and {1} to your cloud storage bucket below.',
        awsUploadText: 'Place files {0} and {1} under the same location in your data credential related AWS S3 bucket.',
        azureUploadText: 'Place files {0} and {1} under the same location in your data credential related Azure Storage.',
        gcpStorageBucket: 'Cloud storage bucket:',
        awsStorageBucket: 'Data credential related S3 bucket:',
        azureStorageBucket: 'Data credential related Azure Storage:',
        configFilePrefix: 'Configuration file prefix:',
        gcpPlaceholder: 'Enter the file location like gs://celerdata-s3-test-lg/path/to/*****.xml',
        awsPlaceholder: 'Enter the file location as s3://<bucket>/a/b',
        azurePlaceholder: 'Enter the file location as azblob://storage_account_name/container_name/a/b',
        testButton: 'Test',
        accessFailedError: 'Failed to access file. Please check whether your cluster node instance can access the cloud storage associated with your current cluster\'s data credentials.',
        testSuccessTip: 'XML file has been accessed successfully. You can now apply the changes. The cluster {nodeType} nodes will restart sequentially to ensure that the configuration changes take effect. Please note that this process will take some time.',
        cleanConfirmTitle: 'Confirm to clean the Ranger configuration?',
        cleanConfirmContent: 'This operation will remove all Ranger-related configuration files in the current cluster. And restart the {nodeType} nodes one-by-one.',
      },
    },
    autoScaling: {
      policyTitle: 'Autoscaling Policy',
      editPolicyTitle: 'Edit autoscaling policy',
      enableAutoScaling: 'Enable Auto Scaling for your warehouse.',
      policyDesc: 'When enabled, this policy will automatically scale the number of {0}, based on {1} of the warehouse.  Learn more about these here: {2}.',
      levelNode: 'Compute Node',
      levelGroup: 'Compute Node Group',
      strategyPolicy: 'the autoscaling strategy you chose',
      cpuPolicy: 'CPU utilization based',
      cpuPolicyCondition: 'CPU utilization',
      queuePolicy: 'Query queue based',
      queuePolicyCondition: 'queue',
      queuePolicyMetrics: 'warehouse resource utilization',
      scaleInPolicyContent: 'The policy only works when the {0} count is greater than the lower bound of the scaling range.',
      scaleInStepLimitTips: 'A maximum of two Compute Nodes can be scaled in per step, avoiding significant fluctuations in cluster performance.',
      scaleInStepLimitTipsOfGroup: 'A maximum of two Compute Groups can be scaled in per step, avoiding significant fluctuations in cluster performance.',
      scaleOutPolicyContent: 'The policy only works when the {0} count is less than the upper bound of the scaling range.',
      enableAutoScalingDocs: 'Enable Auto Scaling for your warehouse',
      enableQueueCPUAutoScalingDocs: 'Enable elastic model in elastic cluster based on CPU utilization strategy',
      enableQueueBasedAutoScalingDocs: 'Enable Auto Scaling for your warehouse',
      scaleIn: 'scale in',
      scaleOut: 'scale out',
      editPolicyDesc: 'With autoscaling, PhoenixAI will dynamically adjust the number of compute nodes for the specific warehouse, based on the autoscaling strategy you have chosen for the warehouse. Learn more about these here:',
      autoscaling: 'Autoscaling',
      scalingRange: 'Scaling range',
      scalingPolicy: 'Scaling policy',
      scalingRangeDesc: 'The lower and upper bounds of the Compute Node scaling range is {0} and {1}',
      commonCondition: 'When {0} remains {1} {2}% over {3} seconds',
      cpuAutoScaleTrigger: '{0} {1} {2} per step when {3} remains {4} {5} over {6} seconds;',
      multiTriggerConditions: 'either of the following conditions is met:',
      singleTriggerConditions: 'the following condition is met:',
      queueScaleOutTrigger: 'scale out {0} {1} is triggered if {2}',
      queueTriggerCondition1: 'The queue is not empty and the earliest query has been waiting for more than {0} seconds over',
      queueTriggerCondition2: 'The queue length exceeds {0}',
      queueScaleInTrigger: 'scale in {0} {1} is triggered if {2}',
      queueScaleOutCondition: 'The queue length {0} exceeds {1} or the earliest query has been waiting for more than {2} seconds',
      groupAutoscalingQueueTarget: 'for the Warehouse',
      queueScaleOutNote: 'Note: The maximum queue length is 1024, so the queue length threshold must be set below this limit. Once the queue reaches full capacity, new queries will be immediately rejected. The maximum wait time for a query in the queue is 300 seconds. To ensure timely auto-scaling, the scaling timeout should be set below 300 seconds—ideally no more than 180 seconds to account for scaling latency.',
      queueLengthTooltip: 'The maximum queue length is 1024, so the queue length threshold must be set below this limit. Once the queue reaches full capacity, new queries will be immediately rejected.',
      waitTimeTooltip: 'The maximum wait time for a query in the queue is 300 seconds. To ensure timely auto-scaling, the scaling timeout should be set below 300 seconds—ideally no more than 180 seconds to account for scaling latency.',
      scaleOutStepTooltip: 'A maximum of 100 Compute Nodes can be scaled out per step, avoiding significant fluctuations in cluster performance.',
      cpuDurationTooltip: 'The minimum duration is 300 seconds.',
      scaleTip: '{0} {1} {2} per step',
      scaleOutInvalidTip: 'The maximum of {0} nodes per cngroup specified in the policy is {1} the current {2} nodes per cngroup of this warehouse. The autoscaling policy of scale out is not effective.',
      scaleInInvalidTip: 'The minimum of {0} nodes per cngroup specified in the policy is {1} the current {2} nodes per cngroup of this warehouse. The autoscaling policy of scale in is not effective.',
      policyTakeEffectLimit: 'The scaling policy will only take effect when the warehouse is running.',
      cpuPolicyInvalid: 'The CPU utilization upper limit of Scale out policy must be greater than the lower limit of Scale in policy',
      multiAzTopologyUnknown: 'This warehouse\'s availability zones could not be determined, so autoscaling ranges cannot be calculated for it. Reload the page; if the problem persists, contact support.',
      equationCaption: 'Choose what autoscales — click a factor of the warehouse-size equation:',
      cngroupSize: 'cngroup size',
      cngroupCount: 'cngroup count',
      cngroups: 'cngroups',
      nodesPerCngroup: 'nodes / cngroup',
      warehouseNodes: 'warehouse nodes',
      total: 'total',
      computeNodeScalingRange: 'the {0} scaling range: {1} ~ {2}',
      computeNodeScalingRangePerCngroup: 'the {0} scaling range: {1} ~ {2} per cngroup ({3} ~ {4} nodes across the warehouse)',
    },
    scheduledScaling: {
      policyTitle: 'Scheduled Scaling Policy',
      editPolicyTitle: 'Edit scheduled scaling policy',
      policyDesc: 'When enabled, this policy will automatically scale the number of Compute Nodes based on the schedule you defined. Learn more about these here: {0}.',
      enableScheduledScaling: 'Enable Scheduled Scaling for your warehouse',
      policyName: 'Policy name',
      policyDescription: 'Policy description',
      warehouseConfiguration: 'Warehouse Configuration',
      warehouseSize: 'Warehouse size',
      target: 'Target',
      targetNodesPerCngroup: '{0} nodes / cngroup',
      targetCngroups: '{0} cngroups',
      scaleTargetCaption: 'Choose what this schedule sets — click a factor of the warehouse-size equation:',
      countRangeHint: 'Between {0} and {1} cngroups ({2} per AZ at most).',
      sizeRangeHint: '1–100 nodes per cngroup, up to 1,000 nodes in total.',
      countNotSupported: 'Scheduling by cngroup count needs the multi-cngroup feature and is not available for cross-AZ warehouses.',
      nodeCapExceeded: 'A warehouse can have at most 1,000 nodes.',
      countTopologyUnknown: 'This warehouse\'s availability zones could not be determined, so it cannot be scheduled by cngroup count. Reload the page; if the problem persists, contact support.',
      autoscalingOnTip: 'Autoscaling is on for this warehouse. When the schedule ends, the warehouse is not restored to its previous size, and autoscaling on the same factor may scale it back in during the window.',
      schedule: 'Schedule',
      once: 'One-time',
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
      selectDaysOfWeek: 'Days of week',
      selectDaysOfMonth: 'Days of month',
      selectDaysOfOnce: 'Select the date',
      timeTips: 'Configure the time for the policy to be active and end',
      startTime: 'Start time',
      endTime: 'End time',
      configureTimeForPolicy: 'Configure the time for the policy to be active and optionally end',
      enabled: 'Enabled',
      action: 'Action',
      edit: 'Edit',
      emptyText: 'No scheduled scaling policies',
      createPolicy: 'Create scheduled scaling policy',
      policyNamePlaceholder: 'Enter policy name',
      policyDescriptionPlaceholder: 'Enter policy description (optional)',
      pleaseSelectScheduleType: 'Please select schedule type',
      pleaseSelectDays: 'Please select at least one day',
      pleaseEnterStartTime: 'Please enter start time',
      pleaseEnterEndTime: 'Please enter end time',
      pleaseEnterWarehouseSize: 'Please enter warehouse size',
      warehouseSizeInvalid: 'Warehouse size must be a positive integer',
      timeRangeInvalid: 'End time must be after start time',
      timeDurationInvalid: 'The minimum duration of the scaling strategy is 1 hour.',
      operationSucceeded: 'Operation succeeded',
      deletePolicyConfirmTitle: 'Delete scheduled scaling policy',
      deletePolicyConfirm: 'The action will permanently delete the scheduled scaling policy and can\'t be undone. Are you sure you want to proceed?',
      policyEnabled: 'Policy enabled',
      scheduleType: 'Schedule type',
      selectStartTime: 'Please select the start time',
      selectEndTime: 'Please select the end time',
      policyDescriptionLengthLimit: 'The policy description must be less than 1000 characters',
      oncePlaceholder: 'Please select the date',
      timeOverlapWarning: 'The time range of the current policy overlaps with the time range of the existing policy `{0}`. Please make the necessary revisions and try again.',
    },
  },
  addCluster: {
    title: 'Bring PhoenixAI to your own cloud',
    subTitle: 'Quickly create a PhoenixAI cluster and get started!',
    step1: 'Configure the cluster resources',
    step2: 'Set up your {cspName} credentials',
    step3: 'Configure access to the cluster',
    step4: 'Deploy the cluster in your {cspName} cloud',
    addNodeTypeTip: 'For stability reasons, using {0} is only recommended for testing clusters.',
    step: {
      1: {
        sizeTitle: 'Cluster size',
        addTagTip: 'Add tag',
        addLabelTip: 'Add label',
        mainTitle: 'Step1: Define your cluster size and location  ',
        title: 'CONFIGURE YOUR CLUSTER',
        name: 'Cluster name',
        beIops: 'BE disk IOPS',
        beThroughput: 'BE disk throughput',
        freeTierDoc: 'Learn about free tier cluster',
        freeTierDocOfClassic: '{0} or {1} to learn more',
        tryFreeCluster: 'Try free cluster size',
        freeTier1: 'You have opted for the Free Developer Tier (0 CCU). This tier comprises {0} Frontend (FE) with {1}c{2}g and {3} Backend (BE) instance {4}c{5}g, but excludes technical support. You only need to pay the cloud provider for cluster related infrastructure.',
        freeTier1Elastic: 'You have opted for the Free Developer Tier (0 CCU). This tier comprises {0} Coordinator node with {1}c{2}g and {3} Compute node instance {4}c{5}g, but excludes technical support. You only need to pay the cloud provider for cluster related infrastructure.',
        freeTier2: 'Scaling of the Free Developer Tier cluster is restricted until unlocked. To scale out or up the cluster, you must first exit the Free Developer Tier, which cannot be rejoined once you have left.',
        freeTier3: 'Please note that each PhoenixAI account is limited to one single Free Developer Tier cluster at any given time.',
        nameRequire: 'Cluster name is required',
        nameCheckFailed: 'Failed to verify the cluster name, please try again',
        tagNameRequire: 'The key is not allowed to be empty in tags, please edit again.',
        tagValueRequire: 'The tag value is required.',
        tagSpacesLimit: 'No spaces are allowed in the key and value of the tag, please edit again.',
        sameTagLimit: 'The same key is not allowed in tags, please edit again.',
        interSameTagLimit: 'The tag name cannot be the same as the internal tag name, like Vendor, Creator, ClusterName, WarehouseName{0}.',
        warehouseTagSameAsClusterLimit: 'The warehouse tag name cannot be the same as the cluster tag name, like {0}.',
        clusterTagSameAsWarehouseLimit: 'The cluster tag name cannot be the same as the warehouse tag name, like {0}.',
        tagValueLengthLimit: 'The value is limited to 256 characters.',
        awsTagNameLimit: 'The name cannot start with aws:.',
        awsTagRules: 'The {0} can only contain letters, numbers, spaces and any of the following: _.:/=+{\'@\'}-',
        awsTagNameLengthLimit: 'The name is limited to 128 characters.',
        labelNameRequire: 'The key is not allowed to be empty in labels, please edit again.',
        labelValueRequire: 'The label value is required.',
        sameLabelLimit: 'The same key is not allowed in labels, please edit again.',
        interSameLabelLimit: 'The label names cannot be the same as the internal label name, like vendor, cluster-name, warehouse-name{0}.',
        warehouseLabelSameAsClusterLimit: 'The warehouse label name cannot be the same as the cluster label name, like {0}.',
        clusterLabelSameAsWarehouseLimit: 'The cluster label name cannot be the same as the warehouse label name, like {0}.',
        labelValueValidate: 'The label values can only include lowercase letters (a-z), numbers, hyphens (-), and underscores (_).',
        labelNameLengthLimit: 'Label names are limited to 2 - 63 characters.',
        labelValueLengthLimit: 'Label values are limited to 63 characters.',
        labelNameValidate: 'The label names must start with a lowercase character, and can only include lowercase letters (a-z), numbers, hyphens (-), and underscores (_).',
        beStorageRequire: 'Be storage type is required',
        beStorageSizeRequire: 'Be storage size is required',
        regionRequire: 'AWS region is required',
        feRequire: 'FE instance type is required',
        beRequire: 'BE instance type is required',
        beCountSizeRequire: 'BE node count is required',
        nameExist: 'Name exists',
        namePlaceholder: 'Enter a cluster name',
        region: 'AWS region',
        regionPlaceholder: 'Select your region to deploy',
        srVersion: 'PhoenixAI enterprise version',
        srVersionPlaceholder: 'Select version',
        previweVersionTip: 'This version is in preview and is not recommended for production workloads. Clusters running preview versions are not covered by SLAs.',
        size: 'Cluster initial size',
        ha: 'FE HA mode',
        feNode: 'FE instance type',
        feNodePlaceholder: 'Select your FE instance type',
        beNode: 'BE instance type',
        beNodePlaceholder: 'Select your BE instance type',
        beStorage: 'BE storage type',
        beStorageSize: 'BE storage size',
        customizeDiskSize: 'Customize number of volumes',
        diskDistribution: '{0} volume count * {1} volume size',
        beDiskDescription: '{0}GB per node ({1}GB * {2})',
        beNodeCount: 'BE node count',
        beStorageCount: 'BE storage count',
        clusterPrice: 'Cluster software costs per hour:',
        userLimitation: 'Notes on Cloud Resource Management',
        additionalDocText: 'PhoenixAI Cloud leverages infrastructure in a VPC to deploy services. There are some considerations for maintaining cluster-related infrastructure. {0}.',
        reviewPrice: 'Review cost details',
        costDetailTitle: 'Cluster software cost details',
        manual: 'Manual deployment',
        costDesc: 'The cluster is charged {0} (per hour) for the software costs by PhoenixAI. The total software cost will be calculated based on the hourly cluster cost and the total running time of the cluster. You also need to pay the cloud provider for the additional infrastructure (such as virtual machine instances) costs associated with this cluster.',
        feCost: 'FE nodes cost:',
        beCost: 'BE nodes cost:',
        storageCost: 'Storage cost:',
        costUnit: 'CCU/Hour',
        distributionPolicyRequire: 'Select your node distribution policy',
        multipleAZ: 'Multiple availability zone',
        multiAZTrafficWarning: 'If multi-AZ deployment is selected, additional traffic charges may occur.',
        coordinatorNodeCount: 'Coordinator node count',
        productionHATip: 'In a production environment, we suggest that you turn it on to obtain complete SLA protection.',
        cpuArchitecture: 'CPU architecture',
        gravitonBasedTip: 'Create cluster with Graviton-based {0} to save more {1} cost.',
        advanceSettings: 'Advanced Settings',
        caseInsensitive: 'Case Insensitive',
        terminationProtection: 'Termination Protection',
        skipInitScriptFailure: 'Skip Init Script Failure',
        nodeDistributionPolicy: 'Node Distribution Policy',
        autoAddedTags: 'Automatically added tags',
        autoAddedLabels: 'Automatically added labels',
        clusterTags: 'Cluster tags',
        clusterLabels: 'Cluster labels',
        byocResourceManagementNote1: 'PhoenixAI Cloud will deploy resources and provide subsequent database services within your cloud account using a cross cloud account approach based on your trust. This means that throughout the entire cluster usage process (including subsequent software upgrades, scale in/out/up/down of cluster nodes, cluster suspend/resume, and disk capacity expansion), you must use the PhoenixAI Cloud console or the PhoenixAI Cloud OpenAPI provided by PhoenixAI to complete it, rather than directly manipulating the corresponding cloud resources within your own cloud account.',
        byocResourceManagementNote2: 'If you bypass PhoenixAI and directly make changes to cloud resources, it may result in the unavailability of cluster services. For this situation, PhoenixAI will not provide an SLA during the period before your operation on cloud resources is rolled back.',
        readConfirmation: 'Yes, I have read it.',
        elasticFrameTitle: 'Multi-warehouses based elastic cluster is coming now!',
        startCreatingDeployment: 'Start creating your deployment',
        multiAZLimitWarning: 'At least three availability zones are required.',
        azArchitecture: {
          coordinator: 'Coordinator node',
          compute: 'Compute node',
          az: 'AZ-{0}',
        },
        tips: {
          caseInsensitive: 'After enabling this feature, all related names will be stored in lowercase, and all SQL commands containing these names will automatically convert them to lowercase.',
          terminationProtection: 'Checking this box will protect your cluster from deletion. Refer to docs for more information:',
          terminationProtectionLink: 'About Termination Protection',
          skipInitScriptFailure: 'When enabled, a failed initialization or post-deploy script will not fail the deployment — the cluster continues and the failure is logged. When disabled (default), a script failure fails the cluster into the Abnormal state.',
          name: 'The cluster name must be unique within the account.',
          srVersion: 'Select the PhoenixAI Enterprise version to deploy. Stable versions are recommended for production environments, while Preview versions contain the latest features and improvements.',
          releaseMaturity: 'Learn what GA, Stable, and Preview mean — click to view docs',
          ha: 'PhoenixAI Cloud will provide SLA service only if you have turned on HA mode. After you turn on the switch, three FE nodes will be deployed to achieve higher availability.',
          feNode: 'FEs use Amazon Elastic Block Store (EBS) as storage to ensure that metadata files can be restored in the event of failures.',
          beNode: 'The BE node is responsible for the execution of distributed computing, and EBS is used for persistent storage of table data. In general, a virtual machine instance with CPU:RAM=1:4 will be recommended. We suggest selecting a virtual machine with 4 or more vCPUs.',
          beStorage: 'BEs support only the storage provided by the same servers on which the BEs reside.',
          beStorageSize: 'Disk storage size per node',
          perNode: 'per node',
          perDisk: 'per disk',
          beStorageNum: 'Storage volume number per BE node',
          beNodeCount: 'You can configure the BE count based on the estimated size of your data',
        },
        quickDeployment: {
          tip: 'For easier, faster deployment, try {0}',
          quickStartAWS: 'Quick deployment by CloudFormation',
          quickStartGCP: 'Quick deployment',
          quickStartAZURE: 'Quick deployment',
          generate: 'Generate CloudFormation',
          tagCheck: '(Optional) I want to add AWS Tags to this CloudFormation',
          new: {
            tabName: 'Deploy in a new VPC',
          },
          existing: {
            tabName: 'Deploy in an existing VPC',
          },
          deploymentAWS: {
            title: 'Quick deployment',
            tip1: 'You are choosing to deploy your new cluster in a new VPC that the AWS will automatically create.',
            tip2_new: 'PhoenixAI automatically creates an AWS CloudFormation template to describe the resources such as EC2 instances, VPC, credentials, and S3 buckets required for the cluster deployment. You only need to click the following link to the AWS CloudFormation console and create a stack as prompted.',
            tip2_existing: 'You choose to deploy your new cluster in an existing VPC. After entering the AWS CloudFormation console, you can select your preferred VPC and subnet, and the cluster will be deployed in the selected VPC and subnet.',
            tip3: 'If you are not authorized to launch AWS CloudFormation-related resources, copy the link and provide it to a user with the required permissions.',
            btn_create_cluster: 'Start',
          },
          deploymentGCP: {
            title: 'Quick deployment',
            tip1: 'Enter your GCP Project ID to generate a Terraform script for deploying a PhoenixAI Cloud cluster.',
            tip2_new: 'Click {0} to save the terraform script locally or click {1} to generate a signed URL for later download. Both options provide the Terraform script required for deploying PhoenixAI Cloud cluster in your GCP Account.',
            tip2_existing: '',
            tip3: 'Once downloaded,  upload the terraform script to a GCS bucket in your GCP project. Ensure you have a {0} Permission on the GCP project.',
            tip4: 'Click {0} to open the GCP Infrastructure manager and reference the GCS bucket where you uploaded the script. Ensure that the GCP infrastructure manager is enabled in your account to proceed with cluster creation.',
            project_id: 'Your GCP Project ID',
            btn_download_url: 'Generate URL',
            btn_create_cluster: 'Create Cluster',
            download_url: 'Download URL',
          },
          finishAWS: {
            title: 'Finish the AWS CloudFormation creation',
            tip1: 'Creating a stack in AWS CloudFormation takes a few minutes. Do not leave the current PhoenixAI page before the stack creation finishes. If you leave, the PhoenixAI deployment may fail unexpectedly.',
            tip2: 'If the stack creation fails, check whether your AWS account has the required permissions.',
            tip3: 'Click {0} after the stack is created.',
          },
          finishGCP: {
            title: 'Finish the GCP Infrastructure Manager Session',
            tip1: 'Creating the cluster in GCP infrastructure manager takes a few minutes. Do not leave the current PhoenixAI page',
            tip2: 'before the cluster creation finishes. If you leave, PhoenixAI Deployment may fail unexpectedly.',
            tip3: 'Click {0} after the deployment is created.',
          },
        },
        beCountCompute: {
          title: 'How many nodes do I need?',
          phrase1: 'Please provide us with the necessary information, so that we can estimate the required number of BE nodes for your specific use case. ',
          phrase2: 'Note: We would strongly recommend memory-optimized instances for data lake usage.',
          useCase: 'Use case',
          useCases: {
            biReport: 'BI Reports',
            dataLake: 'Data lake',
            databaseAPI: 'Database API',
            others: 'Others',
          },
          scanRows: 'Typical scan volume of each query',
          scanRowsUnit: 'million lines',
          responseTime: 'Expected response time',
          responseTimeUnit: 'seconds',
          queries: 'Queries Per Second (QPS)',
          instanceCore: 'Cores per instance',
          instanceCoreUnit: 'cores',
          beNumber: 'Recommended node count',
        },
      },
      2: {
        mainTitle: 'Step 2: Configure credentials to allow PhoenixAI Cloud to manage your necessary {cspName} resources',
        storageTitle: 'Data credential',
        storageTitleTips: 'When a PhoenixAI cluster is executing queries, a query profile will be generated for each query.\n The query profile can help users to diagnose slow queries and find the query performance\'s bottleneck. All this query profile information will be stored in S3.\n During the deployment process, the user needs to configure the Data credential. This data credential will be associated with a role embedded in EC2\'s instance profile which enables EC2 to directly read/write to the specific S3 bucket.',
        reuseStorage: 'Reuse data credential',
        reuseStoragePlaceholder: 'Choose your data credential',
        confName: 'Data credential name',
        confNamePlaceHolder: 'Enter a data credential name',
        bucketName: 'Bucket name',
        sharedVPC: {
          switchLabel: 'Does your deployment involve Shared VPCs:',
          fromServiceProject: 'from Service Project',
          ofServiceProject: 'of Service Project',
        },
        bucketNamePlaceHolder: 'Enter the name of your bucket',
        bucketNameValidation: {
          empty: 'Bucket name is required',
          length: 'Bucket name must be between 3 and 63 characters long',
          standardRule: 'Bucket names can consist only of lowercase letters, numbers, dots (.), and hyphens (-).',
          startEnd: 'Bucket names must begin and end with a letter or number.',
          dashperiod: 'Bucket name must not contain dash next to period.',
          ipaddress: 'Bucket name must not resemble an IP address.',
          periods: 'Bucket name must not contain two adjacent periods.',
          uppercase: 'Bucket name must not contain uppercase characters.',
          prefix: 'Bucket names must not start with the prefix {0}.',
          suffix: 'Bucket names must not end with the suffix {0}.',
          gcpBuckeSymbolValid: 'Can’t use a dot (.) next to a hyphen (-) or another dot.',
          gcpBucketValid: 'Bucket names can only include lowercase letters, numbers, hyphens (-), and underscores (_). Dots (.) may be used to form a valid domain name.',
          gcpBucketDomainNameValid: 'Domain names must be between 3 and 222 characters.',
        },
        storageARN: 'Instance profile ARN',
        storageARNPlaceHolder: 'Paste your instance profile ARN',
        storageARNErr: 'Instance profile ARN is required',
        storageARNValidErr: 'Please check whether your instance profile ARN is valid',
        storageRoleARN: 'Role ARN',
        storageRoleARNPlaceHolder: 'Paste your data credential role ARN',
        storageRoleARNErr: 'Role ARN is required',
        storageRoleARNValidErr: 'Please enter a valid IAM role ARN, e.g. arn:aws:iam::123456789012:role/my-data-role',
        storageRoleARNAccountErr: 'The role must be in the same AWS account as the instance profile',
        instanceServiceAccount: 'Instance service account',
        instanceServiceAccountPlaceHolder: 'Paste your Instance service account',
        instanceServiceAccountErr: 'Instance service account is required',
        instanceServiceAccountValidErr: 'Please check whether your instance profile ARN is valid',
        sshIDValidErr: 'Please check whether your SSH key resource ID is valid',
        credentialTitle: 'Deployment credential',
        credentialTitleTips: 'During deployment and scaling, PhoenixAI cloud will auto launch and release EC2 resources in the user’s VPC. This process needs users to create the Deployment credential, which is associated with a cross-account IAM role. Based on this role, PhoenixAI will assume the user and operate the user\'s cloud resource.',
        title: 'Build the Connection with your AWS Cloud Account',
        reuse: 'Reuse deployment credential',
        reusePlaceholder: 'Choose your deployment credential',
        policy: 'IAM policy information',
        generatePolicy: 'Generate policy',
        wrongPolicy: 'We detected that the policy attached to the IAM role in the credential you chose no longer meets the PhoenixAI Cloud deployment requirements. We recommend that you drop this credential and create a new one.',
        credential: 'Credential method',
        arnErr: 'Role ARN is required',
        key: 'AWS Access Key',
        secretKey: 'AWS Secret Access Key',
        role: 'IAM role',
        upsertError: 'get credential ID failed, please try again',
        sk: 'AWS AK/SK',
        accID: 'Trust account ID',
        externalID: 'External ID',
        externalIDPlaceHolder: 'Input External ID here',
        accessTo: 'Grant access to',
        projectId: 'Project ID',
        projectIdPlaceHolder: 'Please input project ID here',
        projectIdPlaceValid: 'Project ID is required',
        projectIdValid: 'Please check whether the project ID is correct',
        ARN: 'Cross-Account Role ARN',
        normal: 'Subnet connectivity tests are normal. You can move to the next step',
        ARNPlaceHolder: 'Paste the ARN of your IAM role',
        reuseQuestion: 'Do you want to reuse the credentials that were automatically saved when a cluster was successfully created before?',
        reuseOption: 'Yes, I hope to reuse the previous credentials and cloud storage',
        notReuseOption: 'No, I need to manually create new credentials from scratch',
        tips: {
          bucketName: 'Enter the name of the bucket to store the cluster’s query profile information.',
          IAM: 'Copy and paste the policy template to attach it to your new role. The role template will change in conjunction with the bucket name you just enter.',
          arn: 'After you have created the role for the AWS Service of EC2 and attached the policy, copy the instance profile ARN for the role and paste it here.',
          depIAM: 'This policy will auto-generate based on the ARN information in the data credential. Copy this generated template to attach it to your cross-account role. If you reuse the credential, please make sure the cross-account role’s policy matches the role ARN in the data credential.',
          crossAc: 'After you have created the cross-account IAM role based on the trust account ID and external ID and attached the policy, copy the ARN of the IAM role and paste it here.',
        },
        tips1: {
          title: 'Set up the AWS data credential',
          phrase1: 'The PhoenixAI cluster generates a profile for each SQL Query. These profiles are stored in your AWS S3 bucket.',
          phrase2: 'On the PhoenixAI Cloud page, enter the name of your AWS S3 bucket, and click generate policy to generate a policy',
          phraseTDE: 'You can enable TDE to secure your data. See more information after enabling it.',
          phrase3: 'In the AWS IAM console, create an IAM role, during which you need to select AWS service in the Trusted entity type section, select EC2 in the Use case section, and attach the generated policy to the IAM role.',
          phrase4: 'After the IAM role is created, copy the instance profile ARN',
          phrase5: 'On the PhoenixAI Cloud page, paste the instance profile ARN of this IAM role to the Profile ARN field.',
          phrase6: 'More information: ',
          reuseTitle: 'Reuse data credential',
          reusePhrase: 'You can only reuse previously saved data credentials in the same cloud provider and region. These data credentials are bound one by one with specific cloud storage in your cloud account. After selecting the data credential, you need to select a corresponding deployment credential with the same name because there is a dependency relationship between them.',
          createAWSStorageConf: 'How to create a data credential',
        },
        elastictTips1: {
          title: 'Set up the AWS data credential',
          phrase1: 'Elastic PhoenixAI clusters store the self-managed table in your AWS S3 bucket. To enable compute nodes to read/write to your S3, you need to create a data credential or select an existing data credential.',
          phrase2: 'On the PhoenixAI Cloud page, enter the name of your AWS S3 bucket, and click generate policy to generate a policy',
          phrase3: 'In the AWS IAM console, create an IAM role, during which you need to select AWS service in the Trusted entity type section, select EC2 in the Use case section, and attach the generated policy to the IAM role.',
          phrase4: 'After the IAM role is created, copy the Instance Profile ARN',
          phrase5: 'On the PhoenixAI Cloud page, paste the Instance profile ARN of this IAM role to the Profile ARN field.',
          phrase6: 'More information:',
          phrase7: 'How to create a data credential',
        },
        tips2: {
          title: 'Set up the AWS deployment credential',
          phrase1: 'To ensure a successful deployment in your VPC, you must create new AWS Deployment credentials or select existing AWS Deployment credentials for PhoenixAI Cloud. If you create a new credential: ',
          phrase2: 'In {0} console, create a new policy based on the policy template in left.',
          awsiam: 'the AWS IAM',
          phrase3: 'In the AWS IAM console, create an IAM role, during which you need to select {0} in the {1}, select {2} in the {3} section, select {4} and paste the external ID copied from the PhoenixAI Cloud page to the External ID field in the Options section, and attach the policy you just created to the IAM role. After the IAM role is created, copy the ARN of the IAM role.',
          AWSAccountBold: 'AWS account',
          trustedBold: 'Trusted entity type',
          anotherAWSAccountBold: 'Another AWS account',
          aNAWSAccountBold: 'An AWS account',
          externalID: 'Require external ID',
          phrase4: 'Create an IAM role, and paste the ARN of the IAM role to the IAM role ARN field.',
          phrase5: 'If you reuse an existing credential, please make sure that a policy with the same policy template has been attached to this IAM role.',
          phrase6: 'More information: {0} ',
          reuseTitle: 'Reuse deployment credential',
          reusePhrase: 'You can only reuse previously saved deployment credentials in the same region. These credentials are bound to specific identities that exist under your cloud account, allowing PhoenixAI’s control plane to perform resource management operations within your cloud account. Please select a deployment credential with the same name based on the data credential you previously selected.',
          setupWithAWS: 'How to create a deployment credential.',
        },
      },
      3: {
        mainTitle: 'Step3: Define the cluster\'s network configuration and identity credentials of initial users',
        title: 'Set your Network and Access Configuration',
        titleTips: 'PhoenixAI cluster must be deployed in your Subnet. In network configuration, you need to configure which subnet this cluster is deployed in and use a security group to control how cluster nodes communicate with each other, and with external applications.',
        block1: 'Network configuration',
        reuse: 'Reuse network configuration',
        notReuse: 'No, help me create a new network configuration',
        VPC: 'VPC ID',
        checkErr: 'Check error',
        subnet: 'Subnet ID',
        subnetPlaceholder: 'Enter the ID of your subnet',
        SG: 'Security group ID',
        SGPlaceholder: 'Enter the ID of your security group',
        endpoint: 'VPC endpoint ID',
        subnetName: 'Subnet name',
        subnetNameSharedVPC: 'Subnet url',
        subnetNamePlaceholder: 'Enter the subnet name',
        subnetNamePlaceholderSharedVPC: 'Enter the subnet url',
        netTag: 'Network tag',
        netTagPlaceholder: 'Enter the network tag',
        PSC: 'PSC connection ID',
        PSCSharedVPC: 'PSC connection ID (from Shared VPC)',
        PSCPlaceholder: 'Enter the PSC connection ID',
        endpointPlaceholder: 'Enter the ID of your VPC endpoint',
        endpointOwner: {
          crossAccountTitle: 'Cross-account network configuration detected.',
          crossAccount: 'The cluster endpoint and your deployment credentials are in different networks. Ensure network connectivity is configured and maintained between the two networks for reliable cluster operations.',
          crossAccountAccounts: 'VPC endpoint account: {endpointAccount}. Deployment credential account: {deploymentAccount}.',
          unknown: 'PhoenixAI cannot find the VPC endpoint {endpoint} in your deployment account or in the account that owns it. Check that the endpoint ID is correct and that the endpoint is connected to the PhoenixAI endpoint service.',
        },
        availableZones: 'Availability zones',
        availableZonesPlaceholder: 'Please select three availability zones',
        availableZonesRequired: 'Please select availability zones',
        availableZonesLengthValid: 'You need select three availability zones.',
        tips: {
          subnet: 'Use the public subnet when connecting with applications and clients in a public network. Use the private subnet when connecting with applications and clients in the same VPC. See **How to create the network configuration**.',
          groupID: 'Inbound & outbound rules define the cluster communication with applications & clients.',
          vpcEndpoint: 'By default, PhoenixAI disables the VPC Endpoint and PhoenixAI Cloud’s control plane will communicate with the data plane in your VPC through the public network. Enable the VPC endpoint based on your security policy.',
          seeMore: 'More information:',
          vpcSeeMore: 'VPC endpoint for connection is a must if you set a private subnet. More information:',
        },
        block1Tips: {
          title: 'Set up the AWS Account Connection',
          phrase1: 'Because PhoenixAI needs to deploy the cluster in user’s VPC, thus during the deploying process, the user needs to define which {0} the cluster is deployed in. And {1} describes how these cluster nodes integrate with each other. More information about how to set up Subnet and Security Group, see {2}',
          subnetBold: 'Subnet',
          securityBold: 'Security Group',
          link1: 'Create a network configuration',
          phrase2: 'PhoenixAI Cloud\'s control plane service is deployed in PhoenixAI\'s VPC. By default the control plane communicates with your cluster through the public network. You can use a VPC Endpoint for increased security by using PrivateLink. More information {0} and {1}.',
          phrase3: 'More information {0}.',
          phrase3Link: 'Deploy cluster with end-to-end PrivateLink',
          link2: 'Create a VPC Endpoint for connection',
          link3: 'Create a VPC Endpoint for S3',
        },
        configurationTitle: 'Cluster configuration',
        timeZone: 'Cluster time zone',
        timeZonePlaceholder: 'Please select cluster time zone',
        timeZoneTipsTitle: 'How to choose the cluster’s time zone?',
        timeZoneTipsContent: 'If you create a cluster in a region with the time zone the same as all your users, just choose your users’ time zone. If you will create multiple clusters in different regions, or you have users across different time zones, it’s recommended to set the UTC time zone for unification.',
        block2: 'Cluster credential',
        user: 'Initial SQL username',
        password: 'Admin password',
        passwordError: 'Admin password is required',
        ssl: 'SSL connection',
        sslTips: 'Establish an SSL connection between the client and your cluster.',
        block2Tips: {
          title: 'How to set the cluster credential?',
          phrase1: 'During STEP3 in the deploying process, you need to configure the initialization password of {0} for the cluster. Then you can use this {1} to log in to the cluster. After configuring this, PhoenixAI Cloud will generate a password file for you. Please keep it confidential.',
          userBold: 'admin user',
          pwdBold: 'admin/password',
        },
        tagTip: 'Adding tags can help you identify the EC2 Instances created by PhoenixAI Cloud more clearly.  You can make the tags like these: e.g., Key : Product, Value : PhoenixAIAccount123',
        workspacePWD: 'Cluster Root Password',
        confirmPWD: 'Confirm the Root Password',
        noNat: 'No NAT gateway is detected, make sure that your subnet has access to the Internet to complete the deployment. More information:',
        noNatHow: 'How to set up the network configuration.',
        subnetErr: 'Network connection test failed! Please check whether the subnet ID that you entered is valid. More information:',
        subnetErrHow: 'How to set up the network configuration.',
        diffVPC: 'Network connection test failed! Please check whether your security group and your subnet reside in the same VPC. More information: ',
        diffVPCHow: 'How to set up the network configuration.',
        sgErr: 'Network connection test failed! Please check whether the security group ID that you entered is valid. More information: ',
        sgErrHow: 'How to set up the network configuration.',
        sgRuleErr: 'Network connection test failed! Please check whether appropriate inbound and outbound rules are added to your security group at the time of its creation. More information: ',
        sgRuleErrHow: 'How to set up the network configuration.',
        nlbGroupID: 'Security group ID for NLB',
        nlbGroupIDPlaceholder: 'Enter the security group ID for NLB separately',
        nlbGroupIDTips: 'You can set a separate security group for NLB against the FEs and BEs to gain fine granular security control. If not set, NLB uses the same security group ID as FEs and BEs.',
        advancedSettings: {
          title: 'Advanced security settings (VPC endpoint, separate SG, etc.)',
          enablePublicAccess: 'Public access to the Cluster console',
          enablePublicAccessTip: 'When public access is enabled, your users can access the Cluster console via the public internet. To enhance security, you can disable public access, requiring all users to access it via PrivateLink, which secures the traffic.',
        },
        vpcIDErr: 'Network connection test failed! Please check whether the VPC endpoint ID that you entered is valid. More information: ',
        vpcIDErrHow: 'How to create a VPC Endpoint.',
        vpcNameErr: 'Network connection test failed! Please check the service name that you configured in VPC Endpoint. More information: ',
        vpcNameErrHow: 'How to create a VPC Endpoint.',
        vpcSubnetErr: 'Network connection test failed!  Please check the subnet that you configured in VPC Endpoint. More information: ',
        vpcSubnetErrHow: 'How to create a VPC Endpoint.',
        vpcSGErr: 'Network connection test failed!  Please check the security group that you configured in VPC Endpoint. More information: ',
        vpcSGErrHow: 'How to create a VPC Endpoint.',
        roleErr: 'Network connection test failed! Please check whether your cross-account role\'s policy is valid. More information: ',
        roleErrHow: 'How to create a cross-account role?',
        publicNet: 'PhoenixAI detects that you are using a public subnet. To ensure a successful package download and deployment, PhoenixAI will automatically launch public IP addresses to your subnet.',
        privateSubnetErr: 'Network connection test failed! Please check whether the security group ID that you entered is valid. More information: ',
        privateSubnetErrHow: 'How to create a VPC Endpoint.',
        tde: {
          title: 'Enable TDE (based on AWS KMS)',
          masterKeyLabel: 'Master Key ARN',
          masterKeyPlaceholder: 'Enter your AWS KMS Key ARN',
          masterKeyTip: 'After you have created your KMS key for TDE, copy the ARN of the KMS key and paste it here.',
          masterKeyARNValidErr: 'Please check whether your master key ARN is valid',
          credentialTitle: 'Credential to access the Key',
          authLabel: 'Authentication',
          authTip: 'Choose the authentication method to access your KMS key. Generally, you can just select the Instance Profile for both simplicity and security.',
          regionLabel: 'AWS region',
          regionTip: 'Optional when The KMS Key region is the same as the cluster region.',
          trustLabel: 'IAM role you need to trust',
          trustTip: 'Your IAM role with permission to access your KMS key should trust this IAM role.',
          arnLabel: 'IAM role ARN',
          arnPlaceholder: 'Enter your IAM role ARN to access your KMS key',
          arnTip: 'After you create an IAM role, add the role as your KMS key user or attach the access policy to your IAM role, then paste the IAM role ARN here.',
          arnRequired: 'IAM role ARN is required.',
          arnValidErr: 'Please enter a valid IAM role ARN, e.g. arn:aws:iam::123456789012:role/my-kms-role',
          confirmation: 'Confirmation: I understand the Master Key is so important not to be deleted.',
          confirmationError: 'Please confirm that you understand the importance of the Master Key.',
          blockTipsTitle: 'Set up the TDE Configuration',
          blockTipsP1: 'You can set up {0} configurations to enable the TDE feature to secure your data. This reduces the risk of data breaches, and is also very easy to use. Please note that the option to enable or disable TDE can\'t be changed once a cluster is created. To set up TDE, follow these steps:',
          blockTipsP1Link: 'Transparent Data Encryption (TDE)',
          blockTipsP2: 'a. In {0} console, create a symmetric key and ensure the user/role has the permissions to access it.',
          blockTipsP2Link: 'the AWS KMS',
          blockTipsP3: 'b. Select an authentication method, enter the IAM role ARN if you choose "Assumed Role". See {0}',
          blockTipsP3Link: 'Assumed role-based authentication',
          blockTipsP4: 'Make sure that the Master Key MUST NOT be deleted, otherwise all your data will get lost. To enhance security, you can use a multi-region key.',
          blockTipsP5: 'More information: {0}',
          blockTipsP5Link: 'How to create a KMS key and configure the authentication method.',
        },
        mutilAzSubnetTips: 'If the default warehouse selects the single AZ mode, the compute nodes under the default warehouse will be deployed in the AZ where the primary subnet is located.',
        confirmNoNatTitle: 'Confirm to create this cluster without NAT Gateway?',
        confirmNoNatContent: 'Please confirm that your subnet can access the Internet through methods other than NAT Gateway.\n\n Enter \'Confirm\' in the text input field to continue.',
      },
      4: {
        1: '1. Connect with your account.',
        2: '2. Create the resource in your region.',
        3: '3. Deploy the PhoenixAI cluster in your VPC.',
        progress: 'Progress',
        title: 'Start the deployment',
        lodingTip: 'PhoenixAI Cloud is deploying the cluster in your VPC. This process will take about 3 minutes. Please wait patiently',
        failedTip: 'PhoenixAI Cloud failed to deploy the cluster',
        lastTimeTips: 'The deployment has been last for',
        subStep1: {
          1: 'Check the IAM Role ARN Configuration',
          2: 'Check the Subnet ID',
          3: 'Check the Security Group ID',
          4: 'Check the VPC Endpoint',
        },
        subStep2: {
          1: 'Launch EC2',
          error0: 'Creating EC2 resource failed. Please check whether your role policy is in cloud credential, and the data credential is valid.',
        },
        subStep3: {
          1: 'Distribute the installation package',
          2: 'Decompress the installation package',
          3: 'Deploy services',
          4: 'Initialize the cluster user (admin)',
          error0: 'Downloading the installation package timed out. Check whether your EC2 instance can connect to the Internet.',
          error1: 'Decompressing the installation package failed. Check whether your EC2 instance is in a normal state.',
          error2: 'Deployment failed. Check whether your EC2 instance is in a normal state and whether your security group is correctly configured.',
          error3: 'Initialization failed. Please retry the deployment.',
        },
        gcp: {
          subStep1: {
            1: 'Check the IAM Configuration',
            2: 'Check the Subnet name',
            3: 'Check the Network connectivity',
            4: 'Check the PSC Endpoint',
          },
          subStep2: {
            1: 'Launch VM',
            error0: 'Creating VM resource failed. Please check whether your IAM configuration is in the cloud credential, and the data credential is valid.',
          },
          subStep3: {
            1: 'Distribute the installation package',
            2: 'Decompress the installation package',
            3: 'Deploy services',
            4: 'Initialize the cluster user (admin)',
            error0: 'Unable to access google service to download the installation package. Refer to {0} to set proper private DNS zone and firewall rules.',
            error0LinkText: 'Configure Network for Private Access to Google APIs and Services',
            error1: 'Decompressing the installation package failed. Check whether your VM instance is in a normal state.',
            error2: 'Deployment failed. Check whether your VM instance is in a normal state and whether your firewall rules are correctly configured.',
            error3: 'Initialization failed. Please retry the deployment.',
          },
        },
      },
      failTo: 'Fail to ',
      elastic1: {
        ha: 'Coordinator HA mode',
        feNode: 'Coordinator node size',
        feNodePlaceholder: 'Select your Coordinator node size',
        beNode: 'Compute node size',
        beNodePlaceholder: 'Select your Compute node size',
        beNodeCount: 'Compute node count',
        beIops: 'Compute disk IOPS',
        beThroughput: 'Compute disk throughput',
        mountDiskTips: '(Optional) I want to mount cloud disk to increase the cache hit rate.',
        beDiskCapacity: 'Cloud disk capacity',
        basicTitle: 'Cluster basic configuration',
        beTitle: 'Initial warehouse',
        warehouseTip: 'Specify the instance type and number of compute nodes for the default warehouse named default_warehouse which will be created along with the cluster. The default warehouse executes all jobs by default if no warehouse is specified. More warehouses can be created later to run different queries in an isolated manner.',
        nodeCountTips: 'Don\'t know how to choose the suitable node count? {0} to learn more.',
        feCost: 'Coordinator cost:',
        beCost: 'Warehouse cost:',
        beCountSizeRequire: 'Compute node count is required',
        beRequire: 'Compute node size is required',
        beStorageSize: 'Compute storage size',
        feRequire: 'Coordinator node size is required',
        tips: {
          beStorageSize: 'Data disk size per node, please make sure that you have enough quota in your cloud account.',
          ha: 'PhoenixAI Cloud will provide SLA service only if you have turned on HA mode. After you turn on the switch, three coordinator nodes will be deployed to achieve higher availability.',
          feNode: 'Coordinator nodes use Amazon Elastic Block Store (EBS) as storage to ensure that metadata files can be restored in the event of failures.',
          beNode: 'Compute nodes don\'t persist internal tables. All the self-managed tables are persisted in object storage. The compute nodes are used to execute SQL jobs and cache self-managed internal tables and external tables.',
          beNodeCount: 'For trials, you can configure a single node; for production use, we suggest you deploy at least three compute nodes.',
        },
      },
      region: '{cloud} region',
      tagsTitle: '{cloud} {tag}',
      checkErr: {
        accessDenied: 'Access denied! Please check whether your across account role\'s policy is valid.',
        appErr: 'APP invalid. Please verify the Directory ID and the Application ID',
        appRoleErr: 'App permission verification failed. It seems that the app doesn\'t have the role named {0}. For more details, please refer to ',
        appRoleErrHow: 'Create a service principal for PhoenixAI on Azure.',
        managedIdentityErr: 'Manage identity invalid. Please verify the managed identity resource ID.',
        managedIdentityRoleErr: 'Manage identity permission verification failed. It seems that the managed identity doesn\'t have the role named {0}.',
        storageAccountErr: 'Storage account invalid. Please verify the Storage account name and ensure it belongs to the same subscription as the managed identity.',
        containerErr: 'Container invalid. Please verify the container name and ensure it belongs to the Storage account.',
        subnetErr: 'Subnet invalid. Please verify the Virtual network resource ID and the Subnet name.',
        sgErr: 'Security group invalid. Please verify the subnet has a security group configured.',
        sgRulesErr: 'Network access failed. Please refer to Create a virtual network, a subnet, and a security group for PhoenixAI on Azure and verify your security group rule configuration.',
        bucketErr: 'Your bucket must locate in the same region with your cluster! Please change a new bucket and try again.',
        bucketNotExist: 'The bucket {0} does not exist. Please check again.',
      },
      aws: {
        1: {
          region: 'AWS region',
        },
      },
      azure: {
        1: {
          tagsTitle: 'Azure resources tags',
          tagNameRules: 'The following characters are not supported: <>%&\\?/ and the following tag name prefixes are reserved: \'azure\', \'microsoft\', \'windows\'.',
          tagNameLengthLimit: 'Tag names are case-insensitive and are limited to 128 characters.',
          tagValueLengthLimit: 'Tag values are case-sensitive and are limited to 256 characters.',
          tips: {
            name: 'The cluster name must be unique within the account.',
            feNode: 'FEs use cloud disk as storage to ensure that metadata files can be restored in the event of failure.',
            beNode: 'The BE node is responsible for the execution of distributed computing, and the node\'s disk is also used for persistent storage of table data. In general, a virtual machine instance with CPU:RAM=1:4 will be recommended. We suggest selecting a virtual machine with 4 or more vCPUs.',
            beStorage: 'Select the total size of the disk you want to mount for each BE node. This will determine the total amount of data that your cluster can store.',
            beStorageSize: 'Select the total size of the disk you want to mount for each BE node. This will determine the total amount of data that your cluster can store.',
            perNode: 'per node',
            beStorageNum: 'Storage volume number per BE node',
            beNodeCount: 'The number of BE nodes. In a production environment, in order to make computing as parallel as possible while ensuring high availability of data replicas, we recommend deploying at least three BE nodes.',
          },
        },
        2: {
          topTitle: 'Deployment credential',
          bottomTitle: 'Data credential',
          subID: 'Subscription ID',
          subIDPlaceHolder: 'Enter your subscription ID here',
          appID: 'Application (client) ID',
          appIDTips: 'Enter the Application (client) ID of your App registration.',
          appIDPlaceHolder: 'Enter your client ID here',
          appIDErr: 'Please enter your client ID here',
          tenantID: 'Directory (tenant) ID',
          tenantIDTips: 'Enter the Directory (tenant) ID of your App registration.',
          tenantIDPlaceHolder: 'Enter your tenant ID here',
          tenantIDErr: 'Please enter your tenant ID here',
          sshResourceID: 'SSH Key resource ID',
          sshResourceIDTips: 'Enter the resource ID of the SSH key pair. Format: /subscriptions/xxxxxxxxx/resourceGroups/yyyyyy/providers/Microsoft.Compute/sshPublicKeys/zzzzz.',
          sshResourceIDPlaceHolder: 'Enter the resource ID of the SSH Key',
          sshResourceIDErr: 'Please enter the resource ID of the SSH Key',
          secret: 'Client secret value',
          secretTips: 'Enter the client secret value of the App registration. Client secret values cannot be viewed, except for immediately after creation. Be sure to save the secret before leaving the Azure console.',
          secretPlaceHolder: 'Enter the client secret value here',
          secretErr: 'Please enter the client secret value here',
          dataReuse: 'Reuse data credential',
          idResourceID: 'Managed identity resource ID',
          idResourceIDPlaceHolder: 'Enter your managed identity resource ID here',
          idResourceIDTips: 'Create your managed identity and copy the ID here. The format is like: \'/subscriptions/xxxxxxxxxxx/resourcegroups/yyyyyy/providers/Microsoft.ManagedIdentity/userAssignedIdentities/zzzz\'.',
          idResourceIDErr: 'Please enter your managed identity resource ID',
          storageName: 'Storage account name or ID',
          storageNameTips: 'Specify which storage account you want to use to store the SQL profile. If the storage account is in the same resource group as the cluster, enter its name. If it is in a different resource group, paste its full resource ID, for example: \'/subscriptions/xxxxxxxxxxx/resourceGroups/yyyyyy/providers/Microsoft.Storage/storageAccounts/zzzz\'.',
          storageNamePlaceHolder: 'Enter your storage account name or resource ID here',
          storageNameErr: 'Enter a valid storage account name (3-24 lowercase letters or numbers), or a full storage account resource ID whose account name meets the same rule.',
          containerName: 'Container name',
          containerNameTips: 'Specify which container you want to use to store the SQL profile.',
          containerNamePlaceHolder: 'Enter your container name here',
          containerNameErr: 'This name may only contain lowercase letters, numbers, and hyphens, and must begin with a letter or a number. Each hyphen must be preceded and followed by a non-hyphen character. The name must also be between 3 and 63 characters long.',
          tips1: {
            title: 'Set up the Azure deployment credential',
            phrase1: 'Configure service principals in your Azure cloud to make sure PhoenixAI Cloud can successfully launch the related cloud resources in your subscriptions during this cluster’s deployment process and the follow-up scaling process. ',
            phrase2: 'Additionally, you need to create an SSH key. This key will be used for PhoenixAI to deploy service in your virtual machine. ',
            phrase3: 'More information:',
            phrase4: 'Create a service principal for PhoenixAI on Azure',
            phrase5: 'Create an SSH key pair for PhoenixAI on Azure',
          },
          tips2: {
            title: 'Set up the Azure data credential',
            phrase1: 'The PhoenixAI cluster will generate a SQL Profile for each query. These profiles need to be stored in the container of your storage account.',
            phrase2: 'You need to create a managed identity as the data credential for this cluster, then add a role assignment to this managed identity to give necessary read and write permissions on the storage account.',
            phrase3: 'More information:',
            phrase4: 'Create a managed identity for Azure storage container',
            phrase5: 'Create a storage account and a container for PhoenixAI on Azure',
          },
        },
        3: {
          topTitle: 'Network Configuration',
          bottomTitle: 'Cluster authentication configuration',
          network: 'Reuse network configuration',
          vNetID: 'Virtual network resource ID',
          vNetIDPlaceHolder: 'Enter the name of your virtual network ',
          vNetIDTips: 'Enter the resource ID of the Azure virtual network to deploy the cluster in. Format: /subscriptions/xxxxxx/resourceGroups/yyyyyy/providers/Microsoft.Network/virtualNetworks/zzzzz.',
          vNetIDErr: 'Please enter the name of your virtual network ',
          resourceGroupName: 'Resource group name',
          resourceGroupNamePlaceHolder: 'Enter the name of your resource group',
          subnetName: 'Subnet name',
          subnetNameTips: 'Enter the subnet name.',
          subnetNamePlaceHolder: 'Enter the name of your subnet',
          subnetNameErr: 'The name must begin with a letter or number, end with a letter, number or underscore, and may contain only letters, numbers, underscores, periods, or hyphens. The name must be between 1 and 80 characters.',
          subnetID: 'Subnet resource ID',
          subnetIDPlaceHolder: 'Enter the resource ID of your subnet',
          subnetIDTips: 'Enter the resource ID of the Azure subnet to deploy the cluster in. Format: /subscriptions/xxxxxx/resourceGroups/yyyyyy/providers/Microsoft.Network/virtualNetworks/zzzzz/subnets/nnnnn.',
          subnetIDErr: 'Please enter a valid subnet resource ID',
          resourceGroup: 'Resource group resource ID',
          resourceGroupPlaceHolder: 'Defaults to the resource group of the virtual network',
          resourceGroupTips: 'The resource group in which the cluster VMs, load balancer, and disks are created. Defaults to the resource group of the virtual network. Format: /subscriptions/xxxxxx/resourceGroups/yyyyyy.',
          resourceGroupErr: 'Please enter a valid resource group resource ID',
          resourceGroupSubscriptionErr: 'The resource group must be in the same subscription as the subnet',
          pubAccessible: 'Public accessible',
          pubAccessibleTips: 'You can optionally specify whether the cluster can be accessed from public networks by selecting or clearing the checkbox next to Public accessible. If you select Public accessible, PhoenixAI Cloud will attach a load balancer to the cluster to distribute incoming queries, and assign a public domain name to the cluster so you can access the cluster over a public network. If you do not select Public accessible, the cluster is accessible only through a private domain name.',
          pubAccessibleDesc: 'I want to access the cluster from the public network. ',
          userTips: 'Defines the username of the initial user for this cluster. This will be the administrator of the cluster.',
          passwordTips: 'Defines cluster administrator\'s initial password. You can also click \'Random\' next to the Admin password field to obtain a password generated by PhoenixAI Cloud.',
          normal: 'The subnet connectivity test is successful. You may proceed to the next step.',
          tips1: {
            title: 'Set up the Azure network configuration',
            phrase1: 'Because PhoenixAI needs to deploy the cluster in the user’s virtual network, the user needs to define which Subnet the cluster is deployed in and configure the inbound/outbound rules of the subnet to allow PhoenixAI Cloud to successfully integrate with your cluster. For more information, see:',
            phrase2: 'How to create a virtual network, a subnet, and a security group for PhoenixAI on Azure? ',
            phrase3: 'PhoenixAI Cloud\'s control plane service is deployed in PhoenixAI\'s VNet. By default, the control plane communicates with your cluster through the public network. You can use a Private Endpoint for increased security by using PrivateLink.',
            phrase4: 'Private endpoint for connection is a must if you need to keep the cluster network to private only. More information: {0}',
            phrase5: 'Private DNS Zone ID is a must for the private endpoint URL to resolve correctly to the private IPs of the cluster.',
            phrase6: 'Create a private endpoint for Private Link',
          },
          tips2: {
            title: 'How to set the Security Configuration?',
            phrase1: 'During STEP3 in the deploying process, you need to configure the initial password for the cluster admin user. Then you can use this admin/password to log in to the cluster. After configuring this, PhoenixAI Cloud will generate a password file for you. Please keep it confidential.',
          },
          vpcEndpointId: 'Private Endpoint ID',
          vpcEndpointIdPlaceholder: 'Enter the ID of your VPC endpoint',
          vpcEndpointIdTips: 'Enter the Azure Private Endpoint Resource ID. Format: /subscriptions/{uuid}/resourceGroups/{name}/providers/Microsoft.Network/privateEndpoints/{name}',
          vpcEndpointIdErr: 'Invalid format. Expected: /subscriptions/{uuid}/resourceGroups/{name}/providers/Microsoft.Network/privateEndpoints/{name}',
          privateDnsZoneId: 'Private DNS Zone ID',
          privateDnsZoneIdPlaceholder: 'Enter the ID of your Private DNS Zone',
          privateDnsZoneIdTips: 'Enter the Azure Private DNS Zone Resource ID. Format: /subscriptions/{uuid}/resourceGroups/{name}/providers/Microsoft.Network/privateDnsZones/{name}',
          privateDnsZoneIdErr: 'Invalid format. Expected: /subscriptions/{uuid}/resourceGroups/{name}/providers/Microsoft.Network/privateDnsZones/{name}',
          advancedSettings: {
            title: 'Advanced security settings (Private Endpoint)',
          },
        },
        4: {
          1: '1. Connect with your account.',
          2: '2. Create the resource in your region.',
          3: '3. Deploy the PhoenixAI cluster in your VNet.',
          progress: 'Progress',
          title: 'Start the deployment',
          lodingTip: 'PhoenixAI Cloud is deploying in your VNet. This process will take about 6 minutes. Please wait patiently.',
          failedTip: 'PhoenixAI Cloud failed to deploy the cluster',
          lastTimeTips: 'The deployment has been last for',
          subStep1: {
            1: 'Check the Managed identity resource ID',
            2: 'Check the Storage account Configuration',
            3: 'Check the App registration Configuration',
            4: 'Check the SSH Key resource ID',
            5: 'Check the Virtual network resource ID',
            6: 'Check the subnet name',
          },
          subStep2: {
            1: 'Launch virtual machine',
            error0: 'Creating virtual machine failed. Please check whether your role policy in cloud credential and data credential is valid.',
          },
          subStep3: {
            1: 'Distribute the installation package',
            2: 'Decompress the installation package',
            3: 'Deploy services',
            4: 'Initialize the cluster user (admin)',
            error0: 'Downloading the installation package timed out. Check whether your VM instance can connect to the Internet.',
            error1: 'Decompressing the installation package failed. Check whether your VM instance is in a normal state.',
            error2: 'Deployment failed. Check whether your VM instance is in a normal state and whether your security group is correctly configured.',
            error3: 'Initialization failed. Please retry the deployment.',
          },
          success: {
            subTitle: 'PhoenixAI Cluster has been successfully deployed in your Azure Cloud!',
          },
        },
      },
      gcp: {
        1: {
          tips: {
            feNode: 'FEs use Persistent Storage as storage to ensure that metadata files can be restored in the event of failure.',
            beNode: 'The BE node is responsible for the execution of distributed computing, and Persistent Storage is used for the storing of table data. In general, a virtual machine instance with CPU:RAM=1:4 will be recommended. We suggest selecting a virtual machine with 4 or more vCPUs.',
          },
        },
        2: {
          instanceServiceAccountToolTips: 'After you have created the service account and granted it with the role to access the bucket, copy the service account email and paste it here.',
          tips1: {
            title: 'Set up the GCP data credential',
            phrase1: 'You need to {0} for deploying your PhoenixAI cluster. All the resources to be created are within this project.',
            phrase1SharedVPC: 'You need to {0} for deploying your PhoenixAI cluster. This project will be the \'Service Project\'. All the resources to be created are within this project.',
            phrase2: 'The PhoenixAI cluster will generate a SQL Profile for each query. These profile files will be uploaded into your cloud storage bucket. To enable PhoenixAI Cloud to read/write to your cloud storage, a data credential is needed:',
            phrase3: 'On this page, enter the name of your cloud storage bucket.',
            phrase3SharedVPC: 'On this page, enter the name of your cloud storage bucket from the Service Project.',
            phrase4: 'In the {0}, create a service account which will be attached to compute instances as the data credential for this cluster. Grant a role with read and write permissions for the storage objects to the service account.',
            GCPIAMAdmin: 'GCP IAM & Admin',
            phrase5: 'After the service account is created, copy the service account email for the GCP console.',
            phrase6: 'On this page, paste the service account email to the {0} field.',
            instanceServiceAccount: 'instance service account',
            phrase7: 'More information: {0}',
            createDataCredential: 'How to create a data credential',
          },
          tips2: {
            title: 'Set up the GCP deployment credential',
            phrase1: 'To ensure a successful deployment in your VPC, you must create a deployment credential by conducting the following steps:',
            phrase1SharedVPC: 'To ensure a successful deployment in your Shared VPC, you must create a deployment credential by conducting the following steps:',
            phrase2: 'In the GCP console, find the project, copy the project ID, and paste it to the {0} field.',
            phrase2SharedVPC: 'In the GCP console, find the project, copy the project ID, and paste it to the {0} field. This is your Service Project in your Shared VPC.',
            projectId: 'Project ID',
            phrase3: 'In the {0} console, grant required roles to the {1}.',
            GCPIAM: 'GCP IAM',
            phrase4: 'More information: {0} ',
            setupWithGCP: 'How to create a deployment credential.',
            trustServiceAccount: 'PhoenixAI\'s public service account(Grant access to)',
          },
        },
        3: {
          subnetToolTips: 'You must set proper routes to allow your cluster to access PhoenixAI Cloud over the public internet, otherwise you need to create Private Service Connect (PSC) to access PhoenixAI Cloud to make sure all the traffic remains within Google Cloud.\n If you want to connect your client to the cluster over the public network, you will also need to adjust the network configurations.',
          networkTagToolTips: 'This network tag will be attached to all compute instances within this cluster, and please make sure that firewall rules created for this VPC are using it to filter targets as well.',
          endpointToolTips: 'The ID of the connected endpoint. For target service info, please refer to: ',
          block1Tips: {
            title: 'Set up the GCP network configuration',
            phrase1: 'PhoenixAI needs to deploy the cluster in your VPC under your project created previously.',
            phrase1SharedVPC: 'PhoenixAI needs to deploy the cluster in your Shared VPC under your {0} created previously.',
            phrase2: 'In the {0} console, create a VPC with a subnet, make sure you select the region that you chose for your cluster in step 1.',
            phrase2SharedVPC: 'In the {0} console, create a VPC in the {1} with a subnet, make sure you select the region that you chose for your cluster in step 1.',
            gcpVPCNetwork: 'GCP VPC Network',
            phrase3: 'On this page, fill in the {0} that the cluster will be deployed in.',
            subnetName: 'subnet name',
            subnetNameSharedVPC: 'subnet url',
            phrase4: 'In the {0} console, create some firewall rules, and make sure these firewall rules have been configured properly by using the {1} as required.',
            gcpNetworkSecurity: 'GCP Network Security',
            networkTag: 'network tag',
            phrase5: 'On this page, paste the {0} you use for firewall rules.',
            phrase6: 'For more information, please refer to: {0}',
            createNetWorkConfig: 'Create a network configuration',
            phrase7: 'PhoenixAI Cloud\'s control plane service is deployed in PhoenixAI\'s VPC. By default the control plane communicates with your cluster through the public network. You can use a Private Service Connect (PSC) for increased security. More information {0}.',
            phrase8: 'More information {0}.',
            createPSCEndpoint: 'Create a PSC Endpoint',
            deployPrivateServiceConnect: 'Deploy cluster with end-to-end Private Service Connect',
          },
          advancedSettings: {
            title: 'Advanced security settings (PSC endpoint)',
            enablePublicAccessTip: 'When public access is enabled, your users can access the Cluster console via the public internet. To enhance security, you can disable public access, requiring all users to access it via Private Service Connect, which secures the traffic.',
          },
          noNat: 'No NAT gateway is detected, make sure that your subnet has access to the Internet to complete the deployment. More information:',
          noNatHow: 'How to set up the network configuration.',
          subnetErr: 'Network connection test failed! Please check whether the subnet name that you entered is valid. More information:',
          subnetErrHow: 'How to set up the network configuration.',
          diffVPC: 'Network connection test failed! Please check whether your security group and your subnet reside in the same VPC. More information: ',
          diffVPCHow: 'How to set up the network configuration.',
          sgErr: 'Network connection test failed! Please check whether the PSC Connection ID that you entered is valid. More information: ',
          sgErrHow: 'How to create a PSC Endpoint.',
          sgRuleErr: 'Network connection test failed! Please check whether appropriate ingress and egress firewall rules are created, and whether you have specified the Network tag field correctly. More information: ',
          sgRuleErrHow: 'How to set up the network configuration.',
          vpcIDErr: 'Network connection test failed! Please check whether the PSC Connection ID that you entered is valid. More information: ',
          vpcIDErrHow: 'How to create a PSC Endpoint.',
          vpcNameErr: 'Network connection test failed! Please check the service attachment that you configured in PSC Endpoint. More information: ',
          vpcNameErrHow: 'How to create a PSC Endpoint.',
          vpcSubnetErr: 'Network connection test failed!  Please check the subnetwork that you configured in PSC Endpoint. More information: ',
          vpcSubnetErrHow: 'How to create a PSC Endpoint.',
          privateSubnetErr: 'Network connection test failed! We have discovered that one or more subnets can access the public network, while we require them to be private if the PSC Endpoint is configured. More information: ',
          privateSubnetErrHow: 'Make sure your subnet is private.',
          publicNet: 'PhoenixAI detects that you are using a public subnet. To ensure a successful package download and deployment, PhoenixAI will automatically launch public IP addresses to your subnet.',
        },
        elastic1: {
          tips: {
            feNode: 'Coordinator nodes use Persistent Storage as storage to ensure that metadata files can be restored in the event of failure.',
            beNode: 'Compute nodes don\'t persist internal tables. All the self-managed tables are persisted in object storage. The compute nodes are used to execute SQL jobs and cache self-managed internal tables and external tables.',
          },
        },
      },
      result: {
        success: {
          1: 'By default, each cluster has a built-in user named admin. The initialization password is set up in STEP3 during the deployment process. Users can use admin to log into the cluster through MySQL Client/JDBC/WebUI. If you need more cluster built-in users to cooperate with you in this cluster, you can perform the CREATE USER STATEMENT In this cluster. More information: ',
          2: 'We provide a public network accessible WebUI for each cluster. Through this WebUI, users can directly analyze & manage data within the cluster. Click the Open Cluster button on the Cluster Overview Page to enter this WebUI with cluster built-in users authentication information (such as the admin user you set up in STEP3).',
          3: 'We find your cluster can be accessed from the Public Network. You can use MySQL Client or Data Application (JDBC supported) in public network to connect with your cluster. The connection information can be seen on the Cluster Overview Page. Before building the connection, please check whether the Firewall rules for Ingress allow requests from application’s host. More information: ',
          title: 'Deployment Succeeded!',
          subTitle: 'PhoenixAI Cluster has been successfully deployed in your {cloud} Cloud! ',
          loginIn: 'About logging in to the PhoenixAI cluster',
          link1: 'How to manage cluster users?',
          link2: 'How to connect from a client application to PhoenixAI Cloud?',
          contact: 'Please contact us if you have any problems during deployment.',
          quickStartTip: 'Need a quick start? You can see:',
        },
        failed: 'Deployment failed',
        failedTip: 'Something wrong with the cluster deployment process. ',
      },
    },
    modal: {
      classic: {
        name: 'Classic cluster',
        label: '',
        desc: 'Data is stored on AWS EBS. Ideal for data warehouse or other scenarios prioritizing high concurrency and low latency.',
        azureDesc: 'Data is stored on virtual machines\' cloud disks. Ideal for data warehouses or other scenarios prioritizing high concurrency and low latency.',
        gcpDesc: 'Data is stored on virtual machines\' Persistent Storage. Ideal for data warehouses or other scenarios prioritizing high concurrency and low latency.',
        deprecationNoticeWithClassic: 'Note: Although classic clusters are fully supported, as a part of our product evolution, we encourage new deployments to adopt the Shared-Data architecture for improved elasticity and cost efficiency.',
        deprecationNoticeWithoutClassic: 'PhoenixAI is transitioning to Shared-Data as our primary architecture and Classic clusters are no longer available. If your project requires a Classic Cluster, please reach out to Support for guidance.',
      },
      elastic: {
        name: 'Elastic cluster',
        label: '',
        desc: 'Data is separated from compute. Data is stored in cloud object storage, and warehouses containing different numbers/types of compute nodes are created according to business scenarios for data lake exploration and interactive analytics under the premise of resource isolation.',
      },
      label: '(Coming soon)',
      modalTitle: 'Which cluster model do you prefer?',
      providerTitle: 'Choose cloud provider',
      cspTips: 'Google Cloud Platform will be supported soon.',
      noCloudProviders: 'No cloud providers',
    },
  },
  support: {
    title: 'Support',
    createTicketBtn: 'Create ticket',
    notAssignedTip: 'You are not authorized to create tickets. Ask your admin to assign you in the Assign Users panel.',
    searchPlaceholder: 'Search tickets...',
    searchBtn: 'Search',
    emptyState: 'No support tickets yet',
    filter: {
      allStatus: 'All Status',
    },
    status: {
      open: 'Open',
      pending: 'Pending',
      closed: 'Closed',
      solved: 'Solved',
    },
    severity: {
      critical: 'Critical',
      high: 'High',
      medium: 'Medium',
      low: 'Low',
    },
    table: {
      ticketId: 'Ticket ID',
      severity: 'Severity',
      summary: 'Summary',
      createdBy: 'Created By',
      created: 'Created',
      status: 'Status',
      lastUpdated: 'Last Updated',
      zendesk: 'Zendesk',
      ticketTypeCluster: 'Cluster Related',
      ticketTypeNonCluster: 'Non-cluster Related',
    },
    freeTier: {
      bannerTitle: 'Support Tickets - Premium Feature',
      bannerText: 'Support tickets are available on paid plans. Visit our community channels to get help from the StarRocks community.',
      joinSlack: 'Join Slack Community',
      upgradeBtn: 'Upgrade to Paid Plan',
    },
    community: {
      title: 'Community Support Options',
      slack: {
        name: 'Slack Community',
        desc: 'Join our community of developers and users. Get help from community members and PhoenixAI team.',
        link: 'Join our Slack →',
      },
      docs: {
        name: 'Documentation',
        desc: 'Comprehensive documentation, tutorials, and guides to help you get started and troubleshoot issues.',
        link: 'View Documentation →',
      },
      faq: {
        name: 'FAQ & Troubleshooting',
        desc: 'Common questions and answers or frequently encountered issues.',
        link: 'Browse FAQ →',
      },
    },
    createTicket: {
      title: 'Create Support Ticket',
      subtitle: 'Provide the details below to create a new support ticket. Our team will reach out to you within the service tier timeframe.',
      ticketType: 'Ticket Type',
      ticketTypePlaceholder: 'Select ticket type',
      clusterRelated: 'Cluster Related',
      nonClusterRelated: 'Non-cluster Related (Billing, Account Management, etc.)',
      selectCluster: 'Select Cluster',
      selectClusterPlaceholder: 'Choose cluster',
      isProduction: 'Is this cluster production?',
      severity: 'Severity',
      severityPlaceholder: 'Select severity',
      summary: 'Summary',
      summaryPlaceholder: 'Brief summary of the issue',
      description: 'Description',
      descriptionPlaceholder: 'Provide detailed information about the issue. Include steps to reproduce, impact, and any relevant logs or traces.',
      attachments: 'Attachments',
      uploadHint: 'Drop files here or ',
      uploadClick: 'click to upload',
      uploadTip: 'Supported formats: PNG, JPG, PDF, TXT · Max 10 MB per file · Up to 10 files',
      uploadTypeError: 'Only PNG, JPG, PDF, and TXT files are supported',
      uploadSizeError: 'File exceeds the {max} MB size limit',
      uploadCountError: 'You can upload a maximum of {max} files',
      submit: 'Create Ticket',
      successMsg: 'Support ticket created successfully',
      validation: {
        ticketType: 'Please select a ticket type',
        cluster: 'Please select a cluster',
        isProduction: 'Please indicate if this is a production cluster',
        severity: 'Please select a severity level',
        summary: 'Please enter a summary',
        description: 'Please enter a description',
      },
    },
    zendesk: {
      linkDialogTitle: 'Zendesk Account Not Linked',
      linkDialogContent: 'Your current account has not been linked to a Zendesk account. Would you like us to automatically create a Zendesk account for you?',
      linkDialogConfirm: 'OK',
      linkDialogCancel: 'Cancel',
    },
    assignUsers: {
      btn: 'Assign Users',
      title: 'Assign Users for Support Ticket Creation',
      description: 'Select up to {limit} users who can create support tickets. Selected users will receive an email with Zendesk account details and password reset instructions.',
      assignedTitle: 'Currently Assigned Users',
      availableTitle: 'Available Users',
      searchPlaceholder: 'Search by name or email',
      noSearchResults: 'No users match your search',
      noAssignedUsers: 'No users assigned yet',
      noAvailableUsers: 'No more users available',
      availableSlotsTitle: 'Available slots:',
      limitWarningTitle: 'Available slots: {remaining} of {limit} user slots remaining',
      limitWarningContent: 'Account admins automatically have access and don\'t count towards this limit.',
      tagActive: 'Active',
      tagAccountAdmin: 'Account admin',
      AccountAdminLockTip: 'Account admins always have access and cannot be removed',
    },
  },
  billing: {
    bill: 'Billing',
    title: 'Billing Dashboard',
    graph: 'Graph',
    details: 'Details',
    usage: {
      title: 'Usage',
      graph: 'Cluster Usage Graph',
      allClusters: 'All clusters',
      details: 'Cluster Usage Details',
      warehouseGraph: 'Warehouse Usage Graph',
      warehouseDetails: 'Warehouse Usage Details',
      noViewClusterPrivilege: 'No view cluster privilege',
      allClassicClusters: 'All classic clusters',
      allElasticClusters: 'All elastic clusters',
      table: {
        billingPeriod: 'Billing period',
        ccuUsageBeforeDiscount: 'CCU usage(Before discount)',
        ccuUsageAfterDiscount: 'CCU usage(After discount)',
        ccuBalanceCost: 'CCU balance cost',
        usdCost: 'USD cost',
        paymentStatus: 'Payment status',
        operation: 'Operation',
        date: 'Date',
      },
      ccuUnit: 'CCU(s)',
    },
    overview: {
      title: 'Overview',
      nextBilling: 'Next Billing Time',
      monthUsage: 'Current Month\'s CCU Usage',
      monthBillableCCU: 'Current Month\'s Billable CCU',
      monthCost: 'Current Month\'s Total Cost',
      monthlyConsumption: 'Monthly consumption',
      byAllAccounts: 'By all accounts',
      downloadAll: 'Download All',
      download: 'Download',
      table: {
        billingPeriod: 'Billing period',
        ccuUsage: 'CCU usage',
        ccuUsageTooltip: 'Total number of PhoenixAI Compute Units (CCUs) consumed by your workloads within the given billing period.',
        billableCCU: 'Billable CCU',
        billableCCUTooltip: 'The number of CCUs that you\'re charged for after applying any free tiers, free trial, or discounts.',
        balancePayment: 'Balance payment',
        balancePaymentTooltip: 'The portion of your bill covered by any existing balance of prepaid CCU credits.',
        creditCardPayment: 'Credit card payment',
        creditCardPaymentTooltip: 'The amount charged to your credit card for CCU usage after deducting any balance payment.',
        status: 'Status',
        operation: 'Operation',
      },
    },
    payment: {
      title: 'Payment details',
      ccuBalance: 'CCU balance',
      payType: 'Payment type',
      directly: {
        cardDesc: '{0} ending in {1} expiring {2}',
        btnAction: 'Add credit card',
        methodName: 'Direct billing',
        desc: 'Billing through PhoenixAI Cloud with consumption based on CCUs usage',
        addTitle: 'Add new credit card',
        editTitle: 'Edit credit card information',
        addDesc: 'Your card will be charged during the last day of each month for the CCUs you consume this month. More information : {0}',
        moreLink: 'Understand PhoenixAI Cloud billing',
      },
      contract: {
        methodName: 'Contract',
      },
    },
    history: {
      title: 'Billing history',
    },
    downloadInvoice: 'Download invoice',
    downloadReceipt: 'Download receipt',
  },
  cloud: {
    filter: {
      byName: 'Filtered to {0}.',
      clear: 'Clear filter',
    },
    settings: 'Cloud settings',
    aws: 'AWS cloud settings',
    azure: 'Azure cloud settings',
    gcp: 'GCP cloud settings',
    method: 'IAM role',
    delTips: 'Are you sure you want to delete the {0}? Deleting this {0} will not affect the related cluster, but members in this account can no longer reuse this {0} during the new cluster’s deployment process.',
    cre: 'credential',
    config: 'configuration',
    storageTip: 'Data credential',
    deploymentReplaceTips1: 'Notes: You should replace <Data credential role ARN> in the JSON policy template with the ARN of the data credential role, and <S3-bucket-name> with the name of the data credential bucket.',
    deploymentReplaceTips2: 'It\'s recommended to update the data/deployment credential from a specific cluster, it\'s much easier.',
    detail: {
      cid: {
        method: 'Credential method',
        externalID: 'External ID',
        arn: 'IAM role ARN',
        related: 'Related cluster',
        create: 'Created at',
        author: 'Created by',
      },
      nid: {
        subnet: 'Subnet ID',
        sg: 'Security group ID',
        nlbSg: 'Security group ID for NLB',
        related: 'Related cluster',
        endpoint: 'VPC endpoint ID',
        create: 'Created at',
        author: 'Created by',
        region: 'Region',
      },
      storage: {
        bucketName: 'Bucket name',
        arn: 'Instance profile ARN',
        related: 'Related cluster',
        create: 'Created at',
        author: 'Created by',
      },
      common: {
        updatedAt: 'Updated at',
        updatedBy: 'Updated by',
        deleteFailed: 'Delete Failed',
        stillClustersAssociated: 'There are still clusters: {0} associated with this {1}. Release the clusters before removing the {1}.',
        toBeDeleted: '{0} to be deleted: {1}',
        enterDeleteToRemove: 'Enter <strong>Delete</strong> to remove the {0}.',
        credentialTypes: {
          iamRole: 'IAM role',
          aksk: 'AK/SK',
        },
        dialogTypes: {
          cid: 'Deployment Credential',
          nid: 'Network configuration',
          storage: 'Data credential',
        },
      },
    },
    nodata: 'No {0} found. When you successfully create a cluster, the corresponding {1} will be automatically saved here.',
    IAM: {
      title: 'Deployment credentials',
      detail: 'Deployment credential',
      create: 'Create deployment credential',
      how: 'How to create a cross-account IAM role?',
      tips1: 'Before creating the deployment credential, you need to create a cross-account IAM role based on the policy template. More information',
      tips2: 'Then you can create the new deployment credential based on this cross-account role. This credential can be used to quickly start up a new PhoenixAI Cluster in the user’s cloud account. When you finish creating, you can paste the cross-account role’s ARN here. For more information about how to create a Deployment credential, see ',
      tips2Link: 'Create a deployment credential',
      errTips: 'The ARN of the IAM role is invalid. Please check whether the Policy, Account ID, and External ID are configured correctly when you create the Cross-Account Role.',
      modal: {
        title: 'Create deployment credential',
        name: 'Deployment credential name',
        namePlaceholder: 'Enter a deployment credential name',
        nameTips: 'The credential name must be unique within the account.',
      },
      table: {
        name: 'Deployment credential name',
        method: 'Credential method',
        arn: 'IAM role ARN',
        update: 'Updated at',
        time: 'Created at',
      },
    },
    network: {
      title: 'Network configurations',
      detail: 'Network configuration',
      create: 'Create network configuration',
      tips1: 'PhoenixAI Cluster is deployed in your own VPC. When the VPC/Subnet/Security Group/VPC Endpoint (Optional) are configured in Network Configuration, users can reuse the configuration during the deployment process. This will help you quickly start up a new cluster. For more information about how to create a network configuration, see ',
      how: 'Create network configuration.',
      errTips: 'Network configuration is invalid. Please check items.',
      modal: {
        title: 'Create network configuration',
        name: 'Network configuration name',
        namePlaceholder: 'Enter a network configuration name',
        nameTips: 'The network configuration name must be unique within the account.',
        multiAz: 'Multiple availability zone',
        deploymentCredential: 'Deployment credential',
        primary: 'Primary',
      },
      table: {
        name: 'Network configuration name',
        subnet: 'Subnet ID',
        sg: 'Security group ID',
        endpoint: 'VPC endpoint ID',
        multiAz: 'MultiAz',
      },
      validation: {
        subnetRequired: 'Subnet ID is required',
        nameRequired: 'Network configuration name is required',
        subnetFormat: 'Please enter the correct format of subnet ID',
        selectRegion: 'Please select the region first',
        selectCredential: 'Please select the deployment credential first',
        uniqueSubnet: 'Please enter a unique subnet ID',
        sameVPC: 'Subnets should be in the same VPC',
        differentAZs: 'Subnets should be in different AZs',
        validSubnet: 'Please enter a valid subnet ID',
        getNetIfaceError: 'get net iface id error, please try again',
        threeSubnetsType: 'The three subnets must all be either private subnets or public subnets. If public accessibility over the internet is required, the three subnets must be public subnets.',
      },
    },
    storage: {
      title: 'Data credentials',
      detail: 'Data credential details',
      create: 'Create data credential',
      tips1: 'Before creating the data credential, you need to create a role in your AWS Console based on the policy template. More information: ',
      how: 'How to create a role for data credential?',
      tips2: 'Then you can create the new data credential based on this role. Based on this data credential, you can create a PhoenixAI cluster and store the SQL Query profile in related bucket name. Profile can help you analyze the slow query. For more information about how to create a Data credential, see ',
      tips2Link: 'Create a data credential',
      errTips: 'Network configuration is invalid. Please check items.',
      modal: {
        title: 'Create data credential',
        name: 'Bucket name',
      },
      table: {
        name: 'Data credential name',
        bucketname: 'Bucket name',
        update: 'Updated at',
        time: 'Created at',
      },
    },
    azureSettings: {
      deployment: {
        name: 'Deployment credential name',
        method: 'Credential method',
        sshkey: 'SSH key resource ID',
        createAt: 'Created at',
        updateAt: 'Updated at',
        sshKeyMethod: 'SSH Key',
      },
      common: {
        rotateSecretValue: 'Rotate secret value',
        rotateSecretTitle: 'Rotate the secret value in {0}',
        enterNewClientSecret: 'Enter your new client secret value',
        rotationWarning: 'This rotation only works on this already existing Azure credential, and it will affect clusters that were created before.',
        deleteFailed: 'Delete Failed',
        stillClustersAssociated: 'There are still clusters: {0} associated with this {1}. Release the clusters before removing the {1}.',
        toBeDeleted: '{0} to be deleted: {1}',
        enterDeleteToRemove: 'Enter <strong>Delete</strong> to remove the {0}.',
        dialogTypes: {
          deployment: 'Deployment Credential',
          network: 'Network configuration',
          storage: 'Data credential',
        },
      },
      network: {
        name: 'Network configuration name',
        VNID: 'Virtual network resource ID',
        subnetName: 'Subnet name',
        createAt: 'Created at',
      },
      data: {
        name: 'Data credential name',
        containerName: 'Container name',
        createAt: 'Created at',
      },
      detail: {
        deployment: {
          DID: 'Directory (tenant) ID',
          AID: 'Application (client) ID',
          clientSecret: 'Client secret value',
          sshID: 'SSH Key resource ID',
          related: 'Related cluster',
          createAt: 'Created at',
          updateAt: 'Updated at',
          creator: 'Created by',
        },
        network: {
          VNID: 'Virtual network resource ID',
          subnetName: 'Subnet name',
          resourceGroup: 'Resource group resource ID',
          related: 'Related cluster',
          createAt: 'Created at',
          creator: 'Created by',
        },
        storage: {
          MID: 'Managed identity resource ID',
          storageAccName: 'Storage account name',
          containerName: 'Container name',
          related: 'Related cluster',
          createAt: 'Created at',
          creator: 'Created by',
        },
      },
    },
    batchDelete: {
      selected: '{n} selected',
      usedBy: 'Used by',
      reviewTitle: 'Selected items',
      name: 'Name',
      remove: 'Remove',
      confirmTitle: 'Delete {type}',
      confirmTip: 'The following items will be deleted. This action cannot be undone.',
      enterDeleteToConfirm: 'Enter {0} to confirm.',
      resourceTypes: {
        credential: 'deployment credentials',
        network: 'network configurations',
        storage: 'data credentials',
      },
    },
    gcpSettings: {
      deployment: {
        table: {
          arn: 'Grant access to',
          projectId: 'Project ID',
        },
        create: {
          tips1: 'Before creating the deployment credential, you need to create a role for cross-project resource access, and grant the role and Compute Admin role to PhoenixAI\'s public service account. More information: ',
          tips2: 'Then you can create the new deployment credential after the role grant and paste your Project ID here. This credential can be used to quickly start up a new PhoenixAI Cluster in the user’s cloud account. For more information about how to create a Deployment credential, see',
          link1: 'Grant Google Cloud Resource Permissions to PhoenixAI',
          link2: 'Create a deployment credential',
        },
      },
      network: {
        table: {
          subnet: 'Subnet name',
          sg: 'Network tag',
          endpoint: 'PSC connection ID',
          multiAz: 'MultiAz',
        },
        create: {
          tips1: 'PhoenixAI Cluster is deployed in your own VPC. When the SubnetName, NetworkTag, and PSC Connection ID (Optional) are configured in Network Configuration, users can reuse the configuration during the deployment process. This will help you quickly start up a new cluster. For more information about how to create a network configuration, please refer to: ',
          link1: 'Create network configuration',
        },
        validation: {
          subnetRequired: 'Subnet name is required',
          subnetUrlRequired: 'Subnet url is required',
          getNetIfaceError: 'get net iface id error, please try again',
          threeSubnetsType: 'The three subnets must all be either private subnets or public subnets. If public accessibility over the internet is required, the three subnets must be public subnets.',
          differentAZs: 'Subnets should be in different AZs.',
          sameVPC: 'Subnets should be in the same VPC.',
        },
        modal: {
          deploymentCredential: 'Deployment credential',
        },
      },
      data: {
        create: {
          tips1: 'With this data credential configured, we will be able to store the SQL Query profile into your cloud storage bucket. ',
          tips2: 'Before creating the data credential, you will need to create a service account with required roles granted for compute instances to access this cloud storage bucket. More information: ',
          link1: 'How to create a service account for the data credential?',
          tips3: 'Profile can help you analyze the slow query. For more information about how to create a Data credential, see ',
          link2: 'Create a data credential',
        },
      },
      detail: {
        cid: {
          method: 'Credential method',
          externalID: 'Project ID',
          arn: 'Grant access to',
          related: 'Related cluster',
          create: 'Created at',
          author: 'Created by',
        },
        nid: {
          subnet: 'Subnet name',
          sg: 'Network tag',
          related: 'Related cluster',
          endpoint: 'PSC connection ID',
          create: 'Created at',
          author: 'Created by',
          region: 'Region',
        },
        storage: {
          bucketName: 'Bucket name',
          arn: 'Instance service account',
          related: 'Related cluster',
          create: 'Created at',
          author: 'Created by',
        },
        common: {
          updatedAt: 'Updated at',
          updatedBy: 'Updated by',
          primary: 'Primary',
          stillClustersAssociated: 'There are still clusters: {0} associated with this {1}. Release the clusters before removing the {1}.',
          toBeDeleted: '{0} to be deleted: {1}',
          enterDeleteToRemove: 'Enter <strong>Delete</strong> to remove the {0}.',
          deleteFailed: 'Delete Failed',
          dialogTypes: {
            cid: 'Deployment Credential',
            nid: 'Network configuration',
            storage: 'Data credential',
          },
        },
      },
    },
  },
  management: {
    member: {
      general: 'General',
      privileges: 'Granted roles',
    },
    role: {
      title: 'Role management',
      roleExsit: 'Name exists',
      create: 'Create role',
      roleMatched: 'role(s) matched',
      searchPlaceholder: 'Search the roles',
      remove: {
        title: 'Confirm to remove the role {0}?',
        content: 'When you delete this role, members who inherit it will stop inheriting it, and the role will be unrecoverable after deletion. Confirm to delete?',
        inRoleMappingTips: 'The role "{0}" is currently used in SSO role mapping, please remove it from SSO role mapping before deleting the role.',
      },
      table: {
        name: 'Roles Name',
        desc: 'Description',
        createAt: 'Created at',
      },
      dialog: {
        title: 'Create a new role',
        name: 'Role name',
        desc: 'Description',
      },
      general: 'General',
      privileges: 'Granted privileges',
      detailTitle: 'Role\'s Details',
      ownedCluster: 'ALL OWNED CLUSTERS',
      allCluster: 'ALL CLUSTERS',
      selectClusterPermis: 'Select the cluster that allows the operation',
      allClusterTips: 'ALL CLUSTERS indicates all existing clusters and all clusters to be created in the future.',
    },
  },
  alarm: {
    title: 'Alert policy',
    new: 'Create new policy',
    ow: 'Overview',
    records: 'Records',
    noAlarmPolicies: 'No alert policies',
    table: {
      name: 'Name',
      method: 'Notification methods',
      metrics: 'Metrics',
      time: 'Updated Time',
    },
    edit: {
      title: 'Edit the alert policy',
    },
    create: {
      title: 'Create a new alert policy',
      form: {
        name: 'Policy name',
        namePld: 'Your alert policy name',
        nameReq: 'policy name is required',
        nameLength: 'name must be 1-32 characters',
        nameCheckFailed: 'Could not verify the policy name. Please try again.',
        region: 'Cluster region',
        efctInterval: 'Effective interval',
        alarmInterval: 'Alert interval',
        alarmUnit: '',
        calculationWindow: 'Calculation window',
        rule: 'Alert rules',
        and: 'and',
        or: 'or',
        method: 'Notification methods',
        email: 'Email',
        pagerduty: 'PagerDuty',
        addMethod: '+ Add method',
        pdIntegration: 'PagerDuty integration',
        pdSeverity: 'PagerDuty severity:',
        pdUseDefaultSeverity: 'Use integration default',
        pdSeverityMixed: 'Mixed (set per integration)',
        selectIntegration: 'Select an integration',
        noMoreIntegrations: 'No more integrations available',
        pdMaxLimit: 'Maximum {max} PagerDuty integrations per policy',
        methodRequired: 'Please configure at least one notification method',
        emailRequired: 'Please enter the email address',
        emailUnique: 'Please use unique email addresses',
        emailCorrect: 'Please enter the correct email address',
        emailBusiness: 'Please use the business email address',
        emailMaxLimit: 'A maximum of 20 email addresses is allowed.',
        completeItems: 'please complete the items',
        intervalRequired: 'Please enter the interval',
        unitRequired: 'Please choose',
        selectCluster: 'Select one cluster',
        inputPlaceholder: 'Input',
        timeUnits: {
          seconds: 'Seconds',
          minutes: 'Minutes',
          hours: 'Hours',
        },
        functions: {
          mean: 'mean',
          max: 'max',
          min: 'min',
        },
        subject: 'Subject',
        subjectPld: 'Customized subject or the default when empty',
        subjectTip: 'You can directly specify your own priority label or other information as part of your subject content without specifying the priority.',
        to: 'To',
        toPld: 'Recipients email addresses, use comma (,) to separate multiple email addresses',
        cc: 'Cc',
        ccPld: 'Cc recipients email addresses (optional), use comma (,) to separate multiple email addresses',
        removeTips: 'The action will permanently delete the alert policy and can’t be undone anymore. Are you sure about this?',
        emailSendTips: 'Alerts can be sent every 15 minutes at most, regardless of how short you set the alert interval. {0}',
        emailSendLinkTips: 'Click here to find out more.',
      },
    },
    detail: {
      ow: {
        name: 'Policy Name',
        create: 'Creation time',
        creator: 'Creator',
        interval: 'Alert interval',
        calculationWindow: 'Calculation window',
        rules: 'Alert rules',
        methods: 'Notification methods',
      },
      getInfoFailed: 'Get info failed',
      defaultSeverityTip: 'No per-policy override set. Uses the default severity configured on PagerDuty integration.',
    },
    record: {
      trigger: 'Triggered rule',
      time: 'Time',
    },
  },
  integration: {
    title: 'Integration Hub',
    ranger: {
      title: 'Apache Ranger',
      dialog: {
        title: 'Create Ranger Configuration',
        createTitle: 'Create Ranger Configuration',
        editTitle: 'Edit Ranger Configuration',
        name: 'Name',
        configXml: 'Ranger starrocks security xml',
        rangerScope: 'Ranger Scope',
        rangerScopeDesc: 'Choose which catalogs Ranger manages access control for',
        scopeAll: 'All catalogs (internal + external)',
        scopeAllDesc: 'Ranger becomes the sole IAM for all catalogs, replacing Native RBAC.',
        scopeExternal: 'External catalogs only',
        scopeExternalDesc: 'Ranger manages Hive/Iceberg catalogs. Internal uses StarRocks Native RBAC.',
        scopeFlowAll: 'On <b>Apply</b>, <code>access_control = ranger</code> is written to <code>fe.conf</code> as the <b>global default</b>. Internal catalogs use the StarRocks Ranger service (cannot be overridden); external catalogs default to it too but can override per catalog at definition time (e.g. <code>catalog.access.control=native</code> or <code>ranger.plugin.hive.service.name</code>).',
        scopeFlowExternal: 'On <b>Apply</b>, <code>access_control</code> is <b>not</b> written — it stays the StarRocks default <code>native</code>, so internal catalogs keep Native RBAC. Each external catalog uses Ranger only if its own definition opts in via <code>catalog.access.control=ranger</code> or <code>ranger.plugin.hive.service.name</code>.',
        securityOptionalHint: 'Optional. Read by external catalogs that route to the StarRocks Ranger service (catalog property <code>catalog.access.control=ranger</code>). Independent from the Hive security XML (Apply to Hive Catalog) — provide either or both depending on which services your catalogs use.',
        auditXml: 'Audit XML',
        secure: 'Secure connection',
        storeType: 'Store Type',
        policymgrSslXml: 'Policy Manager SSL XML',
        trust: 'Trust Store',
        key: 'Key Store',
        trustPath: 'Trust Store Path',
        trustCred: 'Trust Store Credential',
        keyPath: 'Key Store Path',
        keyCred: 'Key Store Credential',
        applyHive: 'Apply to Hive Catalog',
        applyHiveDesc: 'Provide a Ranger security configuration for Hive/Iceberg external catalogs',
        hiveSecXml: 'Hive Security XML',
        hiveAuditSwitch: 'Enable audit logs for Hive',
        hiveAuditDesc: 'Separate audit trail for Hive catalog access',
        hiveAuditXml: 'Hive Audit XML',
        enableAudit: 'Enable Audit Logs',
        enableAuditDesc: 'Log all Ranger authorization decisions',
        secureDesc: 'Use SSL/TLS for Ranger communication',
        advanceSettings: 'Advanced Settings',
        successCreateTip: 'Configuration created successfully',
        successUpdateTip: 'Configuration updated successfully',
        successDeleteTip: 'Configuration deleted successfully',
        deleteTitle: 'Delete Configuration',
        deleteContent: 'Are you sure you want to delete configuration "{name}"?',
        placeholder: {
          name: 'Configuration name, e.g. prod-ranger',
          configXml: '/path/to/ranger-starrocks-security.xml',
          auditXml: '/path/to/ranger-starrocks-audit.xml',
          policymgrSslXml: '/path/to/ranger-policymgr-ssl.xml',
          trustPath: '/path/to/truststore.jks',
          trustCred: '/path/to/truststore.jceks',
          keyPath: '/path/to/keystore.jks',
          keyCred: '/path/to/keystore.jceks',
          hiveSecXml: '/path/to/ranger-hive-security.xml',
          hiveAuditXml: '/path/to/ranger-hive-audit.xml',
        },
        validation: {
          nameRequired: 'Please enter a configuration name',
          scopeRequired: 'Ranger Scope is required',
          configXmlRequired: 'Please enter the ranger starrocks security xml(.xml)',
          auditXmlRequired: 'Please enter the audit XML path (.xml)',
          policymgrSslRequired: 'Please enter the Policy Manager SSL XML path (.xml)',
          hiveSecXmlRequired: 'Please enter the Hive security XML path (.xml)',
          hiveAuditXmlRequired: 'Please enter the Hive audit XML path (.xml)',
          externalAtLeastOne: 'For the External catalogs scope, provide at least one of the Ranger StarRocks security XML or the Hive security XML.',
          xmlInvalid: 'Invalid file, .xml required',
          jksInvalid: 'Invalid file, .jks required',
          jceksInvalid: 'Invalid file, .jceks required',
          trustStoreRequired: 'Trust Store path is required (.jks)',
          keyStoreRequired: 'Key Store path is required (.jks)',
        },
      },
      detail: {
        title: 'Configuration Detail',
        name: 'Name',
        rangerScope: 'Ranger Scope',
        configXml: 'Ranger starrocks security xml',
        auditXml: 'Audit XML',
        policymgrSslXml: 'Policy Manager SSL XML',
        trustPath: 'Trust Store Path',
        trustCred: 'Trust Store Credential',
        keyPath: 'Key Store Path',
        keyCred: 'Key Store Credential',
        hiveSecXml: 'Hive Security XML',
        hiveAuditXml: 'Hive Audit XML',
        empty: '-',
      },
      btns: {
        new: 'Create Configuration',
      },
      validateFailed: {
        60001: 'Failed to validate Ranger configuration: Access to the bucket failed.',
        60002: 'Failed to validate Ranger configuration: Download file failed.',
        60003: 'Failed to validate Ranger configuration: Connect to Ranger failed.',
        60004: 'Failed to validate Ranger configuration: Update SSL key failed.',
        60005: 'Failed to validate Ranger configuration: Update FE configuration failed.',
      },
    },
    pagerduty: {
      title: 'PagerDuty',
      empty: 'no data',
      description: 'Route PhoenixAI alerts to your PagerDuty on-call rotations and escalation policies.',
      addIntegration: 'Add integration',
      adminOnly: 'Requires account admin role.',
      name: 'NAME',
      integrationKey: 'INTEGRATION KEY',
      defaultSeverity: 'DEFAULT SEVERITY',
      created: 'CREATED',
      status: 'STATUS',
      actions: 'ACTIONS',
      active: 'Active',
      edit: 'Edit',
      delete: 'Delete',
      dialog: {
        createTitle: 'Add PagerDuty integration',
        editTitle: 'Edit PagerDuty integration',
        name: 'Name:',
        namePlaceholder: 'e.g. Prod On-Call',
        integrationKey: 'Integration Key:',
        integrationKeyPlaceholder: '32-character routing key from PagerDuty',
        defaultSeverity: 'Default Severity:',
        testConnection: 'Test Connection',
        save: 'Save',
        cancel: 'Cancel',
        helpText: 'Get your integration key from PagerDuty: Services > Service Directory > [your service] > Integrations > Events API v2',
        maskedKeyHint: 'The current integration key is masked. Enter a new 32-character key only if you want to replace it.',
        testSuccess: 'Connection successful! PagerDuty accepted the test event.',
        testFailed: 'Connection failed: {0}',
        createSuccess: 'PagerDuty integration created successfully',
        updateSuccess: 'PagerDuty integration updated successfully',
        deleteTitle: 'Delete PagerDuty integration',
        deleteContent: 'Are you sure you want to delete integration "{name}"?',
        deleteHasBindings: 'This integration is referenced by {count} alert policies: {policies}. Please remove those references first.',
        deleteSuccess: 'PagerDuty integration deleted successfully',
        saveFailed: 'Failed to save the PagerDuty integration',
        deleteFailed: 'Failed to delete the PagerDuty integration',
      },
      validation: {
        nameRequired: 'Please enter a name',
        nameExists: 'Name exists',
        keyRequired: 'Please enter an integration key',
        keyLength: 'Integration key must be exactly 32 characters',
        severityRequired: 'Please select a default severity',
      },
    },
  },
  trial: {
    limit: 'You are still in the free trial period, the remaining days are {0} days. {1} or {2}.',
    marketplaceLimit: 'You are still in the free trial period, the remaining days are {0} days.',
    payment: 'Add payment method',
    chat: 'Chat with us for billing questions',
    period: 'Your trial period has ended. Please {0} or contact us at {1}.',
    updateBilling: 'update your billing information',
    confirm: 'Go to usage and billing',
    end: {
      title: 'Your trial period has ended.',
      desc: 'Sorry, your trial period has ended. To continue using PhoenixAI, please update your billing information. Your account will be suspended until the necessary payment information is updated. If you have any questions or need assistance updating your billing information, please contact our support team at {0}.\n      Thank you for trying our service.',
    },
    debit: {
      title: 'Last deduction attempt failed',
      desc: 'We regret to inform you that the last deduction attempt from your account has failed. We kindly ask that you log in to your account and try again. Please note that failure to update your account balance may result in the suspension or termination of your account. Thank you for your attention to this matter.',
      failed: 'Last deduction attempt failed. Please try again. {0}',
      retry: 'Retry',
    },
    invalid: {
      title: 'Invalid Credit Card',
      desc1: 'There seems to be a problem with the card you provided. Our system is unable to process the transaction with this card, which may cause service interruption.',
      desc2: 'Please check the card details and try again with a different card. If the problem persists, please contact your card issuer for further assistance. ',
      billingTips: 'Invalid card information. Please try again. ',
    },
  },
  errPage: {
    401: {
      title: 'Permission Denied',
      info: 'It seems you do not have permission to use this function, please contact the account admin.',
    },
    404: {
      title: 'OOPS!...404 Not Found',
      info: 'Please check that the URL you entered is correct, or click the button below to return to the homepage.',
      returnHome: 'Back to home',
      message: 'The webmaster said that you cannot enter this page...',
    },
    crash: {
      title: 'Something went wrong',
      info: 'This section failed to render. Retry or reload the page if the problem persists.',
    },
  },
  notification: {
    title: 'Notifications',
    noData: 'No notifications',
    noNewNotice: 'No new notifications',
    markRead: 'Mark all as read',
    col: {
      type: 'Type',
      subject: 'Subject',
      date: 'Date',
      operate: 'Operation',
    },
    markReadTip: 'Mark as read',
    markUnReadTip: 'Mark as unread',
    markAllReadTip: 'Mark all as read',
    loading: 'Loading notifications…',
    loadFailed: 'Failed to load notifications',
    retry: 'Retry',
  },
  status: {
    title: 'Status Page',
    statusPage: 'Status Page for {name}',
    statusByRegion: 'Status by {name} Region',
    allServicesOperational: 'All Services Operational',
    serviceComponents: 'Service Components',
    healthy: 'Healthy',
    unhealthy: 'Unhealthy',
    copyright: '© PhoenixAI {year}',
    services: {
      apiService: 'API Service',
      accountService: 'Account Service',
      clusterService: 'Cluster Service',
      billingService: 'Billing Service',
      editorService: 'Editor Service',
      monitorService: 'Monitor Service',
      cloudVendorService: 'Cloud Vendor Service',
    },
  },
  app: {
    title: 'Application keys',
    addSecret: 'New secret',
    tabs: {
      oauth: 'OAuth secrets',
    },
    oauth: {
      desc: 'Application keys allow you to create new identities (up to five per account member) below the current account member for external applications to integrate with your PhoenixAI Cloud account. OAuth secrets are a secure authentication method for external applications to integrate with the PhoenixAI Account API based on the application keys.',
      desc1: 'Learn more about how to use or manage an application key: {0}.',
      link1: 'Application keys',
      desc2: 'Learn more about {0}.',
      link2: 'PhoenixAI Cloud API',
      table: {
        client: 'Client ID',
        createAt: 'Created at',
      },
      modal: {
        create: {
          title: 'Generate secret for application key',
          desc: 'Description',
          descDesc: '(Option) Enter the description of this secret key for easier key management',
          descErr: 'Please keep the description length from 1-32',
          secret: 'Secret',
          client: 'Client ID',
          descText: 'You have successfully generated an OAuth key. Please ensure that you save the Secret & Client ID pair locally, as this is your only opportunity to view the secret key. If you misplace this key pair, you will need to generate a new one.',
          gen: 'Generate now',
          ok: 'Yes, I have finished it.',
        },
        delete: {
          title: 'Confirm to delete the Application secret key?',
          desc: 'This action cannot be undone. Confirm to delete the secret {0} ?',
        },
      },
    },
  },
  organization: {
    title: 'Organization',
    pageTitle: 'Account management',
    name: 'Organization name',
    id: 'Organization ID',
    multipleAccount: 'Multiple accounts',
    accountName: 'Account name',
    accountID: 'Account ID',
    desc: 'An organization is the parent object of an account. When you register an account, an organization will be automatically generated. Later, you can choose to create multiple accounts in this organization. User and cluster information in these accounts are isolated from each other. However, all subsequent fees and bills generated by the cluster will be uniformly viewed and paid in the current account. More details: {0}.',
    detailDoc: 'Overview of organizations and accounts',
    addAccount: '+ Create account',
    orgNameTip: 'The organization name is automatically generated based on the company name when the root account is registered for the first time. If you want to have a custom organization name, please contact our technical support.',
    createAccount: {
      title: 'Create account',
      desc: 'Define your account administrator\'s basic information for this account. Then you need to log in to the corresponding email address and complete the registration of the new account as the administrator.',
      form: {
        firstName: 'First name',
        firstNamePlaceholder: 'Enter the account user\'s first name',
        lastName: 'Last name',
        lastNamePlaceholder: 'Enter the account user\'s last name',
        businessEmail: 'Business email',
        businessEmailPlaceholder: 'Enter the account user\'s email address',
        registrationBtn: 'Start registration',
      },
      startRegistering: {
        title: 'Start registering the new account within the organization',
        desc: 'Check the registered email {0} and follow the instructions to complete the registration. The new account does not have permission to pay for resource usage or manage bills, as these can be done only by the root account of the organization to which the new account belongs.',
      },
    },
    editAccount: {
      title: 'Edit account name',
      newAccountName: 'New account name',
      accountNamePlaceholder: 'Enter the new account name',
      accountName: 'Account name',
    },
  },
  param: {
    tag: {
      desc: 'You can add {cspName} resource {tagName} to your {instanceName}, and other {cspName} resources, then you can manage your resources in different {tagName} categories on {cspName} console.',
      policyTooltip: 'This feature needs proper permissions to work well, but the deployment credential is outdated, and doesn\'t have all the needed permissions. Update the deployment credential to turn on the feature.',
      limitTip: 'Tag limit reached.',
      autoTag: 'Automatically added tags',
      autoTagDesc: 'These tags are added by the system, you can\'t change or delete them.',
      autoLabel: 'Automatically added labels',
      autoLabelDesc: 'These labels are added by the system, you can\'t change or delete them.',
      failedTitle: 'Insufficient Permissions',
      failedDesc1: 'The deployment credential currently lacks the necessary permissions to add or modify tag information. AWS has returned the following error: {0}',
      failedDesc2: 'Please consult the {0}, and update the policy associated with the deployment credential role through {1}.',
      failedDesc3: 'Once you have updated the policy, please return to and confirm this dialog, and try applying the tag modification again.',
      duplicateOverwriteContent: 'This {0} key is already used at the {1} level. Saving will overwrite the previous value. Do you want to proceed?',
      overrideTooltip: 'Overrides cluster value: {0}',
      overriddenByWarehouse: 'overridden by warehouse',
    },
  },
  components: {
    jsonDiff: {
      noChanges: 'No changes, you can click the update button directly.',
      previous: 'Previous',
      current: 'Current',
    },
    policyUpdateViewer: {
      confirmTitle: 'Confirm to update policy',
      confirmText: 'Regardless of whether you have actually updated the policy or not, the system will assume that you have completed the policy update once you press the confirm button.',
    },
    status: {
      details: 'Details',
      clusterScalingTitle: 'Cluster scaling processing - {percent}%',
      clusterRestoreTitle: 'Restoring cluster from snapshot - {percent}%',
      restoreSteps: {
        restoreSnapshot: {
          title: 'Restore from snapshot',
          subtitle: 'Restoring metadata from snapshot',
        },
        bringUpServices: {
          title: 'Bring up services',
          subtitle: 'Starting FE / BE services',
          subtitleElastic: 'Starting Coordinator / Compute services',
        },
        finalize: {
          title: 'Finalize',
          subtitle: 'Resuming warehouses',
        },
      },
      connectWithAccount: 'Connect with your Account',
      connectSucceeded: 'Connect succeeded',
      close: 'Close',
      stepNames: {
        applyConfiguration: 'Apply configuration',
        connectWithAccount: 'Connect with your Account',
        cleanUp: 'Clean up',
        releaseResources: 'Release Resources',
        terminateServices: 'Terminate Services',
        deployServices: 'Deploy services',
      },
      stepTips: {
        provisionInstances: 'Provision instances',
        deployServices: 'Deploy services',
        terminateServices: 'Terminate Services',
        terminateOldServices: 'Terminate old services',
      },
      aws: {
        stepTips: {
          releaseEC2Instances: 'Release the EC2 instance(s)',
          setupEC2: 'Setup EC2',
          launchEC2: 'Launch EC2',
        },
      },
      gcp: {
        stepTips: {
          releaseVMInstances: 'Release the virtual machine instance(s)',
          setupVM: 'Setup virtual machine instance',
          launchVM: 'Launch virtual machine instance',
        },
      },
      azure: {
        stepTips: {
          releaseVMInstances: 'Release the virtual machine instance(s)',
          setupVM: 'Setup virtual machine instance',
          launchVM: 'Launch virtual machine instance',
        },
      },
      upgradeProgressText: 'CN nodes {beDone}/{beTotal}, Coordinator nodes {feDone}/{feTotal}',
      upgradeProgressTextClassic: 'BE nodes {beDone}/{beTotal}, FE nodes {feDone}/{feTotal}',
      elasticRestartBEProgressText: 'Compute nodes {done}/{total}',
      elasticRestartFEProgressText: 'Coordinator nodes {done}/{total}',
      classicRestartBEProgressText: 'BE nodes {done}/{total}',
      classicRestartFEProgressText: 'FE nodes {done}/{total}',
    },
  },
};
